export const NEW_OCCUPATIONS = [
  {
    "code": "11-1011.00",
    "name": "Chief Executives",
    "description": "Determine and formulate policies and provide overall direction of companies or private and public sector organizations within guidelines set up by a board of directors or similar governing body. Plan, direct, or coordinate operational activities at the highest level of management with the help of subordinate executives and staff managers.",
    "hourlyIncome": 126,
    "annualIncome": 262930,
    "careerGrowth": 5.5,
    "jobZone": 5
  },
  {
    "code": "11-1011.03",
    "name": "Chief Sustainability Officers",
    "description": "Communicate and coordinate with management, shareholders, customers, and employees to address sustainability issues. Enact or oversee a corporate sustainability strategy.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "11-1021.00",
    "name": "General and Operations Managers",
    "description": "Plan, direct, or coordinate the operations of public or private sector organizations, overseeing multiple departments or locations. Duties and responsibilities include formulating policies, managing daily operations, and planning the use of materials and human resources, but are too diverse and general in nature to be classified in any one functional area of management or administration, such as personnel, purchasing, or administrative services. Usually manage through subordinate supervisors. Excludes First-Line Supervisors.",
    "hourlyIncome": 64,
    "annualIncome": 133120,
    "careerGrowth": 5.8,
    "jobZone": 4
  },
  {
    "code": "11-1031.00",
    "name": "Legislators",
    "description": "Develop, introduce, or enact laws and statutes at the local, tribal, state, or federal level. Includes only workers in elected positions.",
    "hourlyIncome": null,
    "annualIncome": 67390,
    "careerGrowth": 4.1,
    "jobZone": 4
  },
  {
    "code": "11-2011.00",
    "name": "Advertising and Promotions Managers",
    "description": "Plan, direct, or coordinate advertising policies and programs or produce collateral materials, such as posters, contests, coupons, or giveaways, to create extra interest in the purchase of a product or service for a department, an entire organization, or on an account basis.",
    "hourlyIncome": 72,
    "annualIncome": 149270,
    "careerGrowth": -2.6,
    "jobZone": 4
  },
  {
    "code": "11-2021.00",
    "name": "Marketing Managers",
    "description": "Plan, direct, or coordinate marketing policies and programs, such as determining the demand for products and services offered by a firm and its competitors, and identify potential customers. Develop pricing strategies with the goal of maximizing the firm's profits or share of the market while ensuring the firm's customers are satisfied. Oversee product development or monitor trends that indicate the need for new products and services.",
    "hourlyIncome": 82,
    "annualIncome": 171520,
    "careerGrowth": 8.2,
    "jobZone": 4
  },
  {
    "code": "11-2022.00",
    "name": "Sales Managers",
    "description": "Plan, direct, or coordinate the actual distribution or movement of a product or service to the customer. Coordinate sales distribution by establishing sales territories, quotas, and goals and establish training programs for sales representatives. Analyze sales statistics gathered by staff to determine sales potential and inventory requirements and monitor the preferences of customers.",
    "hourlyIncome": 77,
    "annualIncome": 160930,
    "careerGrowth": 5.9,
    "jobZone": 4
  },
  {
    "code": "11-2032.00",
    "name": "Public Relations Managers",
    "description": "Plan, direct, or coordinate activities designed to create or maintain a favorable public image or raise issue awareness for their organization or client.",
    "hourlyIncome": 79,
    "annualIncome": 163520,
    "careerGrowth": 6.9,
    "jobZone": 4
  },
  {
    "code": "11-2033.00",
    "name": "Fundraising Managers",
    "description": "Plan, direct, or coordinate activities to solicit and maintain funds for special projects or nonprofit organizations.",
    "hourlyIncome": 66,
    "annualIncome": 137290,
    "careerGrowth": 5.9,
    "jobZone": 4
  },
  {
    "code": "11-3012.00",
    "name": "Administrative Services Managers",
    "description": "Plan, direct, or coordinate one or more administrative services of an organization, such as records and information management, mail distribution, and other office support services.",
    "hourlyIncome": 61,
    "annualIncome": 126030,
    "careerGrowth": 6.2,
    "jobZone": 3
  },
  {
    "code": "11-3013.00",
    "name": "Facilities Managers",
    "description": "Plan, direct, or coordinate operations and functionalities of facilities and buildings. May include surrounding grounds or multiple facilities of an organization's campus.",
    "hourlyIncome": 55,
    "annualIncome": 114520,
    "careerGrowth": 5.3,
    "jobZone": 3
  },
  {
    "code": "11-3013.01",
    "name": "Security Managers",
    "description": "Direct an organization's security functions, including physical security and safety of employees and facilities.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-3021.00",
    "name": "Computer and Information Systems Managers",
    "description": "Plan, direct, or coordinate activities in such fields as electronic data processing, information systems, systems analysis, and computer programming.",
    "hourlyIncome": 90,
    "annualIncome": 187990,
    "careerGrowth": 17.4,
    "jobZone": 4
  },
  {
    "code": "11-3031.00",
    "name": "Financial Managers",
    "description": "Plan, direct, or coordinate accounting, investing, banking, insurance, securities, and other financial activities of a branch, office, or department of an establishment.",
    "hourlyIncome": 87,
    "annualIncome": 180470,
    "careerGrowth": 16.5,
    "jobZone": 4
  },
  {
    "code": "11-3031.01",
    "name": "Treasurers and Controllers",
    "description": "Direct financial activities, such as planning, procurement, and investments for all or part of an organization.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-3031.03",
    "name": "Investment Fund Managers",
    "description": "Plan, direct, or coordinate investment strategy or operations for a large pool of liquid assets supplied by institutional investors or individual investors.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "11-3051.00",
    "name": "Industrial Production Managers",
    "description": "Plan, direct, or coordinate the work activities and resources necessary for manufacturing products in accordance with cost, quality, and quantity specifications.",
    "hourlyIncome": 62,
    "annualIncome": 129180,
    "careerGrowth": 2.8,
    "jobZone": 4
  },
  {
    "code": "11-3051.01",
    "name": "Quality Control Systems Managers",
    "description": "Plan, direct, or coordinate quality assurance programs. Formulate quality control policies and control quality of laboratory and production efforts.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-3051.02",
    "name": "Geothermal Production Managers",
    "description": "Manage operations at geothermal power generation facilities. Maintain and monitor geothermal plant equipment for efficient and safe plant operations.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "11-3051.03",
    "name": "Biofuels Production Managers",
    "description": "Manage biofuels production and plant operations. Collect and process information on plant production and performance, diagnose problems, and design corrective procedures.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-3051.04",
    "name": "Biomass Power Plant Managers",
    "description": "Manage operations at biomass power generation facilities. Direct work activities at plant, including supervision of operations and maintenance staff.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-3051.06",
    "name": "Hydroelectric Production Managers",
    "description": "Manage operations at hydroelectric power generation facilities. Maintain and monitor hydroelectric plant equipment for efficient and safe plant operations.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "11-3061.00",
    "name": "Purchasing Managers",
    "description": "Plan, direct, or coordinate the activities of buyers, purchasing officers, and related workers involved in purchasing materials, products, and services. Includes wholesale or retail trade merchandising managers and procurement managers.",
    "hourlyIncome": 72,
    "annualIncome": 150630,
    "careerGrowth": 5.1,
    "jobZone": 4
  },
  {
    "code": "11-3071.00",
    "name": "Transportation, Storage, and Distribution Managers",
    "description": "Plan, direct, or coordinate transportation, storage, or distribution activities in accordance with organizational policies and applicable government laws or regulations. Includes logistics managers.",
    "hourlyIncome": 56,
    "annualIncome": 116010,
    "careerGrowth": 9,
    "jobZone": 4
  },
  {
    "code": "11-3071.04",
    "name": "Supply Chain Managers",
    "description": "Direct or coordinate production, purchasing, warehousing, distribution, or financial forecasting services or activities to limit costs and improve accuracy, customer service, or safety. Examine existing procedures or opportunities for streamlining activities to meet product distribution needs. Direct the movement, storage, or processing of inventory.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-3111.00",
    "name": "Compensation and Benefits Managers",
    "description": "Plan, direct, or coordinate compensation and benefits activities of an organization.",
    "hourlyIncome": 75,
    "annualIncome": 156230,
    "careerGrowth": 2.1,
    "jobZone": 4
  },
  {
    "code": "11-3121.00",
    "name": "Human Resources Managers",
    "description": "Plan, direct, or coordinate human resources activities and staff of an organization.",
    "hourlyIncome": 77,
    "annualIncome": 160480,
    "careerGrowth": 6.5,
    "jobZone": 4
  },
  {
    "code": "11-3131.00",
    "name": "Training and Development Managers",
    "description": "Plan, direct, or coordinate the training and development activities and staff of an organization.",
    "hourlyIncome": 68,
    "annualIncome": 140590,
    "careerGrowth": 7.3,
    "jobZone": 4
  },
  {
    "code": "11-9013.00",
    "name": "Farmers, Ranchers, and Other Agricultural Managers",
    "description": "Plan, direct, or coordinate the management or operation of farms, ranches, greenhouses, aquacultural operations, nurseries, timber tracts, or other agricultural establishments. May hire, train, and supervise farm workers or contract for services to carry out the day-to-day activities of the managed operation. May engage in or supervise planting, cultivating, harvesting, and financial and marketing activities.",
    "hourlyIncome": 47,
    "annualIncome": 97240,
    "careerGrowth": -1.6,
    "jobZone": 4
  },
  {
    "code": "11-9021.00",
    "name": "Construction Managers",
    "description": "Plan, direct, or coordinate, usually through subordinate supervisory personnel, activities concerned with the construction and maintenance of structures, facilities, and systems. Participate in the conceptual development of a construction project and oversee its organization, scheduling, budgeting, and implementation. Includes managers in specialized construction fields, such as carpentry or plumbing.",
    "hourlyIncome": 58,
    "annualIncome": 119660,
    "careerGrowth": 9.1,
    "jobZone": 4
  },
  {
    "code": "11-9031.00",
    "name": "Education and Childcare Administrators, Preschool and Daycare",
    "description": "Plan, direct, or coordinate academic or nonacademic activities of preschools or childcare centers and programs, including before- and after-school care.",
    "hourlyIncome": 30,
    "annualIncome": 62640,
    "careerGrowth": -2.1,
    "jobZone": 4
  },
  {
    "code": "11-9032.00",
    "name": "Education Administrators, Kindergarten through Secondary",
    "description": "Plan, direct, or coordinate the academic, administrative, or auxiliary activities of kindergarten, elementary, or secondary schools.",
    "hourlyIncome": null,
    "annualIncome": 113360,
    "careerGrowth": -0.5,
    "jobZone": 5
  },
  {
    "code": "11-9033.00",
    "name": "Education Administrators, Postsecondary",
    "description": "Plan, direct, or coordinate student instruction, administration, and services, as well as other research and educational activities, at postsecondary institutions, including universities, colleges, and junior and community colleges.",
    "hourlyIncome": 60,
    "annualIncome": 124450,
    "careerGrowth": 2.9,
    "jobZone": 5
  },
  {
    "code": "11-9039.00",
    "name": "Education Administrators, All Other",
    "description": "All education administrators not listed separately.",
    "hourlyIncome": 48,
    "annualIncome": 99460,
    "careerGrowth": 2.5,
    "jobZone": null
  },
  {
    "code": "11-9041.00",
    "name": "Architectural and Engineering Managers",
    "description": "Plan, direct, or coordinate activities in such fields as architecture and engineering or research and development in these fields.",
    "hourlyIncome": 84,
    "annualIncome": 175710,
    "careerGrowth": 5.5,
    "jobZone": 5
  },
  {
    "code": "11-9041.01",
    "name": "Biofuels/Biodiesel Technology and Product Development Managers",
    "description": "Define, plan, or execute biofuels/biodiesel research programs that evaluate alternative feedstock and process technologies with near-term commercial potential.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-9051.00",
    "name": "Food Service Managers",
    "description": "Plan, direct, or coordinate activities of an organization or department that serves food and beverages.",
    "hourlyIncome": 35,
    "annualIncome": 72370,
    "careerGrowth": 1.5,
    "jobZone": 2
  },
  {
    "code": "11-9071.00",
    "name": "Gambling Managers",
    "description": "Plan, direct, or coordinate gambling operations in a casino. May formulate house rules.",
    "hourlyIncome": 49,
    "annualIncome": 102480,
    "careerGrowth": 5.1,
    "jobZone": 2
  },
  {
    "code": "11-9072.00",
    "name": "Entertainment and Recreation Managers, Except Gambling",
    "description": "Plan, direct, or coordinate entertainment and recreational activities and operations of a recreational facility, including cruise ships and parks.",
    "hourlyIncome": 42,
    "annualIncome": 87060,
    "careerGrowth": 10.8,
    "jobZone": 4
  },
  {
    "code": "11-9081.00",
    "name": "Lodging Managers",
    "description": "Plan, direct, or coordinate activities of an organization or department that provides lodging and other accommodations.",
    "hourlyIncome": 37,
    "annualIncome": 77460,
    "careerGrowth": 9.9,
    "jobZone": 4
  },
  {
    "code": "11-9111.00",
    "name": "Medical and Health Services Managers",
    "description": "Plan, direct, or coordinate medical and health services in hospitals, clinics, managed care organizations, public health agencies, or similar organizations.",
    "hourlyIncome": 66,
    "annualIncome": 137730,
    "careerGrowth": 28.5,
    "jobZone": 4
  },
  {
    "code": "11-9121.00",
    "name": "Natural Sciences Managers",
    "description": "Plan, direct, or coordinate activities in such fields as life sciences, physical sciences, mathematics, statistics, and research and development in these fields.",
    "hourlyIncome": 83,
    "annualIncome": 173500,
    "careerGrowth": 7.5,
    "jobZone": 5
  },
  {
    "code": "11-9121.01",
    "name": "Clinical Research Coordinators",
    "description": "Plan, direct, or coordinate clinical research projects. Direct the activities of workers engaged in clinical research projects to ensure compliance with protocols and overall clinical objectives. May evaluate and analyze clinical data.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-9121.02",
    "name": "Water Resource Specialists",
    "description": "Design or implement programs and strategies related to water resource issues such as supply, quality, and regulatory compliance issues.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-9131.00",
    "name": "Postmasters and Mail Superintendents",
    "description": "Plan, direct, or coordinate operational, administrative, management, and support services of a U.S. post office; or coordinate activities of workers engaged in postal and related work in assigned post office.",
    "hourlyIncome": 45,
    "annualIncome": 93760,
    "careerGrowth": -3,
    "jobZone": 2
  },
  {
    "code": "11-9141.00",
    "name": "Property, Real Estate, and Community Association Managers",
    "description": "Plan, direct, or coordinate the selling, buying, leasing, or governance activities of commercial, industrial, or residential real estate properties. Includes managers of homeowner and condominium associations, rented or leased housing units, buildings, or land (including rights-of-way).",
    "hourlyIncome": 40,
    "annualIncome": 82720,
    "careerGrowth": 3.2,
    "jobZone": 4
  },
  {
    "code": "11-9151.00",
    "name": "Social and Community Service Managers",
    "description": "Plan, direct, or coordinate the activities of a social service program or community outreach organization. Oversee the program or organization's budget and policies regarding participant involvement, program requirements, and benefits. Work may involve directing social workers, counselors, or probation officers.",
    "hourlyIncome": 41,
    "annualIncome": 86100,
    "careerGrowth": 8.2,
    "jobZone": 4
  },
  {
    "code": "11-9161.00",
    "name": "Emergency Management Directors",
    "description": "Plan and direct disaster response or crisis management activities, provide disaster preparedness training, and prepare emergency plans and procedures for natural (e.g., hurricanes, floods, earthquakes), wartime, or technological (e.g., nuclear power plant emergencies or hazardous materials spills) disasters or hostage situations.",
    "hourlyIncome": 47,
    "annualIncome": 97700,
    "careerGrowth": 4,
    "jobZone": 4
  },
  {
    "code": "11-9171.00",
    "name": "Funeral Home Managers",
    "description": "Plan, direct, or coordinate the services or resources of funeral homes. Includes activities such as determining prices for services or merchandise and managing the facilities of funeral homes.",
    "hourlyIncome": 41,
    "annualIncome": 85650,
    "careerGrowth": 4.5,
    "jobZone": 3
  },
  {
    "code": "11-9179.00",
    "name": "Personal Service Managers, All Other",
    "description": "All personal service managers not listed separately.",
    "hourlyIncome": 34,
    "annualIncome": 70620,
    "careerGrowth": 6.9,
    "jobZone": null
  },
  {
    "code": "11-9179.01",
    "name": "Fitness and Wellness Coordinators",
    "description": "Manage or coordinate fitness and wellness programs and services. Manage and train staff of wellness specialists, health educators, or fitness instructors.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-9179.02",
    "name": "Spa Managers",
    "description": "Plan, direct, or coordinate activities of a spa facility. Coordinate programs, schedule and direct staff, and oversee financial activities.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "11-9199.00",
    "name": "Managers, All Other",
    "description": "All managers not listed separately.",
    "hourlyIncome": 72,
    "annualIncome": 149890,
    "careerGrowth": 5.7,
    "jobZone": null
  },
  {
    "code": "11-9199.01",
    "name": "Regulatory Affairs Managers",
    "description": "Plan, direct, or coordinate production activities of an organization to ensure compliance with regulations and standard operating procedures.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-9199.02",
    "name": "Compliance Managers",
    "description": "Plan, direct, or coordinate activities of an organization to ensure compliance with ethical or regulatory standards.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-9199.08",
    "name": "Loss Prevention Managers",
    "description": "Plan and direct policies, procedures, or systems to prevent the loss of assets. Determine risk exposure or potential liability, and develop risk control measures.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-9199.09",
    "name": "Wind Energy Operations Managers",
    "description": "Manage wind field operations, including personnel, maintenance activities, financial activities, and planning.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "11-9199.10",
    "name": "Wind Energy Development Managers",
    "description": "Lead or manage the development and evaluation of potential wind energy business opportunities, including environmental studies, permitting, and proposals. May also manage construction of projects.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "11-9199.11",
    "name": "Brownfield Redevelopment Specialists and Site Managers",
    "description": "Plan and direct cleanup and redevelopment of contaminated properties for reuse. Does not include properties sufficiently contaminated to qualify as Superfund sites.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1011.00",
    "name": "Agents and Business Managers of Artists, Performers, and Athletes",
    "description": "Represent and promote artists, performers, and athletes in dealings with current or prospective employers. May handle contract negotiation and other business matters for clients.",
    "hourlyIncome": 80,
    "annualIncome": 165600,
    "careerGrowth": 9.2,
    "jobZone": 4
  },
  {
    "code": "13-1021.00",
    "name": "Buyers and Purchasing Agents, Farm Products",
    "description": "Purchase farm products either for further processing or resale. Includes tree farm contractors, grain brokers and market operators, grain buyers, and tobacco buyers. May negotiate contracts.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1022.00",
    "name": "Wholesale and Retail Buyers, Except Farm Products",
    "description": "Buy merchandise or commodities, other than farm products, for resale to consumers at the wholesale or retail level, including both durable and nondurable goods. Analyze past buying trends, sales records, price, and quality of merchandise to determine value and yield. Select, order, and authorize payment for merchandise according to contractual agreements. May conduct meetings with sales personnel and introduce new products. May negotiate contracts. Includes assistant wholesale and retail buyers of nonfarm products.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "13-1023.00",
    "name": "Purchasing Agents, Except Wholesale, Retail, and Farm Products",
    "description": "Purchase machinery, equipment, tools, parts, supplies, or services necessary for the operation of an establishment. Purchase raw or semifinished materials for manufacturing. May negotiate contracts.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1031.00",
    "name": "Claims Adjusters, Examiners, and Investigators",
    "description": "Review settled claims to determine that payments and settlements are made in accordance with company practices and procedures. Confer with legal counsel on claims requiring litigation. May also settle insurance claims.",
    "hourlyIncome": 38,
    "annualIncome": 78770,
    "careerGrowth": -4.4,
    "jobZone": 4
  },
  {
    "code": "13-1032.00",
    "name": "Insurance Appraisers, Auto Damage",
    "description": "Appraise automobile or other vehicle damage to determine repair costs for insurance claim settlement. Prepare insurance forms to indicate repair cost or cost estimates and recommendations. May seek agreement with automotive repair shop on repair costs.",
    "hourlyIncome": 37,
    "annualIncome": 77050,
    "careerGrowth": -9.2,
    "jobZone": 3
  },
  {
    "code": "13-1041.00",
    "name": "Compliance Officers",
    "description": "Examine, evaluate, and investigate eligibility for or conformity with laws and regulations governing contract compliance of licenses and permits, and perform other compliance and enforcement inspection and analysis activities not classified elsewhere.",
    "hourlyIncome": 41,
    "annualIncome": 84980,
    "careerGrowth": 5.4,
    "jobZone": 4
  },
  {
    "code": "13-1041.01",
    "name": "Environmental Compliance Inspectors",
    "description": "Inspect and investigate sources of pollution to protect the public and environment and ensure conformance with Federal, State, and local regulations and ordinances.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1041.03",
    "name": "Equal Opportunity Representatives and Officers",
    "description": "Monitor and evaluate compliance with equal opportunity laws, guidelines, and policies to ensure that employment practices and contracting arrangements give equal opportunity without regard to race, religion, color, national origin, sex, age, or disability.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1041.04",
    "name": "Government Property Inspectors and Investigators",
    "description": "Investigate or inspect government property to ensure compliance with contract agreements and government regulations.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "13-1041.06",
    "name": "Coroners",
    "description": "Direct activities such as autopsies, pathological and toxicological analyses, and inquests relating to the investigation of deaths occurring within a legal jurisdiction to determine cause of death or to fix responsibility for accidental, violent, or unexplained deaths.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "13-1041.07",
    "name": "Regulatory Affairs Specialists",
    "description": "Coordinate and document internal regulatory processes, such as internal audits, inspections, license renewals, or registrations. May compile and prepare materials for submission to regulatory agencies.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1041.08",
    "name": "Customs Brokers",
    "description": "Prepare customs documentation and ensure that shipments meet all applicable laws to facilitate the import and export of goods. Determine and track duties and taxes payable and process payments on behalf of client. Sign documents under a power of attorney. Represent clients in meetings with customs officials and apply for duty refunds and tariff reclassifications. Coordinate transportation and storage of imported goods.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "13-1051.00",
    "name": "Cost Estimators",
    "description": "Prepare cost estimates for product manufacturing, construction projects, or services to aid management in bidding on or determining price of product or service. May specialize according to particular service performed or type of product manufactured.",
    "hourlyIncome": 40,
    "annualIncome": 83160,
    "careerGrowth": -3.6,
    "jobZone": 4
  },
  {
    "code": "13-1071.00",
    "name": "Human Resources Specialists",
    "description": "Recruit, screen, interview, or place individuals within an organization. May perform other activities in multiple human resources areas.",
    "hourlyIncome": 38,
    "annualIncome": 79730,
    "careerGrowth": 7.9,
    "jobZone": 4
  },
  {
    "code": "13-1074.00",
    "name": "Farm Labor Contractors",
    "description": "Recruit and hire seasonal or temporary agricultural laborers. May transport, house, and provide meals for workers.",
    "hourlyIncome": 25,
    "annualIncome": 51910,
    "careerGrowth": 6.6,
    "jobZone": 2
  },
  {
    "code": "13-1075.00",
    "name": "Labor Relations Specialists",
    "description": "Resolve disputes between workers and managers, negotiate collective bargaining agreements, or coordinate grievance procedures to handle employee complaints.",
    "hourlyIncome": 47,
    "annualIncome": 97130,
    "careerGrowth": -0.3,
    "jobZone": 4
  },
  {
    "code": "13-1081.00",
    "name": "Logisticians",
    "description": "Analyze and coordinate the ongoing logistical functions of a firm or organization. Responsible for the entire life cycle of a product, including acquisition, distribution, internal allocation, delivery, and final disposal of resources.",
    "hourlyIncome": 42,
    "annualIncome": 87600,
    "careerGrowth": 19.3,
    "jobZone": 4
  },
  {
    "code": "13-1081.01",
    "name": "Logistics Engineers",
    "description": "Design or analyze operational solutions for projects such as transportation optimization, network modeling, process and methods analysis, cost containment, capacity enhancement, routing and shipment optimization, or information management.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1081.02",
    "name": "Logistics Analysts",
    "description": "Analyze product delivery or supply chain processes to identify or recommend changes. May manage route activity including invoicing, electronic bills, and shipment tracing.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1082.00",
    "name": "Project Management Specialists",
    "description": "Analyze and coordinate the schedule, timeline, procurement, staffing, and budget of a product or service on a per project basis. Lead and guide the work of technical staff. May serve as a point of contact for the client or customer.",
    "hourlyIncome": 52,
    "annualIncome": 108100,
    "careerGrowth": 7.2,
    "jobZone": 4
  },
  {
    "code": "13-1111.00",
    "name": "Management Analysts",
    "description": "Conduct organizational studies and evaluations, design systems and procedures, conduct work simplification and measurement studies, and prepare operations and procedures manuals to assist management in operating more efficiently and effectively. Includes program analysts and management consultants.",
    "hourlyIncome": 55,
    "annualIncome": 114710,
    "careerGrowth": 10.6,
    "jobZone": 4
  },
  {
    "code": "13-1121.00",
    "name": "Meeting, Convention, and Event Planners",
    "description": "Coordinate activities of staff, convention personnel, or clients to make arrangements for group meetings, events, or conventions.",
    "hourlyIncome": 31,
    "annualIncome": 65090,
    "careerGrowth": 6.6,
    "jobZone": 4
  },
  {
    "code": "13-1131.00",
    "name": "Fundraisers",
    "description": "Organize activities to raise funds or otherwise solicit and gather monetary donations or other gifts for an organization. May design and produce promotional materials. May also raise awareness of the organization's work, goals, and financial needs.",
    "hourlyIncome": 35,
    "annualIncome": 73130,
    "careerGrowth": 5.9,
    "jobZone": 4
  },
  {
    "code": "13-1141.00",
    "name": "Compensation, Benefits, and Job Analysis Specialists",
    "description": "Conduct programs of compensation and benefits and job analysis for employer. May specialize in specific areas, such as position classification and pension programs.",
    "hourlyIncome": 40,
    "annualIncome": 82920,
    "careerGrowth": 7,
    "jobZone": 4
  },
  {
    "code": "13-1151.00",
    "name": "Training and Development Specialists",
    "description": "Design or conduct work-related training and development programs to improve individual skills or organizational performance. May analyze organizational training needs or evaluate training effectiveness.",
    "hourlyIncome": 35,
    "annualIncome": 73760,
    "careerGrowth": 11.5,
    "jobZone": 4
  },
  {
    "code": "13-1161.00",
    "name": "Market Research Analysts and Marketing Specialists",
    "description": "Research conditions in local, regional, national, or online markets. Gather information to determine potential sales of a product or service, or plan a marketing or advertising campaign. May gather information on competitors, prices, sales, and methods of marketing and distribution. May employ search marketing tactics, analyze web metrics, and develop recommendations to increase search engine ranking and visibility to target markets.",
    "hourlyIncome": 42,
    "annualIncome": 86480,
    "careerGrowth": 8.3,
    "jobZone": 4
  },
  {
    "code": "13-1161.01",
    "name": "Search Marketing Strategists",
    "description": "Employ search marketing tactics to increase visibility and engagement with content, products, or services in Internet-enabled devices or interfaces. Examine search query behaviors on general or specialty search engines or other Internet-based content. Analyze research, data, or technology to understand user intent and measure outcomes for ongoing optimization.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1199.00",
    "name": "Business Operations Specialists, All Other",
    "description": "All business operations specialists not listed separately.",
    "hourlyIncome": 44,
    "annualIncome": 92380,
    "careerGrowth": 5.4,
    "jobZone": null
  },
  {
    "code": "13-1199.04",
    "name": "Business Continuity Planners",
    "description": "Develop, maintain, or implement business continuity and disaster recovery strategies and solutions, including risk assessments, business impact analyses, strategy selection, and documentation of business continuity and disaster recovery procedures. Plan, conduct, and debrief regular mock-disaster exercises to test the adequacy of existing plans and strategies, updating procedures and plans regularly. Act as a coordinator for continuity efforts after a disruption event.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1199.05",
    "name": "Sustainability Specialists",
    "description": "Address organizational sustainability issues, such as waste stream management, green building practices, and green procurement plans.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1199.06",
    "name": "Online Merchants",
    "description": "Conduct retail activities of businesses operating exclusively online. May perform duties such as preparing business strategies, buying merchandise, managing inventory, implementing marketing activities, fulfilling and shipping online orders, and balancing financial records.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-1199.07",
    "name": "Security Management Specialists",
    "description": "Conduct security assessments for organizations, and design security systems and processes. May specialize in areas such as physical security or the safety of employees and facilities.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-2011.00",
    "name": "Accountants and Auditors",
    "description": "Examine, analyze, and interpret accounting records to prepare financial statements, give advice, or audit and evaluate statements prepared by others. Install or advise on systems of recording costs or other financial and budgetary data.",
    "hourlyIncome": 45,
    "annualIncome": 93520,
    "careerGrowth": 5.8,
    "jobZone": 4
  },
  {
    "code": "13-2022.00",
    "name": "Appraisers of Personal and Business Property",
    "description": "Appraise and estimate the fair value of tangible personal or business property, such as jewelry, art, antiques, collectibles, and equipment. May also appraise land.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-2023.00",
    "name": "Appraisers and Assessors of Real Estate",
    "description": "Appraise real estate, exclusively, and estimate its fair value. May assess taxes in accordance with prescribed schedules.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "13-2031.00",
    "name": "Budget Analysts",
    "description": "Examine budget estimates for completeness, accuracy, and conformance with procedures and regulations. Analyze budgeting and accounting reports.",
    "hourlyIncome": 45,
    "annualIncome": 93920,
    "careerGrowth": 3.9,
    "jobZone": 4
  },
  {
    "code": "13-2041.00",
    "name": "Credit Analysts",
    "description": "Analyze credit data and financial statements of individuals or firms to determine the degree of risk involved in extending credit or lending money. Prepare reports with credit information for use in decisionmaking.",
    "hourlyIncome": 47,
    "annualIncome": 98040,
    "careerGrowth": -3.9,
    "jobZone": 4
  },
  {
    "code": "13-2051.00",
    "name": "Financial and Investment Analysts",
    "description": "Conduct quantitative analyses of information involving investment programs or financial data of public or private institutions, including valuation of businesses.",
    "hourlyIncome": 56,
    "annualIncome": 116490,
    "careerGrowth": 9.5,
    "jobZone": 4
  },
  {
    "code": "13-2052.00",
    "name": "Personal Financial Advisors",
    "description": "Advise clients on financial plans using knowledge of tax and investment strategies, securities, insurance, pension plans, and real estate. Duties include assessing clients' assets, liabilities, cash flow, insurance coverage, tax status, and financial objectives. May also buy and sell financial assets for clients.",
    "hourlyIncome": 77,
    "annualIncome": 160210,
    "careerGrowth": 17.1,
    "jobZone": 4
  },
  {
    "code": "13-2053.00",
    "name": "Insurance Underwriters",
    "description": "Review individual applications for insurance to evaluate degree of risk involved and determine acceptance of applications.",
    "hourlyIncome": 44,
    "annualIncome": 90830,
    "careerGrowth": -4,
    "jobZone": 4
  },
  {
    "code": "13-2054.00",
    "name": "Financial Risk Specialists",
    "description": "Analyze and measure exposure to credit and market risk threatening the assets, earning capacity, or economic state of an organization. May make recommendations to limit risk.",
    "hourlyIncome": 58,
    "annualIncome": 119930,
    "careerGrowth": 8.4,
    "jobZone": 4
  },
  {
    "code": "13-2061.00",
    "name": "Financial Examiners",
    "description": "Enforce or ensure compliance with laws and regulations governing financial and securities institutions and financial and real estate transactions. May examine, verify, or authenticate records.",
    "hourlyIncome": 50,
    "annualIncome": 103650,
    "careerGrowth": 21,
    "jobZone": 4
  },
  {
    "code": "13-2071.00",
    "name": "Credit Counselors",
    "description": "Advise and educate individuals or organizations on acquiring and managing debt. May provide guidance in determining the best type of loan and explain loan requirements or restrictions. May help develop debt management plans or student financial aid packages. May advise on credit issues, or provide budget, mortgage, bankruptcy, or student financial aid counseling.",
    "hourlyIncome": 27,
    "annualIncome": 55890,
    "careerGrowth": 4.9,
    "jobZone": 4
  },
  {
    "code": "13-2072.00",
    "name": "Loan Officers",
    "description": "Evaluate, authorize, or recommend approval of commercial, real estate, or credit loans. Advise borrowers on financial status and payment methods. Includes mortgage loan officers and agents, collection analysts, loan servicing officers, loan underwriters, and payday loan officers.",
    "hourlyIncome": 41,
    "annualIncome": 86020,
    "careerGrowth": 1.4,
    "jobZone": 4
  },
  {
    "code": "13-2081.00",
    "name": "Tax Examiners and Collectors, and Revenue Agents",
    "description": "Determine tax liability or collect taxes from individuals or business firms according to prescribed laws and regulations.",
    "hourlyIncome": 32,
    "annualIncome": 67570,
    "careerGrowth": 1.9,
    "jobZone": 3
  },
  {
    "code": "13-2082.00",
    "name": "Tax Preparers",
    "description": "Prepare tax returns for individuals or small businesses.",
    "hourlyIncome": 28,
    "annualIncome": 58860,
    "careerGrowth": 4.2,
    "jobZone": 3
  },
  {
    "code": "13-2099.00",
    "name": "Financial Specialists, All Other",
    "description": "All financial specialists not listed separately.",
    "hourlyIncome": 45,
    "annualIncome": 93890,
    "careerGrowth": 6.2,
    "jobZone": null
  },
  {
    "code": "13-2099.01",
    "name": "Financial Quantitative Analysts",
    "description": "Develop quantitative techniques to inform securities investing, equities investing, pricing, or valuation of financial instruments. Develop mathematical or statistical models for risk management, asset optimization, pricing, or relative value analysis.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "13-2099.04",
    "name": "Fraud Examiners, Investigators and Analysts",
    "description": "Obtain evidence, take statements, produce reports, and testify to findings regarding resolution of fraud allegations. May coordinate fraud detection and prevention activities.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-1211.00",
    "name": "Computer Systems Analysts",
    "description": "Analyze science, engineering, business, and other data processing problems to develop and implement solutions to complex applications problems, system administration issues, or network concerns. Perform systems management and integration functions, improve existing computer systems, and review computer system capabilities, workflow, and schedule limitations. May analyze or recommend commercially available software.",
    "hourlyIncome": 54,
    "annualIncome": 111960,
    "careerGrowth": 10.7,
    "jobZone": 3
  },
  {
    "code": "15-1211.01",
    "name": "Health Informatics Specialists",
    "description": "Apply knowledge of nursing and informatics to assist in the design, development, and ongoing modification of computerized health care systems. May educate staff and assist in problem solving to promote the implementation of the health care system.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "15-1212.00",
    "name": "Information Security Analysts",
    "description": "Plan, implement, upgrade, or monitor security measures for the protection of computer networks and information. Assess system vulnerabilities for security risks and propose and implement risk mitigation strategies. May ensure appropriate security controls are in place that will safeguard digital files and vital electronic infrastructure. May respond to computer security breaches and viruses.",
    "hourlyIncome": 61,
    "annualIncome": 127730,
    "careerGrowth": 32.7,
    "jobZone": 4
  },
  {
    "code": "15-1221.00",
    "name": "Computer and Information Research Scientists",
    "description": "Conduct research into fundamental computer and information science as theorists, designers, or inventors. Develop solutions to problems in the field of computer hardware and software.",
    "hourlyIncome": 73,
    "annualIncome": 152310,
    "careerGrowth": 25.6,
    "jobZone": 5
  },
  {
    "code": "15-1231.00",
    "name": "Computer Network Support Specialists",
    "description": "Analyze, test, troubleshoot, and evaluate existing network systems, such as local area networks (LAN), wide area networks (WAN), cloud networks, servers, and other data communications networks. Perform network maintenance to ensure networks operate correctly with minimal interruption.",
    "hourlyIncome": 38,
    "annualIncome": 79610,
    "careerGrowth": 7.3,
    "jobZone": 4
  },
  {
    "code": "15-1232.00",
    "name": "Computer User Support Specialists",
    "description": "Provide technical assistance to computer users. Answer questions or resolve computer problems for clients in person, via telephone, or electronically. May provide assistance concerning the use of computer hardware and software, including printing, installation, word processing, electronic mail, and operating systems.",
    "hourlyIncome": 31,
    "annualIncome": 64990,
    "careerGrowth": 5.1,
    "jobZone": 3
  },
  {
    "code": "15-1241.00",
    "name": "Computer Network Architects",
    "description": "Design and implement computer and information networks, such as local area networks (LAN), wide area networks (WAN), intranets, extranets, and other data communications networks. Perform network modeling, analysis, and planning, including analysis of capacity needs for network infrastructures. May also design network and computer security measures. May research and recommend network and data communications hardware and software.",
    "hourlyIncome": 65,
    "annualIncome": 135890,
    "careerGrowth": 13.4,
    "jobZone": 4
  },
  {
    "code": "15-1241.01",
    "name": "Telecommunications Engineering Specialists",
    "description": "Design or configure wired, wireless, and satellite communications systems for voice, video, and data services. Supervise installation, service, and maintenance.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "15-1242.00",
    "name": "Database Administrators",
    "description": "Administer, test, and implement computer databases, applying knowledge of database management systems. Coordinate changes to computer databases. Identify, investigate, and resolve database performance issues, database capacity, and database scalability. May plan, coordinate, and implement security measures to safeguard computer databases.",
    "hourlyIncome": 52,
    "annualIncome": 107440,
    "careerGrowth": 8.2,
    "jobZone": 4
  },
  {
    "code": "15-1243.00",
    "name": "Database Architects",
    "description": "Design strategies for enterprise databases, data warehouse systems, and multidimensional networks. Set standards for database operations, programming, query processes, and security. Model, design, and construct large relational databases or data warehouses. Create and optimize data models for warehouse infrastructure and workflow. Integrate new systems with existing warehouse structure and refine system performance and functionality.",
    "hourlyIncome": 69,
    "annualIncome": 142620,
    "careerGrowth": 10.8,
    "jobZone": 4
  },
  {
    "code": "15-1243.01",
    "name": "Data Warehousing Specialists",
    "description": "Design, model, or implement corporate data warehousing activities. Program and configure warehouses of database information and provide support to warehouse users.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-1244.00",
    "name": "Network and Computer Systems Administrators",
    "description": "Install, configure, and maintain an organization's local area network (LAN), wide area network (WAN), data communications network, operating systems, and physical and virtual servers. Perform system monitoring and verify the integrity and availability of hardware, network, and server resources and systems. Review system and application logs and verify completion of scheduled jobs, including system backups. Analyze network and server resource consumption and control user access. Install and upgrade software and maintain software licenses. May assist in network modeling, analysis, planning, and coordination between network and data communications hardware and software.",
    "hourlyIncome": 49,
    "annualIncome": 101190,
    "careerGrowth": -2.6,
    "jobZone": 4
  },
  {
    "code": "15-1251.00",
    "name": "Computer Programmers",
    "description": "Create, modify, and test the code and scripts that allow computer applications to run. Work from specifications drawn up by software and web developers or other individuals. May develop and write computer programs to store, locate, and retrieve specific documents, data, and information.",
    "hourlyIncome": 50,
    "annualIncome": 103640,
    "careerGrowth": -9.6,
    "jobZone": 4
  },
  {
    "code": "15-1252.00",
    "name": "Software Developers",
    "description": "Research, design, and develop computer and network software or specialized utility programs. Analyze user needs and develop software solutions, applying principles and techniques of computer science, engineering, and mathematical analysis. Update software or enhance existing software capabilities. May work with computer hardware engineers to integrate hardware and software systems, and develop specifications and performance requirements. May maintain databases within an application area, working individually or coordinating database development as part of a team.",
    "hourlyIncome": 70,
    "annualIncome": 144570,
    "careerGrowth": 17.9,
    "jobZone": 4
  },
  {
    "code": "15-1253.00",
    "name": "Software Quality Assurance Analysts and Testers",
    "description": "Develop and execute software tests to identify software problems and their causes. Test system modifications to prepare for implementation. Document software and application defects using a bug tracking system and report defects to software or web developers. Create and maintain databases of known defects. May participate in software design reviews to provide input on functional requirements, operational characteristics, product designs, and schedules.",
    "hourlyIncome": 53,
    "annualIncome": 110260,
    "careerGrowth": 11.8,
    "jobZone": 4
  },
  {
    "code": "15-1254.00",
    "name": "Web Developers",
    "description": "Develop and implement websites, web applications, application databases, and interactive web interfaces. Evaluate code to ensure that it is properly structured, meets industry standards, and is compatible with browsers and devices. Optimize website performance, scalability, and server-side code and processes. May develop website infrastructure and integrate websites with other computer applications.",
    "hourlyIncome": 48,
    "annualIncome": 98790,
    "careerGrowth": 9,
    "jobZone": 3
  },
  {
    "code": "15-1255.00",
    "name": "Web and Digital Interface Designers",
    "description": "Design digital user interfaces or websites. Develop and test layouts, interfaces, functionality, and navigation menus to ensure compatibility and usability across browsers or devices. May use web framework applications as well as client-side code and processes. May evaluate web design following web and accessibility standards, and may analyze web use metrics and optimize websites for marketability and search engine ranking. May design and test interfaces that facilitate the human-computer interaction and maximize the usability of digital devices, websites, and software with a focus on aesthetics and design. May create graphics used in websites and manage website content and links.",
    "hourlyIncome": 54,
    "annualIncome": 111450,
    "careerGrowth": 7.9,
    "jobZone": 4
  },
  {
    "code": "15-1255.01",
    "name": "Video Game Designers",
    "description": "Design core features of video games. Specify innovative game and role-play mechanics, story lines, and character biographies. Create and maintain design documentation. Guide and collaborate with production staff to produce games as designed.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-1299.00",
    "name": "Computer Occupations, All Other",
    "description": "All computer occupations not listed separately.",
    "hourlyIncome": 56,
    "annualIncome": 116700,
    "careerGrowth": 10.8,
    "jobZone": null
  },
  {
    "code": "15-1299.01",
    "name": "Web Administrators",
    "description": "Manage web environment design, deployment, development and maintenance activities. Perform testing and quality assurance of web sites and web applications.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-1299.02",
    "name": "Geographic Information Systems Technologists and Technicians",
    "description": "Assist scientists or related professionals in building, maintaining, modifying, or using geographic information systems (GIS) databases. May also perform some custom application development or provide user support.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "15-1299.03",
    "name": "Document Management Specialists",
    "description": "Implement and administer enterprise-wide document management systems and related procedures that allow organizations to capture, store, retrieve, share, and destroy electronic records and documents.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-1299.04",
    "name": "Penetration Testers",
    "description": "Evaluate network system security by conducting simulated internal and external cyberattacks using adversary tools and techniques. Attempt to breach and exploit critical systems and gain access to sensitive information to assess system security.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-1299.05",
    "name": "Information Security Engineers",
    "description": "Develop and oversee the implementation of information security procedures and policies. Build, maintain and upgrade security technology, such as firewalls, for the safe use of computer networks and the transmission and retrieval of information. Design and implement appropriate security controls to identify vulnerabilities and protect digital files and electronic infrastructures. Monitor and respond to computer security breaches, viruses, and intrusions, and perform forensic investigation. May oversee the assessment of information security systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-1299.06",
    "name": "Digital Forensics Analysts",
    "description": "Conduct investigations on computer-based crimes establishing documentary or physical evidence, such as digital media and logs associated with cyber intrusion incidents. Analyze digital evidence and investigate computer security incidents to derive information in support of system and network vulnerability mitigation. Preserve and present computer-related evidence in support of criminal, fraud, counterintelligence, or law enforcement investigations.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-1299.07",
    "name": "Blockchain Engineers",
    "description": "Maintain and support distributed and decentralized blockchain-based networks or block-chain applications such as cryptocurrency exchange, payment processing, document sharing, and digital voting. Design and deploy secure block-chain design patterns and solutions over geographically distributed networks using advanced technologies. May assist with infrastructure setup and testing for application transparency and security.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-1299.08",
    "name": "Computer Systems Engineers/Architects",
    "description": "Design and develop solutions to complex applications problems, system administration issues, or network concerns. Perform systems management and integration functions.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "15-1299.09",
    "name": "Information Technology Project Managers",
    "description": "Plan, initiate, and manage information technology (IT) projects. Lead and guide the work of technical staff. Serve as liaison between business and technical aspects of projects. Plan project stages and assess business implications for each stage. Monitor progress to assure deadlines, standards, and cost targets are met.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-2011.00",
    "name": "Actuaries",
    "description": "Analyze statistical data, such as mortality, accident, sickness, disability, and retirement rates and construct probability tables to forecast risk and liability for payment of future benefits. May ascertain insurance rates required and cash reserves necessary to ensure payment of future benefits.",
    "hourlyIncome": 65,
    "annualIncome": 134990,
    "careerGrowth": 21.8,
    "jobZone": 4
  },
  {
    "code": "15-2021.00",
    "name": "Mathematicians",
    "description": "Conduct research in fundamental mathematics or in application of mathematical techniques to science, management, and other fields. Solve problems in various fields using mathematical methods.",
    "hourlyIncome": 59,
    "annualIncome": 122520,
    "careerGrowth": 3.7,
    "jobZone": 5
  },
  {
    "code": "15-2031.00",
    "name": "Operations Research Analysts",
    "description": "Formulate and apply mathematical modeling and other optimizing methods to develop and interpret information that assists management with decisionmaking, policy formulation, or other managerial functions. May collect and analyze data and develop decision support software, services, or products. May develop and supply optimal time, cost, or logistics networks for program evaluation, review, or implementation.",
    "hourlyIncome": 48,
    "annualIncome": 99120,
    "careerGrowth": 23,
    "jobZone": 5
  },
  {
    "code": "15-2041.00",
    "name": "Statisticians",
    "description": "Develop or apply mathematical or statistical theory and methods to collect, organize, interpret, and summarize numerical data to provide usable information. May specialize in fields such as biostatistics, agricultural statistics, business statistics, or economic statistics. Includes mathematical and survey statisticians.",
    "hourlyIncome": 54,
    "annualIncome": 112330,
    "careerGrowth": 11.8,
    "jobZone": 5
  },
  {
    "code": "15-2041.01",
    "name": "Biostatisticians",
    "description": "Develop and apply biostatistical theory and methods to the study of life sciences.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "15-2051.00",
    "name": "Data Scientists",
    "description": "Develop and implement a set of techniques or analytics applications to transform raw data into meaningful information using data-oriented programming languages and visualization software. Apply data mining, data modeling, natural language processing, and machine learning to extract and analyze information from large structured and unstructured datasets. Visualize, interpret, and report data findings. May create dynamic data reports.",
    "hourlyIncome": 60,
    "annualIncome": 124590,
    "careerGrowth": 36,
    "jobZone": 4
  },
  {
    "code": "15-2051.01",
    "name": "Business Intelligence Analysts",
    "description": "Produce financial and market intelligence by querying data repositories and generating periodic reports. Devise methods for identifying data patterns and trends in available information sources.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-2051.02",
    "name": "Clinical Data Managers",
    "description": "Apply knowledge of health care and database management to analyze clinical data, and to identify and report trends.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "15-2099.00",
    "name": "Mathematical Science Occupations, All Other",
    "description": "All mathematical scientists not listed separately.",
    "hourlyIncome": 41,
    "annualIncome": 84700,
    "careerGrowth": 6.9,
    "jobZone": null
  },
  {
    "code": "15-2099.01",
    "name": "Bioinformatics Technicians",
    "description": "Apply principles and methods of bioinformatics to assist scientists in areas such as pharmaceuticals, medical technology, biotechnology, computational biology, proteomics, computer information science, biology and medical informatics. Apply bioinformatics tools to visualize, analyze, manipulate or interpret molecular data. May build and maintain databases for processing and analyzing genomic or other biological information.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-1011.00",
    "name": "Architects, Except Landscape and Naval",
    "description": "Plan and design structures, such as private residences, office buildings, theaters, factories, and other structural property.",
    "hourlyIncome": 50,
    "annualIncome": 103390,
    "careerGrowth": 7.8,
    "jobZone": 5
  },
  {
    "code": "17-1012.00",
    "name": "Landscape Architects",
    "description": "Plan and design land areas for projects such as parks and other recreational facilities, airports, highways, hospitals, schools, land subdivisions, and commercial, industrial, and residential sites.",
    "hourlyIncome": 42,
    "annualIncome": 88000,
    "careerGrowth": 4.7,
    "jobZone": 4
  },
  {
    "code": "17-1021.00",
    "name": "Cartographers and Photogrammetrists",
    "description": "Research, study, and prepare maps and other spatial data in digital or graphic form for one or more purposes, such as legal, social, political, educational, and design purposes. May work with Geographic Information Systems (GIS). May design and evaluate algorithms, data structures, and user interfaces for GIS and mapping systems. May collect, analyze, and interpret geographic information provided by geodetic surveys, aerial photographs, and satellite data.",
    "hourlyIncome": 40,
    "annualIncome": 82860,
    "careerGrowth": 6.3,
    "jobZone": 4
  },
  {
    "code": "17-1022.00",
    "name": "Surveyors",
    "description": "Make exact measurements and determine property boundaries. Provide data relevant to the shape, contour, gravitation, location, elevation, or dimension of land or land features on or near the earth's surface for engineering, mapmaking, mining, land evaluation, construction, and other purposes.",
    "hourlyIncome": 37,
    "annualIncome": 76730,
    "careerGrowth": 5.9,
    "jobZone": 4
  },
  {
    "code": "17-1022.01",
    "name": "Geodetic Surveyors",
    "description": "Measure large areas of the Earth's surface using satellite observations, global navigation satellite systems (GNSS), light detection and ranging (LIDAR), or related sources.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2011.00",
    "name": "Aerospace Engineers",
    "description": "Perform engineering duties in designing, constructing, and testing aircraft, missiles, and spacecraft. May conduct basic and applied research to evaluate adaptability of materials and equipment to aircraft design and manufacture. May recommend improvements in testing equipment and techniques.",
    "hourlyIncome": 68,
    "annualIncome": 141180,
    "careerGrowth": 6,
    "jobZone": 4
  },
  {
    "code": "17-2021.00",
    "name": "Agricultural Engineers",
    "description": "Apply knowledge of engineering technology and biological science to agricultural problems concerned with power and machinery, electrification, structures, soil and water conservation, and processing of agricultural products.",
    "hourlyIncome": 41,
    "annualIncome": 84240,
    "careerGrowth": 7.8,
    "jobZone": 4
  },
  {
    "code": "17-2031.00",
    "name": "Bioengineers and Biomedical Engineers",
    "description": "Apply knowledge of engineering, biology, chemistry, computer science, and biomechanical principles to the design, development, and evaluation of biological, agricultural, and health systems and products, such as artificial organs, prostheses, instrumentation, medical information systems, and health management and care delivery systems.",
    "hourlyIncome": 55,
    "annualIncome": 115020,
    "careerGrowth": 7.4,
    "jobZone": 4
  },
  {
    "code": "17-2041.00",
    "name": "Chemical Engineers",
    "description": "Design chemical plant equipment and devise processes for manufacturing chemicals and products, such as gasoline, synthetic rubber, plastics, detergents, cement, paper, and pulp, by applying principles and technology of chemistry, physics, and engineering.",
    "hourlyIncome": 62,
    "annualIncome": 128430,
    "careerGrowth": 9.8,
    "jobZone": 4
  },
  {
    "code": "17-2051.00",
    "name": "Civil Engineers",
    "description": "Perform engineering duties in planning, designing, and overseeing construction and maintenance of building structures and facilities, such as roads, railroads, airports, bridges, harbors, channels, dams, irrigation projects, pipelines, power plants, and water and sewage systems.",
    "hourlyIncome": 51,
    "annualIncome": 107050,
    "careerGrowth": 6.5,
    "jobZone": 4
  },
  {
    "code": "17-2051.01",
    "name": "Transportation Engineers",
    "description": "Develop plans for surface transportation projects, according to established engineering standards and state or federal construction policy. Prepare designs, specifications, or estimates for transportation facilities. Plan modifications of existing streets, highways, or freeways to improve traffic flow.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2051.02",
    "name": "Water/Wastewater Engineers",
    "description": "Design or oversee projects involving provision of potable water, disposal of wastewater and sewage, or prevention of flood-related damage. Prepare environmental documentation for water resources, regulatory program compliance, data management and analysis, and field work. Perform hydraulic modeling and pipeline design.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2061.00",
    "name": "Computer Hardware Engineers",
    "description": "Research, design, develop, or test computer or computer-related equipment for commercial, industrial, military, or scientific use. May supervise the manufacturing and installation of computer or computer-related equipment and components.",
    "hourlyIncome": 75,
    "annualIncome": 156770,
    "careerGrowth": 7.2,
    "jobZone": 4
  },
  {
    "code": "17-2071.00",
    "name": "Electrical Engineers",
    "description": "Research, design, develop, test, or supervise the manufacturing and installation of electrical equipment, components, or systems for commercial, industrial, military, or scientific use.",
    "hourlyIncome": 58,
    "annualIncome": 120980,
    "careerGrowth": 9.1,
    "jobZone": 4
  },
  {
    "code": "17-2072.00",
    "name": "Electronics Engineers, Except Computer",
    "description": "Research, design, develop, or test electronic components and systems for commercial, industrial, military, or scientific use employing knowledge of electronic theory and materials properties. Design electronic circuits and components for use in fields such as telecommunications, aerospace guidance and propulsion control, acoustics, or instruments and controls.",
    "hourlyIncome": 64,
    "annualIncome": 132500,
    "careerGrowth": 9.1,
    "jobZone": 4
  },
  {
    "code": "17-2072.01",
    "name": "Radio Frequency Identification Device Specialists",
    "description": "Design and implement radio frequency identification device (RFID) systems used to track shipments or goods.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2081.00",
    "name": "Environmental Engineers",
    "description": "Research, design, plan, or perform engineering duties in the prevention, control, and remediation of environmental hazards using various engineering disciplines. Work may include waste treatment, site remediation, or pollution control technology.",
    "hourlyIncome": 53,
    "annualIncome": 110570,
    "careerGrowth": 6.9,
    "jobZone": 4
  },
  {
    "code": "17-2111.00",
    "name": "Health and Safety Engineers, Except Mining Safety Engineers and Inspectors",
    "description": "Promote worksite or product safety by applying knowledge of industrial processes, mechanics, chemistry, psychology, and industrial health and safety laws. Includes industrial product safety engineers.",
    "hourlyIncome": 55,
    "annualIncome": 113770,
    "careerGrowth": 5.1,
    "jobZone": 4
  },
  {
    "code": "17-2111.02",
    "name": "Fire-Prevention and Protection Engineers",
    "description": "Research causes of fires, determine fire protection methods, and design or recommend materials or equipment such as structural components or fire-detection equipment to assist organizations in safeguarding life and property against fire, explosion, and related hazards.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2112.00",
    "name": "Industrial Engineers",
    "description": "Design, develop, test, and evaluate integrated systems for managing industrial production processes, including human work factors, quality control, inventory control, logistics and material flow, cost analysis, and production coordination.",
    "hourlyIncome": 52,
    "annualIncome": 107900,
    "careerGrowth": 12.2,
    "jobZone": 4
  },
  {
    "code": "17-2112.01",
    "name": "Human Factors Engineers and Ergonomists",
    "description": "Design objects, facilities, and environments to optimize human well-being and overall system performance, applying theory, principles, and data regarding the relationship between humans and respective technology. Investigate and analyze characteristics of human behavior and performance as it relates to the use of technology.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "17-2112.02",
    "name": "Validation Engineers",
    "description": "Design or plan protocols for equipment or processes to produce products meeting internal and external purity, safety, and quality requirements.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2112.03",
    "name": "Manufacturing Engineers",
    "description": "Design, integrate, or improve manufacturing systems or related processes. May work with commercial or industrial designers to refine product designs to increase producibility and decrease costs.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2121.00",
    "name": "Marine Engineers and Naval Architects",
    "description": "Design, develop, and evaluate the operation of marine vessels, ship machinery, and related equipment, such as power supply and propulsion systems.",
    "hourlyIncome": 56,
    "annualIncome": 116680,
    "careerGrowth": 8,
    "jobZone": 4
  },
  {
    "code": "17-2131.00",
    "name": "Materials Engineers",
    "description": "Evaluate materials and develop machinery and processes to manufacture materials for use in products that must meet specialized design and performance specifications. Develop new uses for known materials. Includes those engineers working with composite materials or specializing in one type of material, such as graphite, metal and metal alloys, ceramics and glass, plastics and polymers, and naturally occurring materials. Includes metallurgists and metallurgical engineers, ceramic engineers, and welding engineers.",
    "hourlyIncome": 56,
    "annualIncome": 116380,
    "careerGrowth": 7.4,
    "jobZone": 4
  },
  {
    "code": "17-2141.00",
    "name": "Mechanical Engineers",
    "description": "Perform engineering duties in planning and designing tools, engines, machines, and other mechanically functioning equipment. Oversee installation, operation, maintenance, and repair of equipment such as centralized heat, gas, water, and steam systems.",
    "hourlyIncome": 53,
    "annualIncome": 110080,
    "careerGrowth": 11,
    "jobZone": 4
  },
  {
    "code": "17-2141.01",
    "name": "Fuel Cell Engineers",
    "description": "Design, evaluate, modify, or construct fuel cell components or systems for transportation, stationary, or portable applications.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2141.02",
    "name": "Automotive Engineers",
    "description": "Develop new or improved designs for vehicle structural members, engines, transmissions, or other vehicle systems, using computer-assisted design technology. Direct building, modification, or testing of vehicle or components.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2151.00",
    "name": "Mining and Geological Engineers, Including Mining Safety Engineers",
    "description": "Conduct subsurface surveys to identify the characteristics of potential land or mining development sites. May specify the ground support systems, processes, and equipment for safe, economical, and environmentally sound extraction or underground construction activities. May inspect areas for unsafe geological conditions, equipment, and working conditions. May design, implement, and coordinate mine safety programs.",
    "hourlyIncome": 52,
    "annualIncome": 108940,
    "careerGrowth": 2,
    "jobZone": 4
  },
  {
    "code": "17-2161.00",
    "name": "Nuclear Engineers",
    "description": "Conduct research on nuclear engineering projects or apply principles and theory of nuclear science to problems concerned with release, control, and use of nuclear energy and nuclear waste disposal.",
    "hourlyIncome": 65,
    "annualIncome": 134980,
    "careerGrowth": -0.8,
    "jobZone": 4
  },
  {
    "code": "17-2171.00",
    "name": "Petroleum Engineers",
    "description": "Devise methods to improve oil and gas extraction and production and determine the need for new or modified tool designs. Oversee drilling and offer technical advice.",
    "hourlyIncome": 74,
    "annualIncome": 153560,
    "careerGrowth": 2.4,
    "jobZone": 4
  },
  {
    "code": "17-2199.00",
    "name": "Engineers, All Other",
    "description": "All engineers not listed separately.",
    "hourlyIncome": 59,
    "annualIncome": 121720,
    "careerGrowth": 5,
    "jobZone": null
  },
  {
    "code": "17-2199.03",
    "name": "Energy Engineers, Except Wind and Solar",
    "description": "Design, develop, or evaluate energy-related projects or programs to reduce energy costs or improve energy efficiency during the designing, building, or remodeling stages of construction. May specialize in electrical systems; heating, ventilation, and air-conditioning (HVAC) systems; green buildings; lighting; air quality; or energy procurement.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2199.05",
    "name": "Mechatronics Engineers",
    "description": "Research, design, develop, or test automation, intelligent systems, smart devices, or industrial systems control.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2199.06",
    "name": "Microsystems Engineers",
    "description": "Research, design, develop, or test microelectromechanical systems (MEMS) devices.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "17-2199.07",
    "name": "Photonics Engineers",
    "description": "Design technologies specializing in light information or light energy, such as laser or fiber optics technology.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2199.08",
    "name": "Robotics Engineers",
    "description": "Research, design, develop, or test robotic applications.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2199.09",
    "name": "Nanosystems Engineers",
    "description": "Design, develop, or supervise the production of materials, devices, or systems of unique molecular or macromolecular composition, applying principles of nanoscale physics and electrical, chemical, or biological engineering.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "17-2199.10",
    "name": "Wind Energy Engineers",
    "description": "Design underground or overhead wind farm collector systems and prepare and develop site specifications.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-2199.11",
    "name": "Solar Energy Systems Engineers",
    "description": "Perform site-specific engineering analysis or evaluation of energy efficiency and solar projects involving residential, commercial, or industrial customers. Design solar domestic hot water and space heating systems for new and existing structures, applying knowledge of structural energy requirements, local climates, solar technology, and thermodynamics.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-3011.00",
    "name": "Architectural and Civil Drafters",
    "description": "Prepare detailed drawings of architectural and structural features of buildings or drawings and topographical relief maps used in civil engineering projects, such as highways, bridges, and public works. Use knowledge of building materials, engineering practices, and mathematics to complete drawings.",
    "hourlyIncome": 33,
    "annualIncome": 68860,
    "careerGrowth": 1.1,
    "jobZone": 3
  },
  {
    "code": "17-3012.00",
    "name": "Electrical and Electronics Drafters",
    "description": "Prepare wiring diagrams, circuit board assembly diagrams, and layout drawings used for the manufacture, installation, or repair of electrical equipment.",
    "hourlyIncome": 37,
    "annualIncome": 77960,
    "careerGrowth": 4.1,
    "jobZone": 3
  },
  {
    "code": "17-3013.00",
    "name": "Mechanical Drafters",
    "description": "Prepare detailed working diagrams of machinery and mechanical devices, including dimensions, fastening methods, and other engineering information.",
    "hourlyIncome": 36,
    "annualIncome": 74040,
    "careerGrowth": -4.9,
    "jobZone": 3
  },
  {
    "code": "17-3019.00",
    "name": "Drafters, All Other",
    "description": "All drafters not listed separately.",
    "hourlyIncome": 32,
    "annualIncome": 66530,
    "careerGrowth": -5.7,
    "jobZone": null
  },
  {
    "code": "17-3021.00",
    "name": "Aerospace Engineering and Operations Technologists and Technicians",
    "description": "Operate, install, adjust, and maintain integrated computer/communications systems, consoles, simulators, and other data acquisition, test, and measurement instruments and equipment, which are used to launch, track, position, and evaluate air and space vehicles. May record and interpret test data.",
    "hourlyIncome": 42,
    "annualIncome": 86330,
    "careerGrowth": 7.9,
    "jobZone": 3
  },
  {
    "code": "17-3022.00",
    "name": "Civil Engineering Technologists and Technicians",
    "description": "Apply theory and principles of civil engineering in planning, designing, and overseeing construction and maintenance of structures and facilities under the direction of engineering staff or physical scientists.",
    "hourlyIncome": 33,
    "annualIncome": 68450,
    "careerGrowth": 1.8,
    "jobZone": 3
  },
  {
    "code": "17-3023.00",
    "name": "Electrical and Electronic Engineering Technologists and Technicians",
    "description": "Apply electrical and electronic theory and related knowledge, usually under the direction of engineering staff, to design, build, repair, adjust, and modify electrical components, circuitry, controls, and machinery for subsequent evaluation and use by engineering staff in making engineering design decisions.",
    "hourlyIncome": 38,
    "annualIncome": 78580,
    "careerGrowth": 3,
    "jobZone": 3
  },
  {
    "code": "17-3024.00",
    "name": "Electro-Mechanical and Mechatronics Technologists and Technicians",
    "description": "Operate, test, maintain, or adjust unmanned, automated, servomechanical, or electromechanical equipment. May operate unmanned submarines, aircraft, or other equipment to observe or record visual information at sites such as oil rigs, crop fields, buildings, or for similar infrastructure, deep ocean exploration, or hazardous waste removal. May assist engineers in testing and designing robotics equipment.",
    "hourlyIncome": 36,
    "annualIncome": 75710,
    "careerGrowth": -1.2,
    "jobZone": 3
  },
  {
    "code": "17-3024.01",
    "name": "Robotics Technicians",
    "description": "Build, install, test, or maintain robotic equipment or related automated production systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "17-3025.00",
    "name": "Environmental Engineering Technologists and Technicians",
    "description": "Apply theory and principles of environmental engineering to modify, test, and operate equipment and devices used in the prevention, control, and remediation of environmental problems, including waste treatment and site remediation, under the direction of engineering staff or scientists. May assist in the development of environmental remediation devices.",
    "hourlyIncome": 30,
    "annualIncome": 63070,
    "careerGrowth": 2.3,
    "jobZone": 4
  },
  {
    "code": "17-3026.00",
    "name": "Industrial Engineering Technologists and Technicians",
    "description": "Apply engineering theory and principles to problems of industrial layout or manufacturing production, usually under the direction of engineering staff. May perform time and motion studies on worker operations in a variety of industries for purposes such as establishing standard production rates or improving efficiency.",
    "hourlyIncome": 34,
    "annualIncome": 69780,
    "careerGrowth": 4.1,
    "jobZone": 3
  },
  {
    "code": "17-3026.01",
    "name": "Nanotechnology Engineering Technologists and Technicians",
    "description": "Implement production processes and operate commercial-scale production equipment to produce, test, or modify materials, devices, or systems of unique molecular or macromolecular composition. Operate advanced microscopy equipment to manipulate nanoscale objects. Work under the supervision of nanoengineering staff.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "17-3027.00",
    "name": "Mechanical Engineering Technologists and Technicians",
    "description": "Apply theory and principles of mechanical engineering to modify, develop, test, or adjust machinery and equipment under direction of engineering staff or physical scientists.",
    "hourlyIncome": 35,
    "annualIncome": 72450,
    "careerGrowth": 1.9,
    "jobZone": 3
  },
  {
    "code": "17-3027.01",
    "name": "Automotive Engineering Technicians",
    "description": "Assist engineers in determining the practicality of proposed product design changes and plan and carry out tests on experimental test devices or equipment for performance, durability, or efficiency.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "17-3028.00",
    "name": "Calibration Technologists and Technicians",
    "description": "Execute or adapt procedures and techniques for calibrating measurement devices, by applying knowledge of measurement science, mathematics, physics, chemistry, and electronics, sometimes under the direction of engineering staff. Determine measurement standard suitability for calibrating measurement devices. May perform preventive maintenance on equipment. May perform corrective actions to address identified calibration problems.",
    "hourlyIncome": 34,
    "annualIncome": 71080,
    "careerGrowth": 5.5,
    "jobZone": 3
  },
  {
    "code": "17-3029.00",
    "name": "Engineering Technologists and Technicians, Except Drafters, All Other",
    "description": "All engineering technologists and technicians, except drafters, not listed separately.",
    "hourlyIncome": 38,
    "annualIncome": 79740,
    "careerGrowth": 4.4,
    "jobZone": null
  },
  {
    "code": "17-3029.01",
    "name": "Non-Destructive Testing Specialists",
    "description": "Test the safety of structures, vehicles, or vessels using x-ray, ultrasound, fiber optic or related equipment.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "17-3029.08",
    "name": "Photonics Technicians",
    "description": "Build, install, test, or maintain optical or fiber optic equipment, such as lasers, lenses, or mirrors, using spectrometers, interferometers, or related equipment.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "17-3031.00",
    "name": "Surveying and Mapping Technicians",
    "description": "Perform surveying and mapping duties, usually under the direction of an engineer, surveyor, cartographer, or photogrammetrist, to obtain data used for construction, mapmaking, boundary location, mining, or other purposes. May calculate mapmaking information and create maps from source data, such as surveying notes, aerial photography, satellite data, or other maps to show topographical features, political boundaries, and other features. May verify accuracy and completeness of maps.",
    "hourlyIncome": 27,
    "annualIncome": 56890,
    "careerGrowth": 5.6,
    "jobZone": 3
  },
  {
    "code": "19-1011.00",
    "name": "Animal Scientists",
    "description": "Conduct research in the genetics, nutrition, reproduction, growth, and development of domestic farm animals.",
    "hourlyIncome": 50,
    "annualIncome": 104970,
    "careerGrowth": 7.9,
    "jobZone": 5
  },
  {
    "code": "19-1012.00",
    "name": "Food Scientists and Technologists",
    "description": "Use chemistry, microbiology, engineering, and other sciences to study the principles underlying the processing and deterioration of foods; analyze food content to determine levels of vitamins, fat, sugar, and protein; discover new food sources; research ways to make processed foods safe, palatable, and healthful; and apply food science knowledge to determine best ways to process, package, preserve, store, and distribute food.",
    "hourlyIncome": 44,
    "annualIncome": 92190,
    "careerGrowth": 8.9,
    "jobZone": 4
  },
  {
    "code": "19-1013.00",
    "name": "Soil and Plant Scientists",
    "description": "Conduct research in breeding, physiology, production, yield, and management of crops and agricultural plants or trees, shrubs, and nursery stock, their growth in soils, and control of pests; or study the chemical, physical, biological, and mineralogical composition of soils as they relate to plant or crop growth. May classify and map soils and investigate effects of alternative practices on soil and crop productivity.",
    "hourlyIncome": 40,
    "annualIncome": 83040,
    "careerGrowth": 7.2,
    "jobZone": 5
  },
  {
    "code": "19-1021.00",
    "name": "Biochemists and Biophysicists",
    "description": "Study the chemical composition or physical principles of living cells and organisms, their electrical and mechanical energy, and related phenomena. May conduct research to further understanding of the complex chemical combinations and reactions involved in metabolism, reproduction, growth, and heredity. May determine the effects of foods, drugs, serums, hormones, and other substances on tissues and vital processes of living organisms.",
    "hourlyIncome": 56,
    "annualIncome": 115570,
    "careerGrowth": 9,
    "jobZone": 5
  },
  {
    "code": "19-1022.00",
    "name": "Microbiologists",
    "description": "Investigate the growth, structure, development, and other characteristics of microscopic organisms, such as bacteria, algae, or fungi. Includes medical microbiologists who study the relationship between organisms and disease or the effects of antibiotics on microorganisms.",
    "hourlyIncome": 46,
    "annualIncome": 95200,
    "careerGrowth": 6.7,
    "jobZone": 4
  },
  {
    "code": "19-1023.00",
    "name": "Zoologists and Wildlife Biologists",
    "description": "Study the origins, behavior, diseases, genetics, and life processes of animals and wildlife. May specialize in wildlife research and management. May collect and analyze biological data to determine the environmental effects of present and potential use of land and water habitats.",
    "hourlyIncome": 37,
    "annualIncome": 77920,
    "careerGrowth": 4.4,
    "jobZone": 4
  },
  {
    "code": "19-1029.00",
    "name": "Biological Scientists, All Other",
    "description": "All biological scientists not listed separately.",
    "hourlyIncome": 48,
    "annualIncome": 100440,
    "careerGrowth": 5.6,
    "jobZone": null
  },
  {
    "code": "19-1029.01",
    "name": "Bioinformatics Scientists",
    "description": "Conduct research using bioinformatics theory and methods in areas such as pharmaceuticals, medical technology, biotechnology, computational biology, proteomics, computer information science, biology and medical informatics. May design databases and develop algorithms for processing and analyzing genomic information, or other biological information.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-1029.02",
    "name": "Molecular and Cellular Biologists",
    "description": "Research and study cellular molecules and organelles to understand cell function and organization.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-1029.03",
    "name": "Geneticists",
    "description": "Research and study the inheritance of traits at the molecular, organism or population level. May evaluate or treat patients with genetic disorders.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-1029.04",
    "name": "Biologists",
    "description": "Research or study basic principles of plant and animal life, such as origin, relationship, development, anatomy, and functions.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-1031.00",
    "name": "Conservation Scientists",
    "description": "Manage, improve, and protect natural resources to maximize their use without damaging the environment. May conduct soil surveys and develop plans to eliminate soil erosion or to protect rangelands. May instruct farmers, agricultural production managers, or ranchers in best ways to use crop rotation, contour plowing, or terracing to conserve soil and water; in the number and kind of livestock and forage plants best suited to particular ranges; and in range and farm improvements, such as fencing and reservoirs for stock watering.",
    "hourlyIncome": 36,
    "annualIncome": 74310,
    "careerGrowth": 5.6,
    "jobZone": 4
  },
  {
    "code": "19-1031.02",
    "name": "Range Managers",
    "description": "Research or study range land management practices to provide sustained production of forage, livestock, and wildlife.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "19-1031.03",
    "name": "Park Naturalists",
    "description": "Plan, develop, and conduct programs to inform public of historical, natural, and scientific features of national, state, or local park.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "19-1032.00",
    "name": "Foresters",
    "description": "Manage public and private forested lands for economic, recreational, and conservation purposes. May inventory the type, amount, and location of standing timber, appraise the timber's worth, negotiate the purchase, and draw up contracts for procurement. May determine how to conserve wildlife habitats, creek beds, water quality, and soil stability, and how best to comply with environmental regulations. May devise plans for planting and growing new trees, monitor trees for healthy growth, and determine optimal harvesting schedules.",
    "hourlyIncome": 36,
    "annualIncome": 74670,
    "careerGrowth": 3,
    "jobZone": 4
  },
  {
    "code": "19-1041.00",
    "name": "Epidemiologists",
    "description": "Investigate and describe the determinants and distribution of disease, disability, or health outcomes. May develop the means for prevention and control.",
    "hourlyIncome": 45,
    "annualIncome": 94160,
    "careerGrowth": 18.8,
    "jobZone": 5
  },
  {
    "code": "19-1042.00",
    "name": "Medical Scientists, Except Epidemiologists",
    "description": "Conduct research dealing with the understanding of human diseases and the improvement of human health. Engage in clinical investigation, research and development, or other related activities.",
    "hourlyIncome": 54,
    "annualIncome": 112690,
    "careerGrowth": 11.5,
    "jobZone": 5
  },
  {
    "code": "19-1099.00",
    "name": "Life Scientists, All Other",
    "description": "All life scientists not listed separately.",
    "hourlyIncome": 49,
    "annualIncome": 101940,
    "careerGrowth": 6.5,
    "jobZone": null
  },
  {
    "code": "19-2011.00",
    "name": "Astronomers",
    "description": "Observe, research, and interpret astronomical phenomena to increase basic knowledge or apply such information to practical problems.",
    "hourlyIncome": 65,
    "annualIncome": 134430,
    "careerGrowth": 7.4,
    "jobZone": 5
  },
  {
    "code": "19-2012.00",
    "name": "Physicists",
    "description": "Conduct research into physical phenomena, develop theories on the basis of observation and experiments, and devise methods to apply physical laws and theories.",
    "hourlyIncome": 80,
    "annualIncome": 166000,
    "careerGrowth": 7.2,
    "jobZone": 5
  },
  {
    "code": "19-2021.00",
    "name": "Atmospheric and Space Scientists",
    "description": "Investigate atmospheric phenomena and interpret meteorological data, gathered by surface and air stations, satellites, and radar to prepare reports and forecasts for public and other uses. Includes weather analysts and forecasters whose functions require the detailed knowledge of meteorology.",
    "hourlyIncome": 50,
    "annualIncome": 103980,
    "careerGrowth": 5.6,
    "jobZone": 4
  },
  {
    "code": "19-2031.00",
    "name": "Chemists",
    "description": "Conduct qualitative and quantitative chemical analyses or experiments in laboratories for quality or process control or to develop new products or knowledge.",
    "hourlyIncome": 46,
    "annualIncome": 95940,
    "careerGrowth": 7.6,
    "jobZone": 4
  },
  {
    "code": "19-2032.00",
    "name": "Materials Scientists",
    "description": "Research and study the structures and chemical properties of various natural and synthetic or composite materials, including metals, alloys, rubber, ceramics, semiconductors, polymers, and glass. Determine ways to strengthen or combine materials or develop new materials with new or specific properties for use in a variety of products and applications. Includes glass scientists, ceramic scientists, metallurgical scientists, and polymer scientists.",
    "hourlyIncome": 54,
    "annualIncome": 111410,
    "careerGrowth": 8.7,
    "jobZone": 4
  },
  {
    "code": "19-2041.00",
    "name": "Environmental Scientists and Specialists, Including Health",
    "description": "Conduct research or perform investigation for the purpose of identifying, abating, or eliminating sources of pollutants or hazards that affect either the environment or public health. Using knowledge of various scientific disciplines, may collect, synthesize, study, report, and recommend action based on data derived from measurements or observations of air, food, soil, water, and other sources.",
    "hourlyIncome": 43,
    "annualIncome": 88640,
    "careerGrowth": 7.3,
    "jobZone": 4
  },
  {
    "code": "19-2041.01",
    "name": "Climate Change Policy Analysts",
    "description": "Research and analyze policy developments related to climate change. Make climate-related recommendations for actions such as legislation, awareness campaigns, or fundraising approaches.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-2041.02",
    "name": "Environmental Restoration Planners",
    "description": "Collaborate with field and biology staff to oversee the implementation of restoration projects and to develop new products. Process and synthesize complex scientific data into practical strategies for restoration, monitoring or management.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-2041.03",
    "name": "Industrial Ecologists",
    "description": "Apply principles and processes of natural ecosystems to develop models for efficient industrial systems. Use knowledge from the physical and social sciences to maximize effective use of natural resources in the production and use of goods and services. Examine societal issues and their relationship with both technical systems and the environment.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-2042.00",
    "name": "Geoscientists, Except Hydrologists and Geographers",
    "description": "Study the composition, structure, and other physical aspects of the Earth. May use geological, physics, and mathematics knowledge in exploration for oil, gas, minerals, or underground water; or in waste disposal, land reclamation, or other environmental problems. May study the Earth's internal composition, atmospheres, and oceans, and its magnetic, electrical, and gravitational forces. Includes mineralogists, paleontologists, stratigraphers, geodesists, and seismologists.",
    "hourlyIncome": 54,
    "annualIncome": 111310,
    "careerGrowth": 5.5,
    "jobZone": 5
  },
  {
    "code": "19-2043.00",
    "name": "Hydrologists",
    "description": "Research the distribution, circulation, and physical properties of underground and surface waters; and study the form and intensity of precipitation and its rate of infiltration into the soil, movement through the earth, and return to the ocean and atmosphere.",
    "hourlyIncome": 47,
    "annualIncome": 98130,
    "careerGrowth": 2.8,
    "jobZone": 5
  },
  {
    "code": "19-2099.00",
    "name": "Physical Scientists, All Other",
    "description": "All physical scientists not listed separately.",
    "hourlyIncome": 59,
    "annualIncome": 123070,
    "careerGrowth": 2.3,
    "jobZone": null
  },
  {
    "code": "19-2099.01",
    "name": "Remote Sensing Scientists and Technologists",
    "description": "Apply remote sensing principles and methods to analyze data and solve problems in areas such as natural resource management, urban planning, or homeland security. May develop new sensor systems, analytical techniques, or new applications for existing systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "19-3011.00",
    "name": "Economists",
    "description": "Conduct research, prepare reports, or formulate plans to address economic problems related to the production and distribution of goods and services or monetary and fiscal policy. May collect and process economic and statistical data using sampling techniques and econometric methods.",
    "hourlyIncome": 63,
    "annualIncome": 130910,
    "careerGrowth": 5.1,
    "jobZone": 5
  },
  {
    "code": "19-3011.01",
    "name": "Environmental Economists",
    "description": "Conduct economic analysis related to environmental protection and use of the natural environment, such as water, air, land, and renewable energy resources. Evaluate and quantify benefits, costs, incentives, and impacts of alternative options using economic principles and statistical techniques.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-3022.00",
    "name": "Survey Researchers",
    "description": "Plan, develop, or conduct surveys. May analyze and interpret the meaning of survey data, determine survey objectives, or suggest or test question wording. Includes social scientists who primarily design questionnaires or supervise survey teams.",
    "hourlyIncome": 35,
    "annualIncome": 73470,
    "careerGrowth": -0.2,
    "jobZone": 5
  },
  {
    "code": "19-3032.00",
    "name": "Industrial-Organizational Psychologists",
    "description": "Apply principles of psychology to human resources, administration, management, sales, and marketing problems. Activities may include policy planning; employee testing and selection, training, and development; and organizational development and analysis. May work with management to organize the work setting to improve worker productivity.",
    "hourlyIncome": 65,
    "annualIncome": 134400,
    "careerGrowth": 5.8,
    "jobZone": 5
  },
  {
    "code": "19-3033.00",
    "name": "Clinical and Counseling Psychologists",
    "description": "Assess, diagnose, and treat mental and emotional disorders of individuals through observation, interview, and psychological tests. Help individuals with distress or maladjustment understand their problems through their knowledge of case history, interviews with patients, and theory. Provide individual or group counseling services to assist individuals in achieving more effective personal, social, educational, and vocational development and adjustment. May design behavior modification programs and consult with medical personnel regarding the best treatment for patients.",
    "hourlyIncome": 51,
    "annualIncome": 106850,
    "careerGrowth": 13.3,
    "jobZone": 5
  },
  {
    "code": "19-3034.00",
    "name": "School Psychologists",
    "description": "Diagnose and implement individual or schoolwide interventions or strategies to address educational, behavioral, or developmental issues that adversely impact educational functioning in a school. May address student learning and behavioral problems and counsel students or families. May design and implement performance plans, and evaluate performance. May consult with other school-based personnel.",
    "hourlyIncome": 45,
    "annualIncome": 93610,
    "careerGrowth": 0.7,
    "jobZone": 5
  },
  {
    "code": "19-3039.00",
    "name": "Psychologists, All Other",
    "description": "All psychologists not listed separately.",
    "hourlyIncome": 54,
    "annualIncome": 111340,
    "careerGrowth": 5,
    "jobZone": null
  },
  {
    "code": "19-3039.02",
    "name": "Neuropsychologists",
    "description": "Apply theories and principles of neuropsychology to evaluate and diagnose disorders of higher cerebral functioning, often in research and medical settings. Study the human brain and the effect of physiological states on human cognition and behavior. May formulate and administer programs of treatment.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-3039.03",
    "name": "Clinical Neuropsychologists",
    "description": "Assess and diagnose patients with neurobehavioral problems related to acquired or developmental disorders of the nervous system, such as neurodegenerative disorders, traumatic brain injury, seizure disorders, and learning disabilities. Recommend treatment after diagnosis, such as therapy, medication, or surgery. Assist with evaluation before and after neurosurgical procedures, such as deep brain stimulation.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "19-3041.00",
    "name": "Sociologists",
    "description": "Study human society and social behavior by examining the groups and social institutions that people form, as well as various social, religious, political, and business organizations. May study the behavior and interaction of groups, trace their origin and growth, and analyze the influence of group activities on individual members.",
    "hourlyIncome": 54,
    "annualIncome": 111670,
    "careerGrowth": 6.9,
    "jobZone": 5
  },
  {
    "code": "19-3051.00",
    "name": "Urban and Regional Planners",
    "description": "Develop comprehensive plans and programs for use of land and physical facilities of jurisdictions, such as towns, cities, counties, and metropolitan areas.",
    "hourlyIncome": 43,
    "annualIncome": 89730,
    "careerGrowth": 4.3,
    "jobZone": 5
  },
  {
    "code": "19-3091.00",
    "name": "Anthropologists and Archeologists",
    "description": "Study the origin, development, and behavior of human beings. May study the way of life, language, or physical characteristics of people in various parts of the world. May engage in systematic recovery and examination of material evidence, such as tools or pottery remaining from past human cultures, in order to determine the history, customs, and living habits of earlier civilizations.",
    "hourlyIncome": 34,
    "annualIncome": 71070,
    "careerGrowth": 7.8,
    "jobZone": 5
  },
  {
    "code": "19-3092.00",
    "name": "Geographers",
    "description": "Study the nature and use of areas of the Earth's surface, relating and interpreting interactions of physical and cultural phenomena. Conduct research on physical aspects of a region, including land forms, climates, soils, plants, and animals, and conduct research on the spatial implications of human activities within a given area, including social characteristics, economic activities, and political organization, as well as researching interdependence between regions at scales ranging from local to global.",
    "hourlyIncome": 47,
    "annualIncome": 98160,
    "careerGrowth": 2.5,
    "jobZone": 4
  },
  {
    "code": "19-3093.00",
    "name": "Historians",
    "description": "Research, analyze, record, and interpret the past as recorded in sources, such as government and institutional records, newspapers and other periodicals, photographs, interviews, films, electronic media, and unpublished manuscripts, such as personal diaries and letters.",
    "hourlyIncome": 38,
    "annualIncome": 78470,
    "careerGrowth": 5.7,
    "jobZone": 5
  },
  {
    "code": "19-3094.00",
    "name": "Political Scientists",
    "description": "Study the origin, development, and operation of political systems. May study topics, such as public opinion, political decisionmaking, and ideology. May analyze the structure and operation of governments, as well as various political entities. May conduct public opinion surveys, analyze election results, or analyze public documents.",
    "hourlyIncome": 66,
    "annualIncome": 137600,
    "careerGrowth": 2.6,
    "jobZone": 5
  },
  {
    "code": "19-3099.00",
    "name": "Social Scientists and Related Workers, All Other",
    "description": "All social scientists and related workers not listed separately.",
    "hourlyIncome": 51,
    "annualIncome": 106440,
    "careerGrowth": 3.4,
    "jobZone": null
  },
  {
    "code": "19-3099.01",
    "name": "Transportation Planners",
    "description": "Prepare studies for proposed transportation projects. Gather, compile, and analyze data. Study the use and operation of transportation systems. Develop transportation models or simulations.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "19-4012.00",
    "name": "Agricultural Technicians",
    "description": "Work with agricultural scientists in plant, fiber, and animal research, or assist with animal breeding and nutrition. Set up or maintain laboratory equipment and collect samples from crops or animals. Prepare specimens or record data to assist scientists in biology or related life science experiments. Conduct tests and experiments to improve yield and quality of crops or to increase the resistance of plants and animals to disease or insects.",
    "hourlyIncome": 24,
    "annualIncome": 49680,
    "careerGrowth": 5.9,
    "jobZone": 3
  },
  {
    "code": "19-4012.01",
    "name": "Precision Agriculture Technicians",
    "description": "Apply geospatial technologies, including geographic information systems (GIS) and Global Positioning System (GPS), to agricultural production or management activities, such as pest scouting, site-specific pesticide application, yield mapping, or variable-rate irrigation. May use computers to develop or analyze maps or remote sensing images to compare physical topography with data on soils, fertilizer, pests, or weather.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "19-4013.00",
    "name": "Food Science Technicians",
    "description": "Work with food scientists or technologists to perform standardized qualitative and quantitative tests to determine physical or chemical properties of food or beverage products. Includes technicians who assist in research and development of production technology, quality control, packaging, processing, and use of foods.",
    "hourlyIncome": 26,
    "annualIncome": 54400,
    "careerGrowth": 7.3,
    "jobZone": 3
  },
  {
    "code": "19-4021.00",
    "name": "Biological Technicians",
    "description": "Assist biological and medical scientists. Set up, operate, and maintain laboratory instruments and equipment, monitor experiments, collect data and samples, make observations, and calculate and record results. May analyze organic substances, such as blood, food, and drugs.",
    "hourlyIncome": 28,
    "annualIncome": 58020,
    "careerGrowth": 6.6,
    "jobZone": 4
  },
  {
    "code": "19-4031.00",
    "name": "Chemical Technicians",
    "description": "Conduct chemical and physical laboratory tests to assist scientists in making qualitative and quantitative analyses of solids, liquids, and gaseous materials for research and development of new products or processes, quality control, maintenance of environmental standards, and other work involving experimental, theoretical, or practical application of chemistry and related sciences.",
    "hourlyIncome": 29,
    "annualIncome": 61300,
    "careerGrowth": 5.5,
    "jobZone": 3
  },
  {
    "code": "19-4042.00",
    "name": "Environmental Science and Protection Technicians, Including Health",
    "description": "Perform laboratory and field tests to monitor the environment and investigate sources of pollution, including those that affect health, under the direction of an environmental scientist, engineer, or other specialist. May collect samples of gases, soil, water, and other materials for testing.",
    "hourlyIncome": 27,
    "annualIncome": 56770,
    "careerGrowth": 7,
    "jobZone": 4
  },
  {
    "code": "19-4043.00",
    "name": "Geological Technicians, Except Hydrologic Technicians",
    "description": "Assist scientists or engineers in the use of electronic, sonic, or nuclear measuring instruments in laboratory, exploration, and production activities to obtain data indicating resources such as metallic ore, minerals, gas, coal, or petroleum. Analyze mud and drill cuttings. Chart pressure, temperature, and other characteristics of wells or bore holes.",
    "hourlyIncome": 28,
    "annualIncome": 58220,
    "careerGrowth": 3.8,
    "jobZone": 4
  },
  {
    "code": "19-4044.00",
    "name": "Hydrologic Technicians",
    "description": "Collect and organize data concerning the distribution and circulation of ground and surface water, and data on its physical, chemical, and biological properties. Measure and report on flow rates and ground water levels, maintain field equipment, collect water samples, install and collect sampling equipment, and process samples for shipment to testing laboratories. May collect data on behalf of hydrologists, engineers, developers, government agencies, or agriculture.",
    "hourlyIncome": 31,
    "annualIncome": 64410,
    "careerGrowth": 2.4,
    "jobZone": 3
  },
  {
    "code": "19-4051.00",
    "name": "Nuclear Technicians",
    "description": "Assist nuclear physicists, nuclear engineers, or other scientists in laboratory, power generation, or electricity production activities. May operate, maintain, or provide quality control for nuclear testing and research equipment. May monitor radiation.",
    "hourlyIncome": 48,
    "annualIncome": 100730,
    "careerGrowth": -6.2,
    "jobZone": 3
  },
  {
    "code": "19-4051.02",
    "name": "Nuclear Monitoring Technicians",
    "description": "Collect and test samples to monitor results of nuclear experiments and contamination of humans, facilities, and environment.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "19-4061.00",
    "name": "Social Science Research Assistants",
    "description": "Assist social scientists in laboratory, survey, and other social science research. May help prepare findings for publication and assist in laboratory analysis, quality control, or data management.",
    "hourlyIncome": 31,
    "annualIncome": 63560,
    "careerGrowth": 6.3,
    "jobZone": 4
  },
  {
    "code": "19-4071.00",
    "name": "Forest and Conservation Technicians",
    "description": "Provide technical assistance regarding the conservation of soil, water, forests, or related natural resources. May compile data pertaining to size, content, condition, and other characteristics of forest tracts under the direction of foresters, or train and lead forest workers in forest propagation and fire prevention and suppression. May assist conservation scientists in managing, improving, and protecting rangelands and wildlife habitats.",
    "hourlyIncome": 27,
    "annualIncome": 56660,
    "careerGrowth": 1.7,
    "jobZone": 3
  },
  {
    "code": "19-4092.00",
    "name": "Forensic Science Technicians",
    "description": "Collect, identify, classify, and analyze physical evidence related to criminal investigations. Perform tests on weapons or substances, such as fiber, hair, and tissue to determine significance to investigation. May testify as expert witnesses on evidence or crime laboratory techniques. May serve as specialists in area of expertise, such as ballistics, fingerprinting, handwriting, or biochemistry.",
    "hourlyIncome": 36,
    "annualIncome": 75260,
    "careerGrowth": 13.6,
    "jobZone": 3
  },
  {
    "code": "19-4099.00",
    "name": "Life, Physical, and Social Science Technicians, All Other",
    "description": "All life, physical, and social science technicians not listed separately.",
    "hourlyIncome": 31,
    "annualIncome": 64640,
    "careerGrowth": 5.8,
    "jobZone": null
  },
  {
    "code": "19-4099.01",
    "name": "Quality Control Analysts",
    "description": "Conduct tests to determine quality of raw materials, bulk intermediate and finished products. May conduct stability sample tests.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "19-4099.03",
    "name": "Remote Sensing Technicians",
    "description": "Apply remote sensing technologies to assist scientists in areas such as natural resources, urban planning, or homeland security. May prepare flight plans or sensor configurations for flight trips.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "19-5011.00",
    "name": "Occupational Health and Safety Specialists",
    "description": "Review, evaluate, and analyze work environments and design programs and procedures to control, eliminate, and prevent disease or injury caused by chemical, physical, and biological agents or ergonomic factors. May conduct inspections and enforce adherence to laws and regulations governing the health and safety of individuals. May be employed in the public or private sector.",
    "hourlyIncome": 43,
    "annualIncome": 88660,
    "careerGrowth": 14.9,
    "jobZone": 4
  },
  {
    "code": "19-5012.00",
    "name": "Occupational Health and Safety Technicians",
    "description": "Collect data on work environments for analysis by occupational health and safety specialists. Implement and conduct evaluation of programs designed to limit chemical, physical, biological, and ergonomic risks to workers.",
    "hourlyIncome": 31,
    "annualIncome": 63800,
    "careerGrowth": 11.4,
    "jobZone": 3
  },
  {
    "code": "21-1011.00",
    "name": "Substance Abuse and Behavioral Disorder Counselors",
    "description": "Counsel and advise individuals with alcohol, tobacco, drug, or other problems, such as gambling and eating disorders. May counsel individuals, families, or groups or engage in prevention programs.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "21-1012.00",
    "name": "Educational, Guidance, and Career Counselors and Advisors",
    "description": "Advise and assist students and provide educational and vocational guidance services.",
    "hourlyIncome": 34,
    "annualIncome": 71520,
    "careerGrowth": 4.5,
    "jobZone": 5
  },
  {
    "code": "21-1013.00",
    "name": "Marriage and Family Therapists",
    "description": "Diagnose and treat mental and emotional disorders, whether cognitive, affective, or behavioral, within the context of marriage and family systems. Apply psychotherapeutic and family systems theories and techniques in the delivery of services to individuals, couples, and families for the purpose of treating such diagnosed nervous and mental disorders.",
    "hourlyIncome": 35,
    "annualIncome": 72720,
    "careerGrowth": 16.2,
    "jobZone": 5
  },
  {
    "code": "21-1014.00",
    "name": "Mental Health Counselors",
    "description": "Counsel and advise individuals and groups to promote optimum mental and emotional health, with an emphasis on prevention. May help individuals deal with a broad range of mental health issues, such as those associated with addictions and substance abuse; family, parenting, and marital problems; stress management; self-esteem; or aging.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "21-1015.00",
    "name": "Rehabilitation Counselors",
    "description": "Counsel individuals to maximize the independence and employability of persons coping with personal, social, and vocational difficulties that result from birth defects, illness, disease, accidents, aging, or the stress of daily life. Coordinate activities for residents of care and treatment facilities. Assess client needs and design and implement rehabilitation programs that may include personal and vocational counseling, training, and job placement.",
    "hourlyIncome": 25,
    "annualIncome": 51260,
    "careerGrowth": 1.8,
    "jobZone": 4
  },
  {
    "code": "21-1019.00",
    "name": "Counselors, All Other",
    "description": "All counselors not listed separately.",
    "hourlyIncome": 28,
    "annualIncome": 58070,
    "careerGrowth": 14.4,
    "jobZone": null
  },
  {
    "code": "21-1021.00",
    "name": "Child, Family, and School Social Workers",
    "description": "Provide social services and assistance to improve the social and psychological functioning of children and their families and to maximize the family well-being and the academic functioning of children. May assist parents, arrange adoptions, and find foster homes for abandoned or abused children. In schools, they address such problems as teenage pregnancy, misbehavior, and truancy. May also advise teachers.",
    "hourlyIncome": 30,
    "annualIncome": 62920,
    "careerGrowth": 4.9,
    "jobZone": 4
  },
  {
    "code": "21-1022.00",
    "name": "Healthcare Social Workers",
    "description": "Provide individuals, families, and groups with the psychosocial support needed to cope with chronic, acute, or terminal illnesses. Services include advising family caregivers. Provide patients with information and counseling, and make referrals for other services. May also provide case and care management or interventions designed to promote health, prevent disease, and address barriers to access to healthcare.",
    "hourlyIncome": 35,
    "annualIncome": 72030,
    "careerGrowth": 9.7,
    "jobZone": 5
  },
  {
    "code": "21-1023.00",
    "name": "Mental Health and Substance Abuse Social Workers",
    "description": "Assess and treat individuals with mental, emotional, or substance abuse problems, including abuse of alcohol, tobacco, and/or other drugs. Activities may include individual and group therapy, crisis intervention, case management, client advocacy, prevention, and education.",
    "hourlyIncome": 33,
    "annualIncome": 68290,
    "careerGrowth": 11.6,
    "jobZone": 5
  },
  {
    "code": "21-1029.00",
    "name": "Social Workers, All Other",
    "description": "All social workers not listed separately.",
    "hourlyIncome": 36,
    "annualIncome": 74680,
    "careerGrowth": 5.5,
    "jobZone": null
  },
  {
    "code": "21-1091.00",
    "name": "Health Education Specialists",
    "description": "Provide and manage health education programs that help individuals, families, and their communities maximize and maintain healthy lifestyles. Use data to identify community needs prior to planning, implementing, monitoring, and evaluating programs designed to encourage healthy lifestyles, policies, and environments. May link health systems, health providers, insurers, and patients to address individual and population health needs. May serve as resource to assist individuals, other health professionals, or the community, and may administer fiscal resources for health education programs.",
    "hourlyIncome": 34,
    "annualIncome": 71700,
    "careerGrowth": 7,
    "jobZone": 4
  },
  {
    "code": "21-1092.00",
    "name": "Probation Officers and Correctional Treatment Specialists",
    "description": "Provide social services to assist in rehabilitation of law offenders in custody or on probation or parole. Make recommendations for actions involving formulation of rehabilitation plan and treatment of offender, including conditional release and education and employment stipulations.",
    "hourlyIncome": 34,
    "annualIncome": 71530,
    "careerGrowth": 3.6,
    "jobZone": 4
  },
  {
    "code": "21-1093.00",
    "name": "Social and Human Service Assistants",
    "description": "Assist other social and human service providers in providing client services in a wide variety of fields, such as psychology, rehabilitation, or social work, including support for families. May assist clients in identifying and obtaining available benefits and social and community services. May assist social workers with developing, organizing, and conducting programs to prevent and resolve problems relevant to substance abuse, human relationships, rehabilitation, or dependent care.",
    "hourlyIncome": 23,
    "annualIncome": 47090,
    "careerGrowth": 7.9,
    "jobZone": 4
  },
  {
    "code": "21-1094.00",
    "name": "Community Health Workers",
    "description": "Promote health within a community by assisting individuals to adopt healthy behaviors. Serve as an advocate for the health needs of individuals by assisting community residents in effectively communicating with healthcare providers or social service agencies. Act as liaison or advocate and implement programs that promote, maintain, and improve individual and overall community health. May deliver health-related preventive services such as blood pressure, glaucoma, and hearing screenings. May collect data to help identify community health needs.",
    "hourlyIncome": 27,
    "annualIncome": 55970,
    "careerGrowth": 13.1,
    "jobZone": 4
  },
  {
    "code": "21-1099.00",
    "name": "Community and Social Service Specialists, All Other",
    "description": "All community and social service specialists not listed separately.",
    "hourlyIncome": 28,
    "annualIncome": 58360,
    "careerGrowth": 5.9,
    "jobZone": null
  },
  {
    "code": "21-2011.00",
    "name": "Clergy",
    "description": "Conduct religious worship and perform other spiritual functions associated with beliefs and practices of religious faith or denomination. Provide spiritual and moral guidance and assistance to members.",
    "hourlyIncome": 32,
    "annualIncome": 67160,
    "careerGrowth": 2.5,
    "jobZone": 5
  },
  {
    "code": "21-2021.00",
    "name": "Directors, Religious Activities and Education",
    "description": "Coordinate or design programs and conduct outreach to promote the religious education or activities of a denominational group. May provide counseling, guidance, and leadership relative to marital, health, financial, and religious problems.",
    "hourlyIncome": 31,
    "annualIncome": 65040,
    "careerGrowth": 2.2,
    "jobZone": 4
  },
  {
    "code": "21-2099.00",
    "name": "Religious Workers, All Other",
    "description": "All religious workers not listed separately.",
    "hourlyIncome": 24,
    "annualIncome": 49830,
    "careerGrowth": 2.2,
    "jobZone": null
  },
  {
    "code": "23-1011.00",
    "name": "Lawyers",
    "description": "Represent clients in criminal and civil litigation and other legal proceedings, draw up legal documents, or manage or advise clients on legal transactions. May specialize in a single area or may practice broadly in many areas of law.",
    "hourlyIncome": 88,
    "annualIncome": 182760,
    "careerGrowth": 5.2,
    "jobZone": 5
  },
  {
    "code": "23-1012.00",
    "name": "Judicial Law Clerks",
    "description": "Assist judges in court or by conducting research or preparing legal documents.",
    "hourlyIncome": 34,
    "annualIncome": 69850,
    "careerGrowth": 3.4,
    "jobZone": 5
  },
  {
    "code": "23-1021.00",
    "name": "Administrative Law Judges, Adjudicators, and Hearing Officers",
    "description": "Conduct hearings to recommend or make decisions on claims concerning government programs or other government-related matters. Determine liability, sanctions, or penalties, or recommend the acceptance or rejection of claims or settlements.",
    "hourlyIncome": 59,
    "annualIncome": 122620,
    "careerGrowth": 2.1,
    "jobZone": 5
  },
  {
    "code": "23-1022.00",
    "name": "Arbitrators, Mediators, and Conciliators",
    "description": "Facilitate negotiation and conflict resolution through dialogue. Resolve conflicts outside of the court system by mutual consent of parties involved.",
    "hourlyIncome": 44,
    "annualIncome": 91170,
    "careerGrowth": 6.1,
    "jobZone": 5
  },
  {
    "code": "23-1023.00",
    "name": "Judges, Magistrate Judges, and Magistrates",
    "description": "Arbitrate, advise, adjudicate, or administer justice in a court of law. May sentence defendant in criminal cases according to government statutes or sentencing guidelines. May determine liability of defendant in civil cases. May perform wedding ceremonies.",
    "hourlyIncome": 69,
    "annualIncome": 143110,
    "careerGrowth": 3.4,
    "jobZone": 5
  },
  {
    "code": "23-2011.00",
    "name": "Paralegals and Legal Assistants",
    "description": "Assist lawyers by investigating facts, preparing legal documents, or researching legal precedent. Conduct research to support a legal proceeding, to formulate a defense, or to initiate legal action.",
    "hourlyIncome": 32,
    "annualIncome": 66510,
    "careerGrowth": 1.2,
    "jobZone": 3
  },
  {
    "code": "23-2093.00",
    "name": "Title Examiners, Abstractors, and Searchers",
    "description": "Search real estate records, examine titles, or summarize pertinent legal or insurance documents or details for a variety of purposes. May compile lists of mortgages, contracts, and other instruments pertaining to titles by searching public and private records for law firms, real estate agencies, or title insurance companies.",
    "hourlyIncome": 29,
    "annualIncome": 59600,
    "careerGrowth": 1,
    "jobZone": 2
  },
  {
    "code": "23-2099.00",
    "name": "Legal Support Workers, All Other",
    "description": "All legal support workers not listed separately.",
    "hourlyIncome": 41,
    "annualIncome": 86220,
    "careerGrowth": 1,
    "jobZone": null
  },
  {
    "code": "25-1011.00",
    "name": "Business Teachers, Postsecondary",
    "description": "Teach courses in business administration and management, such as accounting, finance, human resources, labor and industrial relations, marketing, and operations research. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 113840,
    "careerGrowth": 6.7,
    "jobZone": 5
  },
  {
    "code": "25-1021.00",
    "name": "Computer Science Teachers, Postsecondary",
    "description": "Teach courses in computer science. May specialize in a field of computer science, such as the design and function of computers or operations and research analysis. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 105830,
    "careerGrowth": 6.1,
    "jobZone": 5
  },
  {
    "code": "25-1022.00",
    "name": "Mathematical Science Teachers, Postsecondary",
    "description": "Teach courses pertaining to mathematical concepts, statistics, and actuarial science and to the application of original and standardized mathematical techniques in solving specific problems and situations. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 92880,
    "careerGrowth": 3.3,
    "jobZone": 5
  },
  {
    "code": "25-1031.00",
    "name": "Architecture Teachers, Postsecondary",
    "description": "Teach courses in architecture and architectural design, such as architectural environmental design, interior architecture/design, and landscape architecture. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 110360,
    "careerGrowth": 3.2,
    "jobZone": 5
  },
  {
    "code": "25-1032.00",
    "name": "Engineering Teachers, Postsecondary",
    "description": "Teach courses pertaining to the application of physical laws and principles of engineering for the development of machines, materials, instruments, processes, and services. Includes teachers of subjects such as chemical, civil, electrical, industrial, mechanical, mineral, and petroleum engineering. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 119340,
    "careerGrowth": 9.2,
    "jobZone": 5
  },
  {
    "code": "25-1041.00",
    "name": "Agricultural Sciences Teachers, Postsecondary",
    "description": "Teach courses in the agricultural sciences. Includes teachers of agronomy, dairy sciences, fisheries management, horticultural sciences, poultry sciences, range management, and agricultural soil conservation. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 97790,
    "careerGrowth": 4.8,
    "jobZone": 5
  },
  {
    "code": "25-1042.00",
    "name": "Biological Science Teachers, Postsecondary",
    "description": "Teach courses in biological sciences. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 101340,
    "careerGrowth": 8.4,
    "jobZone": 5
  },
  {
    "code": "25-1043.00",
    "name": "Forestry and Conservation Science Teachers, Postsecondary",
    "description": "Teach courses in forestry and conservation science. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 103780,
    "careerGrowth": 5,
    "jobZone": 5
  },
  {
    "code": "25-1051.00",
    "name": "Atmospheric, Earth, Marine, and Space Sciences Teachers, Postsecondary",
    "description": "Teach courses in the physical sciences, except chemistry and physics. Includes both teachers primarily engaged in teaching, and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 112950,
    "careerGrowth": 3.8,
    "jobZone": 5
  },
  {
    "code": "25-1052.00",
    "name": "Chemistry Teachers, Postsecondary",
    "description": "Teach courses pertaining to the chemical and physical properties and compositional changes of substances. Work may include providing instruction in the methods of qualitative and quantitative chemical analysis. Includes both teachers primarily engaged in teaching, and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 103030,
    "careerGrowth": 3.4,
    "jobZone": 5
  },
  {
    "code": "25-1053.00",
    "name": "Environmental Science Teachers, Postsecondary",
    "description": "Teach courses in environmental science. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 100360,
    "careerGrowth": 3.9,
    "jobZone": 5
  },
  {
    "code": "25-1054.00",
    "name": "Physics Teachers, Postsecondary",
    "description": "Teach courses pertaining to the laws of matter and energy. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 105460,
    "careerGrowth": 3.7,
    "jobZone": 5
  },
  {
    "code": "25-1061.00",
    "name": "Anthropology and Archeology Teachers, Postsecondary",
    "description": "Teach courses in anthropology or archeology. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 102530,
    "careerGrowth": 3.8,
    "jobZone": 5
  },
  {
    "code": "25-1062.00",
    "name": "Area, Ethnic, and Cultural Studies Teachers, Postsecondary",
    "description": "Teach courses pertaining to the culture and development of an area, an ethnic group, or any other group, such as Latin American studies, women's studies, or urban affairs. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 97350,
    "careerGrowth": 3.6,
    "jobZone": 5
  },
  {
    "code": "25-1063.00",
    "name": "Economics Teachers, Postsecondary",
    "description": "Teach courses in economics. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 133140,
    "careerGrowth": 3.5,
    "jobZone": 5
  },
  {
    "code": "25-1064.00",
    "name": "Geography Teachers, Postsecondary",
    "description": "Teach courses in geography. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 99020,
    "careerGrowth": 4.3,
    "jobZone": 5
  },
  {
    "code": "25-1065.00",
    "name": "Political Science Teachers, Postsecondary",
    "description": "Teach courses in political science, international affairs, and international relations. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 105160,
    "careerGrowth": 3.3,
    "jobZone": 5
  },
  {
    "code": "25-1066.00",
    "name": "Psychology Teachers, Postsecondary",
    "description": "Teach courses in psychology, such as child, clinical, and developmental psychology, and psychological counseling. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 93530,
    "careerGrowth": 5,
    "jobZone": 5
  },
  {
    "code": "25-1067.00",
    "name": "Sociology Teachers, Postsecondary",
    "description": "Teach courses in sociology. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 97270,
    "careerGrowth": 3.4,
    "jobZone": 5
  },
  {
    "code": "25-1069.00",
    "name": "Social Sciences Teachers, Postsecondary, All Other",
    "description": "All postsecondary social sciences teachers not listed separately.",
    "hourlyIncome": null,
    "annualIncome": 92950,
    "careerGrowth": 2.7,
    "jobZone": null
  },
  {
    "code": "25-1071.00",
    "name": "Health Specialties Teachers, Postsecondary",
    "description": "Teach courses in health specialties, in fields such as dentistry, laboratory technology, medicine, pharmacy, public health, therapy, and veterinary medicine.",
    "hourlyIncome": null,
    "annualIncome": 137900,
    "careerGrowth": 18.8,
    "jobZone": 5
  },
  {
    "code": "25-1072.00",
    "name": "Nursing Instructors and Teachers, Postsecondary",
    "description": "Demonstrate and teach patient care in classroom and clinical units to nursing students. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 87090,
    "careerGrowth": 17.9,
    "jobZone": 5
  },
  {
    "code": "25-1081.00",
    "name": "Education Teachers, Postsecondary",
    "description": "Teach courses pertaining to education, such as counseling, curriculum, guidance, instruction, teacher education, and teaching English as a second language. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 78500,
    "careerGrowth": 3.3,
    "jobZone": 5
  },
  {
    "code": "25-1082.00",
    "name": "Library Science Teachers, Postsecondary",
    "description": "Teach courses in library science. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 84320,
    "careerGrowth": 4.2,
    "jobZone": 5
  },
  {
    "code": "25-1111.00",
    "name": "Criminal Justice and Law Enforcement Teachers, Postsecondary",
    "description": "Teach courses in criminal justice, corrections, and law enforcement administration. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 84820,
    "careerGrowth": 2.9,
    "jobZone": 5
  },
  {
    "code": "25-1112.00",
    "name": "Law Teachers, Postsecondary",
    "description": "Teach courses in law. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 139950,
    "careerGrowth": 2.2,
    "jobZone": 5
  },
  {
    "code": "25-1113.00",
    "name": "Social Work Teachers, Postsecondary",
    "description": "Teach courses in social work. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 81880,
    "careerGrowth": 3.6,
    "jobZone": 5
  },
  {
    "code": "25-1121.00",
    "name": "Art, Drama, and Music Teachers, Postsecondary",
    "description": "Teach courses in drama, music, and the arts including fine and applied art, such as painting and sculpture, or design and crafts. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 102240,
    "careerGrowth": 2.7,
    "jobZone": 5
  },
  {
    "code": "25-1122.00",
    "name": "Communications Teachers, Postsecondary",
    "description": "Teach courses in communications, such as organizational communications, public relations, radio/television broadcasting, and journalism. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 90340,
    "careerGrowth": 3.3,
    "jobZone": 5
  },
  {
    "code": "25-1123.00",
    "name": "English Language and Literature Teachers, Postsecondary",
    "description": "Teach courses in English language and literature, including linguistics and comparative literature. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 90400,
    "careerGrowth": 1.1,
    "jobZone": 5
  },
  {
    "code": "25-1124.00",
    "name": "Foreign Language and Literature Teachers, Postsecondary",
    "description": "Teach languages and literature courses in languages other than English. Includes teachers of American Sign Language (ASL). Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 87670,
    "careerGrowth": 1,
    "jobZone": 5
  },
  {
    "code": "25-1125.00",
    "name": "History Teachers, Postsecondary",
    "description": "Teach courses in human history and historiography. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 93710,
    "careerGrowth": 0.9,
    "jobZone": 5
  },
  {
    "code": "25-1126.00",
    "name": "Philosophy and Religion Teachers, Postsecondary",
    "description": "Teach courses in philosophy, religion, and theology. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 88210,
    "careerGrowth": 2,
    "jobZone": 5
  },
  {
    "code": "25-1192.00",
    "name": "Family and Consumer Sciences Teachers, Postsecondary",
    "description": "Teach courses in childcare, family relations, finance, nutrition, and related subjects pertaining to home management. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 84450,
    "careerGrowth": 4.3,
    "jobZone": 5
  },
  {
    "code": "25-1193.00",
    "name": "Recreation and Fitness Studies Teachers, Postsecondary",
    "description": "Teach courses pertaining to recreation, leisure, and fitness studies, including exercise physiology and facilities management. Includes both teachers primarily engaged in teaching and those who do a combination of teaching and research.",
    "hourlyIncome": null,
    "annualIncome": 87980,
    "careerGrowth": 3.4,
    "jobZone": 5
  },
  {
    "code": "25-1194.00",
    "name": "Career/Technical Education Teachers, Postsecondary",
    "description": "Teach vocational courses intended to provide occupational training below the baccalaureate level in subjects such as construction, mechanics/repair, manufacturing, transportation, or cosmetology, primarily to students who have graduated from or left high school. Teaching takes place in public or private schools whose primary business is academic or vocational education.",
    "hourlyIncome": 33,
    "annualIncome": 68710,
    "careerGrowth": 0.1,
    "jobZone": 3
  },
  {
    "code": "25-1199.00",
    "name": "Postsecondary Teachers, All Other",
    "description": "All postsecondary teachers not listed separately.",
    "hourlyIncome": null,
    "annualIncome": 94470,
    "careerGrowth": 3.2,
    "jobZone": null
  },
  {
    "code": "25-2011.00",
    "name": "Preschool Teachers, Except Special Education",
    "description": "Instruct preschool-aged students, following curricula or lesson plans, in activities designed to promote social, physical, and intellectual growth.",
    "hourlyIncome": null,
    "annualIncome": 41450,
    "careerGrowth": 4.4,
    "jobZone": 3
  },
  {
    "code": "25-2012.00",
    "name": "Kindergarten Teachers, Except Special Education",
    "description": "Teach academic and social skills to kindergarten students.",
    "hourlyIncome": null,
    "annualIncome": 67020,
    "careerGrowth": -0.7,
    "jobZone": 4
  },
  {
    "code": "25-2021.00",
    "name": "Elementary School Teachers, Except Special Education",
    "description": "Teach academic and social skills to students at the elementary school level.",
    "hourlyIncome": null,
    "annualIncome": 69790,
    "careerGrowth": -0.7,
    "jobZone": 4
  },
  {
    "code": "25-2022.00",
    "name": "Middle School Teachers, Except Special and Career/Technical Education",
    "description": "Teach one or more subjects to students at the middle, intermediate, or junior high school level.",
    "hourlyIncome": null,
    "annualIncome": 70040,
    "careerGrowth": -0.7,
    "jobZone": 4
  },
  {
    "code": "25-2023.00",
    "name": "Career/Technical Education Teachers, Middle School",
    "description": "Teach occupational, vocational, career, or technical subjects to students at the middle, intermediate, or junior high school level.",
    "hourlyIncome": null,
    "annualIncome": 68690,
    "careerGrowth": -0.9,
    "jobZone": 4
  },
  {
    "code": "25-2031.00",
    "name": "Secondary School Teachers, Except Special and Career/Technical Education",
    "description": "Teach one or more subjects to students at the secondary school level.",
    "hourlyIncome": null,
    "annualIncome": 73700,
    "careerGrowth": -0.6,
    "jobZone": 4
  },
  {
    "code": "25-2032.00",
    "name": "Career/Technical Education Teachers, Secondary School",
    "description": "Teach occupational, vocational, career, or technical subjects to students at the secondary school level.",
    "hourlyIncome": null,
    "annualIncome": 70550,
    "careerGrowth": -0.8,
    "jobZone": 4
  },
  {
    "code": "25-2051.00",
    "name": "Special Education Teachers, Preschool",
    "description": "Teach academic, social, and life skills to preschool-aged students with learning, emotional, or physical disabilities. Includes teachers who specialize and work with students who are blind or have visual impairments; students who are deaf or have hearing impairments; and students with intellectual disabilities.",
    "hourlyIncome": null,
    "annualIncome": 72610,
    "careerGrowth": 1.6,
    "jobZone": 5
  },
  {
    "code": "25-2055.00",
    "name": "Special Education Teachers, Kindergarten",
    "description": "Teach academic, social, and life skills to kindergarten students with learning, emotional, or physical disabilities. Includes teachers who specialize and work with students who are blind or have visual impairments; students who are deaf or have hearing impairments; and students with intellectual disabilities.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "25-2056.00",
    "name": "Special Education Teachers, Elementary School",
    "description": "Teach academic, social, and life skills to elementary school students with learning, emotional, or physical disabilities. Includes teachers who specialize and work with students who are blind or have visual impairments; students who are deaf or have hearing impairments; and students with intellectual disabilities.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "25-2057.00",
    "name": "Special Education Teachers, Middle School",
    "description": "Teach academic, social, and life skills to middle school students with learning, emotional, or physical disabilities. Includes teachers who specialize and work with students who are blind or have visual impairments; students who are deaf or have hearing impairments; and students with intellectual disabilities.",
    "hourlyIncome": null,
    "annualIncome": 72310,
    "careerGrowth": -0.9,
    "jobZone": 4
  },
  {
    "code": "25-2058.00",
    "name": "Special Education Teachers, Secondary School",
    "description": "Teach academic, social, and life skills to secondary school students with learning, emotional, or physical disabilities. Includes teachers who specialize and work with students who are blind or have visual impairments; students who are deaf or have hearing impairments; and students with intellectual disabilities.",
    "hourlyIncome": null,
    "annualIncome": 74610,
    "careerGrowth": -0.6,
    "jobZone": 4
  },
  {
    "code": "25-2059.00",
    "name": "Special Education Teachers, All Other",
    "description": "All special education teachers not listed separately.",
    "hourlyIncome": null,
    "annualIncome": 74180,
    "careerGrowth": 2.1,
    "jobZone": null
  },
  {
    "code": "25-2059.01",
    "name": "Adapted Physical Education Specialists",
    "description": "Provide individualized physical education instruction or services to children, youth, or adults with exceptional physical needs due to gross motor developmental delays or other impairments.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "25-3011.00",
    "name": "Adult Basic Education, Adult Secondary Education, and English as a Second Language Instructors",
    "description": "Teach or instruct out-of-school youths and adults in basic education, literacy, or English as a Second Language classes, or in classes for earning a high school equivalency credential.",
    "hourlyIncome": 31,
    "annualIncome": 64660,
    "careerGrowth": -12.7,
    "jobZone": 4
  },
  {
    "code": "25-3021.00",
    "name": "Self-Enrichment Teachers",
    "description": "Teach or instruct individuals or groups for the primary purpose of self-enrichment or recreation, rather than for an occupational objective, educational attainment, competition, or fitness.",
    "hourlyIncome": 26,
    "annualIncome": 53330,
    "careerGrowth": 3.4,
    "jobZone": 3
  },
  {
    "code": "25-3031.00",
    "name": "Substitute Teachers, Short-Term",
    "description": "Teach students on a short-term basis as a temporary replacement for a regular classroom teacher, typically using the regular teacher's lesson plan.",
    "hourlyIncome": 22,
    "annualIncome": 44930,
    "careerGrowth": 3.4,
    "jobZone": 4
  },
  {
    "code": "25-3041.00",
    "name": "Tutors",
    "description": "Instruct individual students or small groups of students in academic subjects to support formal class instruction or to prepare students for standardized or admissions tests.",
    "hourlyIncome": 23,
    "annualIncome": 47780,
    "careerGrowth": 0.7,
    "jobZone": 3
  },
  {
    "code": "25-3099.00",
    "name": "Teachers and Instructors, All Other",
    "description": "All teachers and instructors not listed separately.",
    "hourlyIncome": null,
    "annualIncome": 71610,
    "careerGrowth": 1.4,
    "jobZone": null
  },
  {
    "code": "25-4011.00",
    "name": "Archivists",
    "description": "Appraise, edit, and direct safekeeping of permanent records and historically valuable documents. Participate in research activities based on archival materials.",
    "hourlyIncome": 33,
    "annualIncome": 67620,
    "careerGrowth": 8,
    "jobZone": 5
  },
  {
    "code": "25-4012.00",
    "name": "Curators",
    "description": "Administer collections, such as artwork, collectibles, historic items, or scientific specimens of museums or other institutions. May conduct instructional, research, or public service activities of institution.",
    "hourlyIncome": 34,
    "annualIncome": 70060,
    "careerGrowth": 12.2,
    "jobZone": 5
  },
  {
    "code": "25-4013.00",
    "name": "Museum Technicians and Conservators",
    "description": "Restore, maintain, or prepare objects in museum collections for storage, research, or exhibit. May work with specimens such as fossils, skeletal parts, or botanicals; or artifacts, textiles, or art. May identify and record objects or install and arrange them in exhibits. Includes book or document conservators.",
    "hourlyIncome": 26,
    "annualIncome": 53630,
    "careerGrowth": 10.7,
    "jobZone": 4
  },
  {
    "code": "25-4022.00",
    "name": "Librarians and Media Collections Specialists",
    "description": "Administer and maintain libraries or collections of information, for public or private access through reference or borrowing. Work in a variety of settings, such as educational institutions, museums, and corporations, and with various types of informational materials, such as books, periodicals, recordings, films, and databases. Tasks may include acquiring, cataloging, and circulating library materials, and user services such as locating and organizing information, providing instruction on how to access information, and setting up and operating a library's media equipment.",
    "hourlyIncome": 33,
    "annualIncome": 69180,
    "careerGrowth": 2.9,
    "jobZone": 5
  },
  {
    "code": "25-4031.00",
    "name": "Library Technicians",
    "description": "Assist librarians by helping readers in the use of library catalogs, databases, and indexes to locate books and other materials; and by answering questions that require only brief consultation of standard reference. Compile records; sort and shelve books or other media; remove or repair damaged books or other media; register patrons; and check materials in and out of the circulation process. Replace materials in shelving area (stacks) or files. Includes bookmobile drivers who assist with providing services in mobile libraries.",
    "hourlyIncome": 21,
    "annualIncome": 43050,
    "careerGrowth": -5.6,
    "jobZone": 3
  },
  {
    "code": "25-9021.00",
    "name": "Farm and Home Management Educators",
    "description": "Instruct and advise individuals and families engaged in agriculture, agricultural-related processes, or home management activities. Demonstrate procedures and apply research findings to advance agricultural and home management activities. May develop educational outreach programs. May instruct on either agricultural issues such as agricultural processes and techniques, pest management, and food safety, or on home management issues such as budgeting, nutrition, and child development.",
    "hourlyIncome": 29,
    "annualIncome": 60470,
    "careerGrowth": -1.7,
    "jobZone": 5
  },
  {
    "code": "25-9031.00",
    "name": "Instructional Coordinators",
    "description": "Develop instructional material, coordinate educational content, and incorporate current technology into instruction in order to provide guidelines to educators and instructors for developing curricula and conducting courses. May train and coach teachers. Includes educational consultants and specialists, and instructional material directors.",
    "hourlyIncome": 37,
    "annualIncome": 77600,
    "careerGrowth": 1.8,
    "jobZone": 5
  },
  {
    "code": "25-9042.00",
    "name": "Teaching Assistants, Preschool, Elementary, Middle, and Secondary School, Except Special Education",
    "description": "Assist a preschool, elementary, middle, or secondary school teacher with instructional duties. Serve in a position for which a teacher has primary responsibility for the design and implementation of educational programs and services.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "25-9043.00",
    "name": "Teaching Assistants, Special Education",
    "description": "Assist a preschool, elementary, middle, or secondary school teacher to provide academic, social, or life skills to students who have learning, emotional, or physical disabilities. Serve in a position for which a teacher has primary responsibility for the design and implementation of educational programs and services.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "25-9044.00",
    "name": "Teaching Assistants, Postsecondary",
    "description": "Assist faculty or other instructional staff in postsecondary institutions by performing instructional support activities, such as developing teaching materials, leading discussion groups, preparing and giving examinations, and grading examinations or papers.",
    "hourlyIncome": null,
    "annualIncome": 47560,
    "careerGrowth": 4,
    "jobZone": 5
  },
  {
    "code": "25-9049.00",
    "name": "Teaching Assistants, All Other",
    "description": "All teaching assistants not listed separately.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "25-9099.00",
    "name": "Educational Instruction and Library Workers, All Other",
    "description": "All educational instruction and library workers not listed separately.",
    "hourlyIncome": 27,
    "annualIncome": 55700,
    "careerGrowth": 2,
    "jobZone": null
  },
  {
    "code": "27-1011.00",
    "name": "Art Directors",
    "description": "Formulate design concepts and presentation approaches for visual productions and media, such as print, broadcasting, video, and film. Direct workers engaged in artwork or layout design.",
    "hourlyIncome": 62,
    "annualIncome": 128100,
    "careerGrowth": 5.2,
    "jobZone": 4
  },
  {
    "code": "27-1012.00",
    "name": "Craft Artists",
    "description": "Create or reproduce handmade objects for sale and exhibition using a variety of techniques, such as welding, weaving, pottery, and needlecraft.",
    "hourlyIncome": 22,
    "annualIncome": 45340,
    "careerGrowth": 2.2,
    "jobZone": 3
  },
  {
    "code": "27-1013.00",
    "name": "Fine Artists, Including Painters, Sculptors, and Illustrators",
    "description": "Create original artwork using any of a wide variety of media and techniques.",
    "hourlyIncome": 37,
    "annualIncome": 76450,
    "careerGrowth": 4,
    "jobZone": 3
  },
  {
    "code": "27-1014.00",
    "name": "Special Effects Artists and Animators",
    "description": "Create special effects or animations using film, video, computers, or other electronic tools and media for use in products, such as computer games, movies, music videos, and commercials.",
    "hourlyIncome": 53,
    "annualIncome": 110110,
    "careerGrowth": 4.3,
    "jobZone": 4
  },
  {
    "code": "27-1019.00",
    "name": "Artists and Related Workers, All Other",
    "description": "All artists and related workers not listed separately.",
    "hourlyIncome": 38,
    "annualIncome": 79490,
    "careerGrowth": 3.3,
    "jobZone": null
  },
  {
    "code": "27-1021.00",
    "name": "Commercial and Industrial Designers",
    "description": "Design and develop manufactured products, such as cars, home appliances, and children's toys. Combine artistic talent with research on product use, marketing, and materials to create the most functional and appealing product design.",
    "hourlyIncome": 42,
    "annualIncome": 88000,
    "careerGrowth": 3.1,
    "jobZone": 4
  },
  {
    "code": "27-1022.00",
    "name": "Fashion Designers",
    "description": "Design clothing and accessories. Create original designs or adapt fashion trends.",
    "hourlyIncome": 59,
    "annualIncome": 122430,
    "careerGrowth": 4.7,
    "jobZone": 3
  },
  {
    "code": "27-1023.00",
    "name": "Floral Designers",
    "description": "Design, cut, and arrange live, dried, or artificial flowers and foliage.",
    "hourlyIncome": 18,
    "annualIncome": 37700,
    "careerGrowth": -10.4,
    "jobZone": 2
  },
  {
    "code": "27-1024.00",
    "name": "Graphic Designers",
    "description": "Design or create graphics to meet specific commercial or promotional needs, such as packaging, displays, or logos. May use a variety of mediums to achieve artistic or decorative effects.",
    "hourlyIncome": 33,
    "annualIncome": 68610,
    "careerGrowth": 2.5,
    "jobZone": 4
  },
  {
    "code": "27-1025.00",
    "name": "Interior Designers",
    "description": "Plan, design, and furnish the internal space of rooms or buildings. Design interior environments or create physical layouts that are practical, aesthetic, and conducive to the intended purposes. May specialize in a particular field, style, or phase of interior design.",
    "hourlyIncome": 34,
    "annualIncome": 71430,
    "careerGrowth": 4,
    "jobZone": 4
  },
  {
    "code": "27-1026.00",
    "name": "Merchandise Displayers and Window Trimmers",
    "description": "Plan and erect commercial displays, such as those in windows and interiors of retail stores and at trade exhibitions.",
    "hourlyIncome": 19,
    "annualIncome": 40540,
    "careerGrowth": 4.8,
    "jobZone": 3
  },
  {
    "code": "27-1027.00",
    "name": "Set and Exhibit Designers",
    "description": "Design special exhibits and sets for film, video, television, and theater productions. May study scripts, confer with directors, and conduct research to determine appropriate architectural styles.",
    "hourlyIncome": 38,
    "annualIncome": 78450,
    "careerGrowth": 5.1,
    "jobZone": 5
  },
  {
    "code": "27-1029.00",
    "name": "Designers, All Other",
    "description": "All designers not listed separately.",
    "hourlyIncome": 38,
    "annualIncome": 78000,
    "careerGrowth": 3,
    "jobZone": null
  },
  {
    "code": "27-2011.00",
    "name": "Actors",
    "description": "Play parts in stage, television, radio, video, or film productions, or other settings for entertainment, information, or instruction. Interpret serious or comic role by speech, gesture, and body movement to entertain or inform audience. May dance and sing.",
    "hourlyIncome": 44,
    "annualIncome": null,
    "careerGrowth": 4.5,
    "jobZone": 2
  },
  {
    "code": "27-2012.00",
    "name": "Producers and Directors",
    "description": "Produce or direct stage, television, radio, video, or film productions for entertainment, information, or instruction. Responsible for creative decisions, such as interpretation of script, choice of actors or guests, set design, sound, special effects, and choreography.",
    "hourlyIncome": 55,
    "annualIncome": 114280,
    "careerGrowth": 8,
    "jobZone": 4
  },
  {
    "code": "27-2012.03",
    "name": "Media Programming Directors",
    "description": "Direct and coordinate activities of personnel engaged in preparation of radio or television station program schedules and programs, such as sports or news.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "27-2012.04",
    "name": "Talent Directors",
    "description": "Audition and interview performers to select most appropriate talent for parts in stage, television, radio, or motion picture productions.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "27-2012.05",
    "name": "Media Technical Directors/Managers",
    "description": "Coordinate activities of technical departments, such as taping, editing, engineering, and maintenance, to produce radio or television programs.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "27-2021.00",
    "name": "Athletes and Sports Competitors",
    "description": "Compete in athletic events.",
    "hourlyIncome": null,
    "annualIncome": 259750,
    "careerGrowth": 11.1,
    "jobZone": 2
  },
  {
    "code": "27-2022.00",
    "name": "Coaches and Scouts",
    "description": "Instruct or coach groups or individuals in the fundamentals of sports for the primary purpose of competition. Demonstrate techniques and methods of participation. May evaluate athletes' strengths and weaknesses as possible recruits or to improve the athletes' technique to prepare them for competition. Those required to hold teaching certifications should be reported in the appropriate teaching category.",
    "hourlyIncome": null,
    "annualIncome": 58910,
    "careerGrowth": 8.8,
    "jobZone": 4
  },
  {
    "code": "27-2023.00",
    "name": "Umpires, Referees, and Other Sports Officials",
    "description": "Officiate at competitive athletic or sporting events. Detect infractions of rules and decide penalties according to established regulations. Includes all sporting officials, referees, and competition judges.",
    "hourlyIncome": null,
    "annualIncome": 52800,
    "careerGrowth": 10.4,
    "jobZone": 2
  },
  {
    "code": "27-2031.00",
    "name": "Dancers",
    "description": "Perform dances. May perform on stage, for broadcasting, or for video recording.",
    "hourlyIncome": 30,
    "annualIncome": null,
    "careerGrowth": 6.7,
    "jobZone": 3
  },
  {
    "code": "27-2032.00",
    "name": "Choreographers",
    "description": "Create new dance routines. Rehearse performance of routines. May direct and stage presentations.",
    "hourlyIncome": 30,
    "annualIncome": 62020,
    "careerGrowth": 5.3,
    "jobZone": 3
  },
  {
    "code": "27-2041.00",
    "name": "Music Directors and Composers",
    "description": "Conduct, direct, plan, and lead instrumental or vocal performances by musical artists or groups, such as orchestras, bands, choirs, and glee clubs; or create original works of music.",
    "hourlyIncome": 41,
    "annualIncome": 84230,
    "careerGrowth": 2.7,
    "jobZone": 4
  },
  {
    "code": "27-2042.00",
    "name": "Musicians and Singers",
    "description": "Play one or more musical instruments or sing. May perform on stage, for broadcasting, or for sound or video recording.",
    "hourlyIncome": 55,
    "annualIncome": null,
    "careerGrowth": 2.1,
    "jobZone": 4
  },
  {
    "code": "27-2091.00",
    "name": "Disc Jockeys, Except Radio",
    "description": "Play prerecorded music for live audiences at venues or events such as clubs, parties, or wedding receptions. May use techniques such as mixing, cutting, or sampling to manipulate recordings. May also perform as emcee (master of ceremonies).",
    "hourlyIncome": 33,
    "annualIncome": null,
    "careerGrowth": 5.1,
    "jobZone": 2
  },
  {
    "code": "27-2099.00",
    "name": "Entertainers and Performers, Sports and Related Workers, All Other",
    "description": "All entertainers and performers, sports and related workers not listed separately.",
    "hourlyIncome": 30,
    "annualIncome": null,
    "careerGrowth": 7.3,
    "jobZone": null
  },
  {
    "code": "27-3011.00",
    "name": "Broadcast Announcers and Radio Disc Jockeys",
    "description": "Speak or read from scripted materials, such as news reports or commercial messages, on radio, television, or other communications media. May play and queue music, announce artist or title of performance, identify station, or interview guests.",
    "hourlyIncome": 39,
    "annualIncome": 80110,
    "careerGrowth": -4,
    "jobZone": 4
  },
  {
    "code": "27-3023.00",
    "name": "News Analysts, Reporters, and Journalists",
    "description": "Narrate or write news stories, reviews, or commentary for print, broadcast, or other communications media such as newspapers, magazines, radio, or television. May collect and analyze information through interview, investigation, or observation.",
    "hourlyIncome": 51,
    "annualIncome": 106030,
    "careerGrowth": -2.7,
    "jobZone": 4
  },
  {
    "code": "27-3031.00",
    "name": "Public Relations Specialists",
    "description": "Promote or create an intended public image for individuals, groups, or organizations. May write or select material for release to various communications media. May specialize in using social media.",
    "hourlyIncome": 39,
    "annualIncome": 80310,
    "careerGrowth": 6.2,
    "jobZone": 4
  },
  {
    "code": "27-3041.00",
    "name": "Editors",
    "description": "Plan, coordinate, revise, or edit written material. May review proposals and drafts for possible publication.",
    "hourlyIncome": 41,
    "annualIncome": 85700,
    "careerGrowth": -2,
    "jobZone": 4
  },
  {
    "code": "27-3042.00",
    "name": "Technical Writers",
    "description": "Write technical materials, such as equipment manuals, appendices, or operating and maintenance instructions. May assist in layout work.",
    "hourlyIncome": 44,
    "annualIncome": 92330,
    "careerGrowth": 4,
    "jobZone": 4
  },
  {
    "code": "27-3043.00",
    "name": "Writers and Authors",
    "description": "Originate and prepare written material, such as scripts, stories, advertisements, and other material.",
    "hourlyIncome": 41,
    "annualIncome": 85780,
    "careerGrowth": 5.1,
    "jobZone": 4
  },
  {
    "code": "27-3043.05",
    "name": "Poets, Lyricists and Creative Writers",
    "description": "Create original written works, such as scripts, essays, prose, poetry or song lyrics, for publication or performance.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "27-3091.00",
    "name": "Interpreters and Translators",
    "description": "Interpret oral or sign language, or translate written text from one language into another.",
    "hourlyIncome": 31,
    "annualIncome": 64950,
    "careerGrowth": 2.3,
    "jobZone": 4
  },
  {
    "code": "27-3092.00",
    "name": "Court Reporters and Simultaneous Captioners",
    "description": "Use verbatim methods and equipment to capture, store, retrieve, and transcribe pretrial and trial proceedings or other information. Includes stenocaptioners who operate computerized stenographic captioning equipment to provide captions of live or prerecorded broadcasts for hearing-impaired viewers.",
    "hourlyIncome": 36,
    "annualIncome": 74630,
    "careerGrowth": 1.8,
    "jobZone": 3
  },
  {
    "code": "27-3099.00",
    "name": "Media and Communication Workers, All Other",
    "description": "All media and communication workers not listed separately.",
    "hourlyIncome": 41,
    "annualIncome": 84870,
    "careerGrowth": 8,
    "jobZone": null
  },
  {
    "code": "27-4011.00",
    "name": "Audio and Video Technicians",
    "description": "Set up, maintain, and dismantle audio and video equipment, such as microphones, sound speakers, connecting wires and cables, sound and mixing boards, video cameras, video monitors and servers, and related electronic equipment for live or recorded events, such as concerts, meetings, conventions, presentations, podcasts, news conferences, and sporting events.",
    "hourlyIncome": 30,
    "annualIncome": 61370,
    "careerGrowth": 5.3,
    "jobZone": 3
  },
  {
    "code": "27-4012.00",
    "name": "Broadcast Technicians",
    "description": "Set up, operate, and maintain the electronic equipment used to acquire, edit, and transmit audio and video for radio or television programs. Control and adjust incoming and outgoing broadcast signals to regulate sound volume, signal strength, and signal clarity. Operate satellite, microwave, or other transmitter equipment to broadcast radio or television programs.",
    "hourlyIncome": 31,
    "annualIncome": 64220,
    "careerGrowth": 0.1,
    "jobZone": 3
  },
  {
    "code": "27-4014.00",
    "name": "Sound Engineering Technicians",
    "description": "Assemble and operate equipment to record, synchronize, mix, edit, or reproduce sound, including music, voices, or sound effects, for theater, video, film, television, podcasts, sporting events, and other productions.",
    "hourlyIncome": 38,
    "annualIncome": 79280,
    "careerGrowth": -0.5,
    "jobZone": 3
  },
  {
    "code": "27-4015.00",
    "name": "Lighting Technicians",
    "description": "Set up, maintain, and dismantle light fixtures, lighting control devices, and the associated lighting electrical and rigging equipment used for photography, television, film, video, and live productions. May focus or operate light fixtures, or attach color filters or other lighting accessories.",
    "hourlyIncome": 34,
    "annualIncome": 70000,
    "careerGrowth": -3,
    "jobZone": 3
  },
  {
    "code": "27-4021.00",
    "name": "Photographers",
    "description": "Photograph people, landscapes, merchandise, or other subjects. May use lighting equipment to enhance a subject's appearance. May use editing software to produce finished images and prints. Includes commercial and industrial photographers, scientific photographers, and photojournalists.",
    "hourlyIncome": 27,
    "annualIncome": 55650,
    "careerGrowth": 3.9,
    "jobZone": 3
  },
  {
    "code": "27-4031.00",
    "name": "Camera Operators, Television, Video, and Film",
    "description": "Operate television, video, or film camera to record images or scenes for television, video, or film productions.",
    "hourlyIncome": 38,
    "annualIncome": 79870,
    "careerGrowth": 1.9,
    "jobZone": 3
  },
  {
    "code": "27-4032.00",
    "name": "Film and Video Editors",
    "description": "Edit moving images on film, video, or other media. May work with a producer or director to organize images for final production. May edit or synchronize soundtracks with images.",
    "hourlyIncome": 40,
    "annualIncome": 83530,
    "careerGrowth": 4.7,
    "jobZone": 4
  },
  {
    "code": "27-4099.00",
    "name": "Media and Communication Equipment Workers, All Other",
    "description": "All media and communication equipment workers not listed separately.",
    "hourlyIncome": 38,
    "annualIncome": 78350,
    "careerGrowth": 3.4,
    "jobZone": null
  },
  {
    "code": "29-1011.00",
    "name": "Chiropractors",
    "description": "Assess, treat, and care for patients by manipulation of spine and musculoskeletal system. May provide spinal adjustment or address sacral or pelvic misalignment.",
    "hourlyIncome": 44,
    "annualIncome": 91830,
    "careerGrowth": 9.9,
    "jobZone": 5
  },
  {
    "code": "29-1021.00",
    "name": "Dentists, General",
    "description": "Examine, diagnose, and treat diseases, injuries, and malformations of teeth and gums. May treat diseases of nerve, pulp, and other dental tissues affecting oral hygiene and retention of teeth. May fit dental appliances or provide preventive care.",
    "hourlyIncome": 94,
    "annualIncome": 196100,
    "careerGrowth": 4.8,
    "jobZone": 5
  },
  {
    "code": "29-1022.00",
    "name": "Oral and Maxillofacial Surgeons",
    "description": "Perform surgery and related procedures on the hard and soft tissues of the oral and maxillofacial regions to treat diseases, injuries, or defects. May diagnose problems of the oral and maxillofacial regions. May perform surgery to improve function or appearance.",
    "hourlyIncome": 173,
    "annualIncome": 360240,
    "careerGrowth": 3.3,
    "jobZone": 5
  },
  {
    "code": "29-1023.00",
    "name": "Orthodontists",
    "description": "Examine, diagnose, and treat dental malocclusions and oral cavity anomalies. Design and fabricate appliances to realign teeth and jaws to produce and maintain normal function and to improve appearance.",
    "hourlyIncome": 122,
    "annualIncome": 254620,
    "careerGrowth": 3.7,
    "jobZone": 5
  },
  {
    "code": "29-1024.00",
    "name": "Prosthodontists",
    "description": "Diagnose, treat, rehabilitate, design, and fit prostheses that maintain oral function, health, and appearance for patients with clinical conditions associated with teeth, oral and maxillofacial tissues, or the jaw.",
    "hourlyIncome": 124,
    "annualIncome": 258660,
    "careerGrowth": 3.5,
    "jobZone": 5
  },
  {
    "code": "29-1029.00",
    "name": "Dentists, All Other Specialists",
    "description": "All dentists not listed separately.",
    "hourlyIncome": 119,
    "annualIncome": 246530,
    "careerGrowth": 2.3,
    "jobZone": null
  },
  {
    "code": "29-1031.00",
    "name": "Dietitians and Nutritionists",
    "description": "Plan and conduct food service or nutritional programs to assist in the promotion of health and control of disease. May supervise activities of a department providing quantity food services, counsel individuals, or conduct nutritional research.",
    "hourlyIncome": 36,
    "annualIncome": 74770,
    "careerGrowth": 7.4,
    "jobZone": 5
  },
  {
    "code": "29-1041.00",
    "name": "Optometrists",
    "description": "Diagnose, manage, and treat conditions and diseases of the human eye and visual system. Examine eyes and visual system, diagnose problems or impairments, prescribe corrective lenses, and provide treatment. May prescribe therapeutic drugs to treat specific eye conditions.",
    "hourlyIncome": 68,
    "annualIncome": 140940,
    "careerGrowth": 8.7,
    "jobZone": 5
  },
  {
    "code": "29-1051.00",
    "name": "Pharmacists",
    "description": "Dispense drugs prescribed by physicians and other health practitioners and provide information to patients about medications and their use. May advise physicians and other health practitioners on the selection, dosage, interactions, and side effects of medications.",
    "hourlyIncome": 66,
    "annualIncome": 137210,
    "careerGrowth": 5.4,
    "jobZone": 5
  },
  {
    "code": "29-1071.00",
    "name": "Physician Assistants",
    "description": "Provide healthcare services typically performed by a physician, under the supervision of a physician. Conduct complete physicals, provide treatment, and counsel patients. May, in some cases, prescribe medication. Must graduate from an accredited educational program for physician assistants.",
    "hourlyIncome": 66,
    "annualIncome": 136900,
    "careerGrowth": 28.5,
    "jobZone": 5
  },
  {
    "code": "29-1071.01",
    "name": "Anesthesiologist Assistants",
    "description": "Assist anesthesiologists in the administration of anesthesia for surgical and non-surgical procedures. Monitor patient status and provide patient care during surgical treatment.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1081.00",
    "name": "Podiatrists",
    "description": "Diagnose and treat diseases and deformities of the human foot.",
    "hourlyIncome": 79,
    "annualIncome": 163960,
    "careerGrowth": 1.4,
    "jobZone": 5
  },
  {
    "code": "29-1122.00",
    "name": "Occupational Therapists",
    "description": "Assess, plan, and organize rehabilitative programs that help build or restore vocational, homemaking, and daily living skills, as well as general independence, to persons with disabilities or developmental delays. Use therapeutic techniques, adapt the individual's environment, teach skills, and modify specific tasks that present barriers to the individual.",
    "hourlyIncome": 47,
    "annualIncome": 98240,
    "careerGrowth": 11.1,
    "jobZone": 5
  },
  {
    "code": "29-1122.01",
    "name": "Low Vision Therapists, Orientation and Mobility Specialists, and Vision Rehabilitation Therapists",
    "description": "Provide therapy to patients with visual impairments to improve their functioning in daily life activities. May train patients in activities such as computer use, communication skills, or home management skills.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1123.00",
    "name": "Physical Therapists",
    "description": "Assess, plan, organize, and participate in rehabilitative programs that improve mobility, relieve pain, increase strength, and improve or correct disabling conditions resulting from disease or injury.",
    "hourlyIncome": 49,
    "annualIncome": 102400,
    "careerGrowth": 14.2,
    "jobZone": 5
  },
  {
    "code": "29-1124.00",
    "name": "Radiation Therapists",
    "description": "Provide radiation therapy to patients as prescribed by a radiation oncologist according to established practices and standards. Duties may include reviewing prescription and diagnosis; acting as liaison with physician and supportive care personnel; preparing equipment, such as immobilization, treatment, and protection devices; and maintaining records, reports, and files. May assist in dosimetry procedures and tumor localization.",
    "hourlyIncome": 53,
    "annualIncome": 110820,
    "careerGrowth": 3.1,
    "jobZone": 3
  },
  {
    "code": "29-1125.00",
    "name": "Recreational Therapists",
    "description": "Plan, direct, or coordinate medically-approved recreation programs for patients in hospitals, nursing homes, or other institutions. Activities include sports, trips, dramatics, social activities, and crafts. May assess a patient condition and recommend appropriate recreational activity.",
    "hourlyIncome": 31,
    "annualIncome": 65350,
    "careerGrowth": 4.3,
    "jobZone": 4
  },
  {
    "code": "29-1126.00",
    "name": "Respiratory Therapists",
    "description": "Assess, treat, and care for patients with breathing disorders. Assume primary responsibility for all respiratory care modalities, including the supervision of respiratory therapy technicians. Initiate and conduct therapeutic procedures; maintain patient records; and select, assemble, check, and operate equipment.",
    "hourlyIncome": 41,
    "annualIncome": 84260,
    "careerGrowth": 13.1,
    "jobZone": 3
  },
  {
    "code": "29-1127.00",
    "name": "Speech-Language Pathologists",
    "description": "Assess and treat persons with speech, language, voice, and fluency disorders. May select alternative communication systems and teach their use. May perform research related to speech and language problems.",
    "hourlyIncome": 46,
    "annualIncome": 95840,
    "careerGrowth": 18.4,
    "jobZone": 5
  },
  {
    "code": "29-1128.00",
    "name": "Exercise Physiologists",
    "description": "Assess, plan, or implement fitness programs that include exercise or physical activities such as those designed to improve cardiorespiratory function, body composition, muscular strength, muscular endurance, or flexibility.",
    "hourlyIncome": 29,
    "annualIncome": 59620,
    "careerGrowth": 10.4,
    "jobZone": 4
  },
  {
    "code": "29-1129.00",
    "name": "Therapists, All Other",
    "description": "All therapists not listed separately.",
    "hourlyIncome": 35,
    "annualIncome": 73800,
    "careerGrowth": 11.8,
    "jobZone": null
  },
  {
    "code": "29-1129.01",
    "name": "Art Therapists",
    "description": "Plan or conduct art therapy sessions or programs to improve clients' physical, cognitive, or emotional well-being.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1129.02",
    "name": "Music Therapists",
    "description": "Plan, organize, direct, or assess clinical and evidenced-based music therapy interventions to positively influence individuals' physical, psychological, cognitive, or behavioral status.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "29-1131.00",
    "name": "Veterinarians",
    "description": "Diagnose, treat, or research diseases and injuries of animals. Includes veterinarians who conduct research and development, inspect livestock, or care for pets and companion animals.",
    "hourlyIncome": 67,
    "annualIncome": 140270,
    "careerGrowth": 19.1,
    "jobZone": 5
  },
  {
    "code": "29-1141.00",
    "name": "Registered Nurses",
    "description": "Assess patient health problems and needs, develop and implement nursing care plans, and maintain medical records. Administer nursing care to ill, injured, convalescent, or disabled patients. May advise patients on health maintenance and disease prevention or provide case management. Licensing or registration required.",
    "hourlyIncome": 47,
    "annualIncome": 98430,
    "careerGrowth": 6,
    "jobZone": 4
  },
  {
    "code": "29-1141.01",
    "name": "Acute Care Nurses",
    "description": "Provide advanced nursing care for patients with acute conditions such as heart attacks, respiratory distress syndrome, or shock. May care for pre- and post-operative patients or perform advanced, invasive diagnostic or therapeutic procedures.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "29-1141.02",
    "name": "Advanced Practice Psychiatric Nurses",
    "description": "Assess, diagnose, and treat individuals and families with mental health or substance use disorders or the potential for such disorders. Apply therapeutic activities, including the prescription of medication, per state regulations, and the administration of psychotherapy.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1141.03",
    "name": "Critical Care Nurses",
    "description": "Provide specialized nursing care for patients in critical or coronary care units.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "29-1141.04",
    "name": "Clinical Nurse Specialists",
    "description": "Direct nursing staff in the provision of patient care in a clinical practice setting, such as a hospital, hospice, clinic, or home. Ensure adherence to established clinical policies, protocols, regulations, and standards.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1151.00",
    "name": "Nurse Anesthetists",
    "description": "Administer anesthesia, monitor patient's vital signs, and oversee patient recovery from anesthesia. May assist anesthesiologists, surgeons, other physicians, or dentists. Must be registered nurses who have specialized graduate education.",
    "hourlyIncome": 111,
    "annualIncome": 231700,
    "careerGrowth": 10.4,
    "jobZone": 5
  },
  {
    "code": "29-1161.00",
    "name": "Nurse Midwives",
    "description": "Diagnose and coordinate all aspects of the birthing process, either independently or as part of a healthcare team. May provide well-woman gynecological care. Must have specialized, graduate nursing education.",
    "hourlyIncome": 62,
    "annualIncome": 128110,
    "careerGrowth": 7.1,
    "jobZone": 5
  },
  {
    "code": "29-1171.00",
    "name": "Nurse Practitioners",
    "description": "Diagnose and treat acute, episodic, or chronic illness, independently or as part of a healthcare team. May focus on health promotion and disease prevention. May order, perform, or interpret diagnostic tests such as lab work and x rays. May prescribe medication. Must be registered nurses who have specialized graduate education.",
    "hourlyIncome": 63,
    "annualIncome": 132000,
    "careerGrowth": 46.3,
    "jobZone": 5
  },
  {
    "code": "29-1181.00",
    "name": "Audiologists",
    "description": "Assess and treat persons with hearing and related disorders. May fit hearing aids and provide auditory training. May perform research related to hearing problems.",
    "hourlyIncome": 46,
    "annualIncome": 95320,
    "careerGrowth": 10.9,
    "jobZone": 5
  },
  {
    "code": "29-1211.00",
    "name": "Anesthesiologists",
    "description": "Administer anesthetics and analgesics for pain management prior to, during, or after surgery.",
    "hourlyIncome": 162,
    "annualIncome": 336640,
    "careerGrowth": 4,
    "jobZone": 5
  },
  {
    "code": "29-1212.00",
    "name": "Cardiologists",
    "description": "Diagnose, treat, manage, and prevent diseases or conditions of the cardiovascular system. May further subspecialize in interventional procedures (e.g., balloon angioplasty and stent placement), echocardiography, or electrophysiology.",
    "hourlyIncome": 208,
    "annualIncome": 432490,
    "careerGrowth": 5,
    "jobZone": 5
  },
  {
    "code": "29-1213.00",
    "name": "Dermatologists",
    "description": "Diagnose and treat diseases relating to the skin, hair, and nails. May perform both medical and dermatological surgery functions.",
    "hourlyIncome": 167,
    "annualIncome": 347810,
    "careerGrowth": 7.1,
    "jobZone": 5
  },
  {
    "code": "29-1214.00",
    "name": "Emergency Medicine Physicians",
    "description": "Make immediate medical decisions and act to prevent death or further disability. Provide immediate recognition, evaluation, care, stabilization, and disposition of patients. May direct emergency medical staff in an emergency department.",
    "hourlyIncome": 154,
    "annualIncome": 320700,
    "careerGrowth": 3.5,
    "jobZone": 5
  },
  {
    "code": "29-1215.00",
    "name": "Family Medicine Physicians",
    "description": "Diagnose, treat, and provide preventive care to individuals and families across the lifespan. May refer patients to specialists when needed for further diagnosis or treatment.",
    "hourlyIncome": 123,
    "annualIncome": 256830,
    "careerGrowth": 4.8,
    "jobZone": 5
  },
  {
    "code": "29-1216.00",
    "name": "General Internal Medicine Physicians",
    "description": "Diagnose and provide nonsurgical treatment for a wide range of diseases and injuries of internal organ systems. Provide care mainly for adults and adolescents, and are based primarily in an outpatient care setting.",
    "hourlyIncome": 126,
    "annualIncome": 262710,
    "careerGrowth": 3.4,
    "jobZone": 5
  },
  {
    "code": "29-1217.00",
    "name": "Neurologists",
    "description": "Diagnose, manage, and treat disorders and diseases of the brain, spinal cord, and peripheral nerves, with a primarily nonsurgical focus.",
    "hourlyIncome": 138,
    "annualIncome": 286310,
    "careerGrowth": 6.8,
    "jobZone": 5
  },
  {
    "code": "29-1218.00",
    "name": "Obstetricians and Gynecologists",
    "description": "Provide medical care related to pregnancy or childbirth. Diagnose, treat, and help prevent diseases of women, particularly those affecting the reproductive system. May also provide general care to women. May perform both medical and gynecological surgery functions.",
    "hourlyIncome": 135,
    "annualIncome": 281130,
    "careerGrowth": 3.3,
    "jobZone": 5
  },
  {
    "code": "29-1221.00",
    "name": "Pediatricians, General",
    "description": "Diagnose, treat, and help prevent diseases and injuries in children. May refer patients to specialists for further diagnosis or treatment, as needed.",
    "hourlyIncome": 107,
    "annualIncome": 222340,
    "careerGrowth": 2.1,
    "jobZone": 5
  },
  {
    "code": "29-1222.00",
    "name": "Physicians, Pathologists",
    "description": "Diagnose diseases and conduct lab tests using organs, body tissues, and fluids. Includes medical examiners.",
    "hourlyIncome": 128,
    "annualIncome": 266020,
    "careerGrowth": 5.5,
    "jobZone": 5
  },
  {
    "code": "29-1223.00",
    "name": "Psychiatrists",
    "description": "Diagnose, treat, and help prevent mental disorders.",
    "hourlyIncome": 129,
    "annualIncome": 269120,
    "careerGrowth": 7.6,
    "jobZone": 5
  },
  {
    "code": "29-1224.00",
    "name": "Radiologists",
    "description": "Diagnose and treat diseases and injuries using medical imaging techniques, such as x rays, magnetic resonance imaging (MRI), nuclear medicine, and ultrasounds. May perform minimally invasive medical procedures and tests.",
    "hourlyIncome": 173,
    "annualIncome": 359820,
    "careerGrowth": 3.6,
    "jobZone": 5
  },
  {
    "code": "29-1229.00",
    "name": "Physicians, All Other",
    "description": "All physicians not listed separately.",
    "hourlyIncome": 122,
    "annualIncome": 253470,
    "careerGrowth": 3.9,
    "jobZone": null
  },
  {
    "code": "29-1229.01",
    "name": "Allergists and Immunologists",
    "description": "Diagnose, treat, and help prevent allergic diseases and disease processes affecting the immune system.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1229.02",
    "name": "Hospitalists",
    "description": "Provide inpatient care predominantly in settings such as medical wards, acute care units, intensive care units, rehabilitation centers, or emergency rooms. Manage and coordinate patient care throughout treatment.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1229.03",
    "name": "Urologists",
    "description": "Diagnose, treat, and help prevent benign and malignant medical and surgical disorders of the genitourinary system and the renal glands.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1229.04",
    "name": "Physical Medicine and Rehabilitation Physicians",
    "description": "Diagnose and treat disorders requiring physiotherapy to provide physical, mental, and occupational rehabilitation.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1229.05",
    "name": "Preventive Medicine Physicians",
    "description": "Apply knowledge of general preventive medicine and public health issues to promote health care to groups or individuals, and aid in the prevention or reduction of risk of disease, injury, disability, or death. May practice population-based medicine or diagnose and treat patients in the context of clinical health promotion and disease prevention.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1229.06",
    "name": "Sports Medicine Physicians",
    "description": "Diagnose, treat, and help prevent injuries that occur during sporting events, athletic training, and physical activities.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1241.00",
    "name": "Ophthalmologists, Except Pediatric",
    "description": "Diagnose and perform surgery to treat and help prevent disorders and diseases of the eye. May also provide vision services for treatment including glasses and contacts.",
    "hourlyIncome": 145,
    "annualIncome": 301500,
    "careerGrowth": 4.5,
    "jobZone": 5
  },
  {
    "code": "29-1242.00",
    "name": "Orthopedic Surgeons, Except Pediatric",
    "description": "Diagnose and perform surgery to treat and prevent rheumatic and other diseases in the musculoskeletal system.",
    "hourlyIncome": 176,
    "annualIncome": 365060,
    "careerGrowth": 4.2,
    "jobZone": 5
  },
  {
    "code": "29-1243.00",
    "name": "Pediatric Surgeons",
    "description": "Diagnose and perform surgery to treat fetal abnormalities and birth defects, diseases, and injuries in fetuses, premature and newborn infants, children, and adolescents. Includes all pediatric surgical specialties and subspecialties.",
    "hourlyIncome": 217,
    "annualIncome": 450810,
    "careerGrowth": 2,
    "jobZone": 5
  },
  {
    "code": "29-1249.00",
    "name": "Surgeons, All Other",
    "description": "All surgeons not listed separately.",
    "hourlyIncome": 179,
    "annualIncome": 371280,
    "careerGrowth": 4.3,
    "jobZone": null
  },
  {
    "code": "29-1291.00",
    "name": "Acupuncturists",
    "description": "Diagnose, treat, and prevent disorders by stimulating specific acupuncture points within the body using acupuncture needles. May also use cups, nutritional supplements, therapeutic massage, acupressure, and other alternative health therapies.",
    "hourlyIncome": 43,
    "annualIncome": 89750,
    "careerGrowth": 5.5,
    "jobZone": 5
  },
  {
    "code": "29-1292.00",
    "name": "Dental Hygienists",
    "description": "Administer oral hygiene care to patients. Assess patient oral hygiene problems or needs and maintain health records. Advise patients on oral health maintenance and disease prevention. May provide advanced care such as providing fluoride treatment or administering topical anesthesia.",
    "hourlyIncome": 45,
    "annualIncome": 93890,
    "careerGrowth": 9.2,
    "jobZone": 3
  },
  {
    "code": "29-1299.00",
    "name": "Healthcare Diagnosing or Treating Practitioners, All Other",
    "description": "All healthcare diagnosing or treating practitioners not listed separately.",
    "hourlyIncome": 62,
    "annualIncome": 128680,
    "careerGrowth": 2.6,
    "jobZone": null
  },
  {
    "code": "29-1299.01",
    "name": "Naturopathic Physicians",
    "description": "Diagnose, treat, and help prevent diseases using a system of practice that is based on the natural healing capacity of individuals. May use physiological, psychological or mechanical methods. May also use natural medicines, prescription or legend drugs, foods, herbs, or other natural remedies.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-1299.02",
    "name": "Orthoptists",
    "description": "Diagnose and treat visual system disorders such as binocular vision and eye movement impairments.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-2011.00",
    "name": "Medical and Clinical Laboratory Technologists",
    "description": "Perform complex medical laboratory tests for diagnosis, treatment, and prevention of disease. May train or supervise staff.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "29-2011.01",
    "name": "Cytogenetic Technologists",
    "description": "Analyze chromosomes or chromosome segments found in biological specimens, such as amniotic fluids, bone marrow, solid tumors, and blood to aid in the study, diagnosis, classification, or treatment of inherited or acquired genetic diseases. Conduct analyses through classical cytogenetic, fluorescent in situ hybridization (FISH) or array comparative genome hybridization (aCGH) techniques.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "29-2011.02",
    "name": "Cytotechnologists",
    "description": "Stain, mount, and study cells to detect evidence of cancer, hormonal abnormalities, and other pathological conditions following established standards and practices.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "29-2011.04",
    "name": "Histotechnologists",
    "description": "Apply knowledge of health and disease causes to evaluate new laboratory techniques and procedures to examine tissue samples. Process and prepare histological slides from tissue sections for microscopic examination and diagnosis by pathologists. May solve technical or instrument problems or assist with research studies.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "29-2012.00",
    "name": "Medical and Clinical Laboratory Technicians",
    "description": "Perform routine medical laboratory tests for the diagnosis, treatment, and prevention of disease. May work under the supervision of a medical technologist.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "29-2012.01",
    "name": "Histology Technicians",
    "description": "Prepare histological slides from tissue sections for microscopic examination and diagnosis by pathologists. May assist with research studies.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "29-2031.00",
    "name": "Cardiovascular Technologists and Technicians",
    "description": "Conduct tests on pulmonary or cardiovascular systems of patients for diagnostic, therapeutic, or research purposes. May conduct or assist in electrocardiograms, cardiac catheterizations, pulmonary functions, lung capacity, and similar tests.",
    "hourlyIncome": 35,
    "annualIncome": 72890,
    "careerGrowth": 4.2,
    "jobZone": 3
  },
  {
    "code": "29-2032.00",
    "name": "Diagnostic Medical Sonographers",
    "description": "Produce ultrasonic recordings of internal organs for use by physicians. Includes vascular technologists.",
    "hourlyIncome": 44,
    "annualIncome": 92550,
    "careerGrowth": 15.1,
    "jobZone": 3
  },
  {
    "code": "29-2033.00",
    "name": "Nuclear Medicine Technologists",
    "description": "Prepare, administer, and measure radioactive isotopes in therapeutic, diagnostic, and tracer studies using a variety of radioisotope equipment. Prepare stock solutions of radioactive materials and calculate doses to be administered by radiologists. Subject patients to radiation. Execute blood volume, red cell survival, and fat absorption studies following standard laboratory techniques.",
    "hourlyIncome": 48,
    "annualIncome": 99690,
    "careerGrowth": -1.3,
    "jobZone": 3
  },
  {
    "code": "29-2034.00",
    "name": "Radiologic Technologists and Technicians",
    "description": "Take x-rays and CAT scans or administer nonradioactive materials into patient's bloodstream for diagnostic or research purposes. Includes radiologic technologists and technicians who specialize in other scanning modalities.",
    "hourlyIncome": 38,
    "annualIncome": 79760,
    "careerGrowth": 5.8,
    "jobZone": 3
  },
  {
    "code": "29-2035.00",
    "name": "Magnetic Resonance Imaging Technologists",
    "description": "Operate Magnetic Resonance Imaging (MRI) scanners. Monitor patient safety and comfort, and view images of area being scanned to ensure quality of pictures. May administer gadolinium contrast dosage intravenously. May interview patient, explain MRI procedures, and position patient on examining table. May enter into the computer data such as patient history, anatomical area to be scanned, orientation specified, and position of entry.",
    "hourlyIncome": 44,
    "annualIncome": 91020,
    "careerGrowth": 8.4,
    "jobZone": 3
  },
  {
    "code": "29-2036.00",
    "name": "Medical Dosimetrists",
    "description": "Generate radiation treatment plans, develop radiation dose calculations, communicate and supervise the treatment plan implementation, and consult with members of radiation oncology team.",
    "hourlyIncome": 68,
    "annualIncome": 141420,
    "careerGrowth": 5.4,
    "jobZone": 4
  },
  {
    "code": "29-2042.00",
    "name": "Emergency Medical Technicians",
    "description": "Assess injuries and illnesses and administer basic emergency medical care. May transport injured or sick persons to medical facilities.",
    "hourlyIncome": 22,
    "annualIncome": 44790,
    "careerGrowth": 6.1,
    "jobZone": 3
  },
  {
    "code": "29-2043.00",
    "name": "Paramedics",
    "description": "Administer basic or advanced emergency medical care and assess injuries and illnesses. May administer medication intravenously, use equipment such as EKGs, or administer advanced life support to sick or injured individuals.",
    "hourlyIncome": 29,
    "annualIncome": 60610,
    "careerGrowth": 5.9,
    "jobZone": 3
  },
  {
    "code": "29-2051.00",
    "name": "Dietetic Technicians",
    "description": "Assist in the provision of food service and nutritional programs, under the supervision of a dietitian. May plan and produce meals based on established guidelines, teach principles of food and nutrition, or counsel individuals.",
    "hourlyIncome": 19,
    "annualIncome": 39560,
    "careerGrowth": 4.3,
    "jobZone": 3
  },
  {
    "code": "29-2052.00",
    "name": "Pharmacy Technicians",
    "description": "Prepare medications under the direction of a pharmacist. May measure, mix, count out, label, and record amounts and dosages of medications according to prescription orders.",
    "hourlyIncome": 22,
    "annualIncome": 44800,
    "careerGrowth": 7.2,
    "jobZone": 3
  },
  {
    "code": "29-2053.00",
    "name": "Psychiatric Technicians",
    "description": "Care for individuals with mental or emotional conditions or disabilities, following the instructions of physicians or other health practitioners. Monitor patients' physical and emotional well-being and report to medical staff. May participate in rehabilitation and treatment programs, help with personal hygiene, and administer oral or injectable medications.",
    "hourlyIncome": 22,
    "annualIncome": 45000,
    "careerGrowth": 17.1,
    "jobZone": 3
  },
  {
    "code": "29-2055.00",
    "name": "Surgical Technologists",
    "description": "Assist in operations, under the supervision of surgeons, registered nurses, or other surgical personnel. May help set up operating room, prepare and transport patients for surgery, adjust lights and equipment, pass instruments and other supplies to surgeons and surgeons' assistants, hold retractors, cut sutures, and help count sponges, needles, supplies, and instruments.",
    "hourlyIncome": 32,
    "annualIncome": 65810,
    "careerGrowth": 5.8,
    "jobZone": 3
  },
  {
    "code": "29-2056.00",
    "name": "Veterinary Technologists and Technicians",
    "description": "Perform medical tests in a laboratory environment for use in the treatment and diagnosis of diseases in animals. Prepare vaccines and serums for prevention of diseases. Prepare tissue samples, take blood samples, and execute laboratory tests, such as urinalysis and blood counts. Clean and sterilize instruments and materials and maintain equipment and machines. May assist a veterinarian during surgery.",
    "hourlyIncome": 22,
    "annualIncome": 46280,
    "careerGrowth": 19.3,
    "jobZone": 3
  },
  {
    "code": "29-2057.00",
    "name": "Ophthalmic Medical Technicians",
    "description": "Assist ophthalmologists by performing ophthalmic clinical functions. May administer eye exams, administer eye medications, and instruct the patient in care and use of corrective lenses.",
    "hourlyIncome": 22,
    "annualIncome": 45360,
    "careerGrowth": 14.1,
    "jobZone": 3
  },
  {
    "code": "29-2061.00",
    "name": "Licensed Practical and Licensed Vocational Nurses",
    "description": "Care for ill, injured, or convalescing patients or persons with disabilities in hospitals, nursing homes, clinics, private homes, group homes, and similar institutions. May work under the supervision of a registered nurse. Licensing required.",
    "hourlyIncome": 31,
    "annualIncome": 64150,
    "careerGrowth": 2.6,
    "jobZone": 3
  },
  {
    "code": "29-2072.00",
    "name": "Medical Records Specialists",
    "description": "Compile, process, and maintain medical records of hospital and clinic patients in a manner consistent with medical, administrative, ethical, legal, and regulatory requirements of the healthcare system. Classify medical and healthcare concepts, including diagnosis, procedures, medical services, and equipment, into the healthcare industry's numerical coding system. Includes medical coders.",
    "hourlyIncome": 27,
    "annualIncome": 55970,
    "careerGrowth": 8.7,
    "jobZone": 3
  },
  {
    "code": "29-2081.00",
    "name": "Opticians, Dispensing",
    "description": "Design, measure, fit, and adapt lenses and frames for client according to written optical prescription or specification. Assist client with inserting, removing, and caring for contact lenses. Assist client with selecting frames. Measure customer for size of eyeglasses and coordinate frames with facial and eye measurements and optical prescription. Prepare work order for optical laboratory containing instructions for grinding and mounting lenses in frames. Verify exactness of finished lens spectacles. Adjust frame and lens position to fit client. May shape or reshape frames. Includes contact lens opticians.",
    "hourlyIncome": 24,
    "annualIncome": 49970,
    "careerGrowth": 2.9,
    "jobZone": 3
  },
  {
    "code": "29-2091.00",
    "name": "Orthotists and Prosthetists",
    "description": "Design, measure, fit, and adapt orthopedic braces, appliances or prostheses, such as limbs or facial parts for patients with disabling conditions.",
    "hourlyIncome": 39,
    "annualIncome": 81330,
    "careerGrowth": 15.1,
    "jobZone": 5
  },
  {
    "code": "29-2092.00",
    "name": "Hearing Aid Specialists",
    "description": "Select and fit hearing aids for customers. Administer and interpret tests of hearing. Assess hearing instrument efficacy. Take ear impressions and prepare, design, and modify ear molds.",
    "hourlyIncome": 31,
    "annualIncome": 63930,
    "careerGrowth": 14.9,
    "jobZone": 3
  },
  {
    "code": "29-2099.00",
    "name": "Health Technologists and Technicians, All Other",
    "description": "All health technologists and technicians not listed separately.",
    "hourlyIncome": 27,
    "annualIncome": 56370,
    "careerGrowth": 7,
    "jobZone": null
  },
  {
    "code": "29-2099.01",
    "name": "Neurodiagnostic Technologists",
    "description": "Conduct electroneurodiagnostic (END) tests such as electroencephalograms, evoked potentials, polysomnograms, or electronystagmograms. May perform nerve conduction studies.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "29-2099.05",
    "name": "Ophthalmic Medical Technologists",
    "description": "Assist ophthalmologists by performing ophthalmic clinical functions and ophthalmic photography. Provide instruction and supervision to other ophthalmic personnel. Assist with minor surgical procedures, applying aseptic techniques and preparing instruments. May perform eye exams, administer eye medications, and instruct patients in care and use of corrective lenses.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "29-2099.08",
    "name": "Patient Representatives",
    "description": "Assist patients in obtaining services, understanding policies and making health care decisions.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "29-9021.00",
    "name": "Health Information Technologists and Medical Registrars",
    "description": "Apply knowledge of healthcare and information systems to assist in the design, development, and continued modification and analysis of computerized healthcare systems. Abstract, collect, and analyze treatment and followup information of patients. May educate staff and assist in problem solving to promote the implementation of the healthcare information system. May design, develop, test, and implement databases with complete history, diagnosis, treatment, and health status to help monitor diseases.",
    "hourlyIncome": 35,
    "annualIncome": 73410,
    "careerGrowth": 16.3,
    "jobZone": 3
  },
  {
    "code": "29-9091.00",
    "name": "Athletic Trainers",
    "description": "Evaluate and treat musculoskeletal injuries or illnesses. Provide preventive, therapeutic, emergency, and rehabilitative care.",
    "hourlyIncome": null,
    "annualIncome": 63960,
    "careerGrowth": 12.7,
    "jobZone": 5
  },
  {
    "code": "29-9092.00",
    "name": "Genetic Counselors",
    "description": "Assess individual or family risk for a variety of inherited conditions, such as genetic disorders and birth defects. Provide information to other healthcare providers or to individuals and families concerned with the risk of inherited conditions. Advise individuals and families to support informed decisionmaking and coping methods for those at risk. May help conduct research related to genetic conditions or genetic counseling.",
    "hourlyIncome": 49,
    "annualIncome": 102890,
    "careerGrowth": 16.1,
    "jobZone": 5
  },
  {
    "code": "29-9093.00",
    "name": "Surgical Assistants",
    "description": "Assist in operations, under the supervision of surgeons. May, in accordance with state laws, help surgeons to make incisions and close surgical sites, manipulate or remove tissues, implant surgical devices or drains, suction the surgical site, place catheters, clamp or cauterize vessels or tissue, and apply dressings to surgical site.",
    "hourlyIncome": 32,
    "annualIncome": 67190,
    "careerGrowth": 6.7,
    "jobZone": 3
  },
  {
    "code": "29-9099.00",
    "name": "Healthcare Practitioners and Technical Workers, All Other",
    "description": "All healthcare practitioners and technical workers not listed separately.",
    "hourlyIncome": 35,
    "annualIncome": 73200,
    "careerGrowth": 5.8,
    "jobZone": null
  },
  {
    "code": "29-9099.01",
    "name": "Midwives",
    "description": "Provide prenatal care and childbirth assistance.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 5
  },
  {
    "code": "31-1121.00",
    "name": "Home Health Aides",
    "description": "Monitor the health status of an individual with disabilities or illness, and address their health-related needs, such as changing bandages, dressing wounds, or administering medication. Work is performed under the direction of offsite or intermittent onsite licensed nursing staff. Provide assistance with routine healthcare tasks or activities of daily living, such as feeding, bathing, toileting, or ambulation. May also help with tasks such as preparing meals, doing light housekeeping, and doing laundry depending on the patient's abilities.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "31-1122.00",
    "name": "Personal Care Aides",
    "description": "Provide personalized assistance to individuals with disabilities or illness who require help with personal care and activities of daily living support (e.g., feeding, bathing, dressing, grooming, toileting, and ambulation). May also provide help with tasks such as preparing meals, doing light housekeeping, and doing laundry. Work is performed in various settings depending on the needs of the care recipient and may include locations such as their home, place of work, out in the community, or at a daytime nonresidential facility.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "31-1131.00",
    "name": "Nursing Assistants",
    "description": "Provide or assist with basic care or support under the direction of onsite licensed nursing staff. Perform duties such as monitoring of health status, feeding, bathing, dressing, grooming, toileting, or ambulation of patients in a health or nursing facility. May include medication administration and other health-related tasks. Includes nursing care attendants, nursing aides, and nursing attendants.",
    "hourlyIncome": 20,
    "annualIncome": 41270,
    "careerGrowth": 4.4,
    "jobZone": 3
  },
  {
    "code": "31-1132.00",
    "name": "Orderlies",
    "description": "Transport patients to areas such as operating rooms or x-ray rooms using wheelchairs, stretchers, or moveable beds. May maintain stocks of supplies or clean and transport equipment. Psychiatric orderlies are included in Psychiatric Aides.",
    "hourlyIncome": 19,
    "annualIncome": 40070,
    "careerGrowth": 4.5,
    "jobZone": 2
  },
  {
    "code": "31-1133.00",
    "name": "Psychiatric Aides",
    "description": "Assist mentally impaired or emotionally disturbed patients, working under direction of nursing and medical staff. May assist with daily living activities, lead patients in educational and recreational activities, or accompany patients to and from examinations and treatments. May restrain violent patients. Includes psychiatric orderlies.",
    "hourlyIncome": 21,
    "annualIncome": 43610,
    "careerGrowth": 0.8,
    "jobZone": 2
  },
  {
    "code": "31-2011.00",
    "name": "Occupational Therapy Assistants",
    "description": "Assist occupational therapists in providing occupational therapy treatments and procedures. May, in accordance with state laws, assist in development of treatment plans, carry out routine functions, direct activity programs, and document the progress of treatments. Generally requires formal training.",
    "hourlyIncome": 33,
    "annualIncome": 68540,
    "careerGrowth": 22.3,
    "jobZone": 3
  },
  {
    "code": "31-2012.00",
    "name": "Occupational Therapy Aides",
    "description": "Under close supervision of an occupational therapist or occupational therapy assistant, perform only delegated, selected, or routine tasks in specific situations. These duties include preparing patient and treatment room.",
    "hourlyIncome": 20,
    "annualIncome": 41850,
    "careerGrowth": 3.7,
    "jobZone": 3
  },
  {
    "code": "31-2021.00",
    "name": "Physical Therapist Assistants",
    "description": "Assist physical therapists in providing physical therapy treatments and procedures. May, in accordance with state laws, assist in the development of treatment plans, carry out routine functions, document the progress of treatment, and modify specific treatments in accordance with patient status and within the scope of treatment plans established by a physical therapist. Generally requires formal training.",
    "hourlyIncome": 32,
    "annualIncome": 67160,
    "careerGrowth": 25.4,
    "jobZone": 3
  },
  {
    "code": "31-2022.00",
    "name": "Physical Therapist Aides",
    "description": "Under close supervision of a physical therapist or physical therapy assistant, perform only delegated, selected, or routine tasks in specific situations. These duties include preparing the patient and the treatment area.",
    "hourlyIncome": 17,
    "annualIncome": 35510,
    "careerGrowth": 2.9,
    "jobZone": 2
  },
  {
    "code": "31-9011.00",
    "name": "Massage Therapists",
    "description": "Perform therapeutic massages of soft tissues and joints. May assist in the assessment of range of motion and muscle strength, or propose client therapy plans.",
    "hourlyIncome": 31,
    "annualIncome": 63430,
    "careerGrowth": 17.7,
    "jobZone": 3
  },
  {
    "code": "31-9091.00",
    "name": "Dental Assistants",
    "description": "Perform limited clinical duties under the direction of a dentist. Clinical duties may include equipment preparation and sterilization, preparing patients for treatment, assisting the dentist during treatment, and providing patients with instructions for oral healthcare procedures. May perform administrative duties such as scheduling appointments, maintaining medical records, billing, and coding information for insurance purposes.",
    "hourlyIncome": 23,
    "annualIncome": 48860,
    "careerGrowth": 8.4,
    "jobZone": 3
  },
  {
    "code": "31-9092.00",
    "name": "Medical Assistants",
    "description": "Perform administrative and certain clinical duties under the direction of a physician. Administrative duties may include scheduling appointments, maintaining medical records, billing, and coding information for insurance purposes. Clinical duties may include taking and recording vital signs and medical histories, preparing patients for examination, drawing blood, and administering medications as directed by physician.",
    "hourlyIncome": 22,
    "annualIncome": 44720,
    "careerGrowth": 15,
    "jobZone": 3
  },
  {
    "code": "31-9093.00",
    "name": "Medical Equipment Preparers",
    "description": "Prepare, sterilize, install, or clean laboratory or healthcare equipment. May perform routine laboratory tasks and operate or inspect equipment.",
    "hourlyIncome": 24,
    "annualIncome": 48990,
    "careerGrowth": 5.7,
    "jobZone": 2
  },
  {
    "code": "31-9094.00",
    "name": "Medical Transcriptionists",
    "description": "Transcribe medical reports recorded by physicians and other healthcare practitioners using various electronic devices, covering office visits, emergency room visits, diagnostic imaging studies, operations, chart reviews, and final summaries. Transcribe dictated reports and translate abbreviations into fully understandable form. Edit as necessary and return reports in either printed or electronic form for review and signature, or correction.",
    "hourlyIncome": 19,
    "annualIncome": 39210,
    "careerGrowth": -4.7,
    "jobZone": 3
  },
  {
    "code": "31-9095.00",
    "name": "Pharmacy Aides",
    "description": "Record drugs delivered to the pharmacy, store incoming merchandise, and inform the supervisor of stock needs. May operate cash register and accept prescriptions for filling.",
    "hourlyIncome": 19,
    "annualIncome": 40290,
    "careerGrowth": 0.9,
    "jobZone": 2
  },
  {
    "code": "31-9096.00",
    "name": "Veterinary Assistants and Laboratory Animal Caretakers",
    "description": "Feed, water, and examine pets and other nonfarm animals for signs of illness, disease, or injury in laboratories and animal hospitals and clinics. Clean and disinfect cages and work areas, and sterilize laboratory and surgical equipment. May provide routine postoperative care, administer medication orally or topically, or prepare samples for laboratory examination under the supervision of veterinary or laboratory animal technologists or technicians, veterinarians, or scientists.",
    "hourlyIncome": 19,
    "annualIncome": 38990,
    "careerGrowth": 19.4,
    "jobZone": 2
  },
  {
    "code": "31-9097.00",
    "name": "Phlebotomists",
    "description": "Draw blood for tests, transfusions, donations, or research. May explain the procedure to patients and assist in the recovery of patients with adverse reactions.",
    "hourlyIncome": 21,
    "annualIncome": 44390,
    "careerGrowth": 7.8,
    "jobZone": 3
  },
  {
    "code": "31-9099.00",
    "name": "Healthcare Support Workers, All Other",
    "description": "All healthcare support workers not listed separately.",
    "hourlyIncome": 23,
    "annualIncome": 48760,
    "careerGrowth": 5.6,
    "jobZone": null
  },
  {
    "code": "31-9099.01",
    "name": "Speech-Language Pathology Assistants",
    "description": "Assist speech-language pathologists in the assessment and treatment of speech, language, voice, and fluency disorders. Implement speech and language programs or activities as planned and directed by speech-language pathologists. Monitor the use of alternative communication devices and systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "31-9099.02",
    "name": "Endoscopy Technicians",
    "description": "Maintain a sterile field to provide support for physicians and nurses during endoscopy procedures. Prepare and maintain instruments and equipment. May obtain specimens.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "33-1011.00",
    "name": "First-Line Supervisors of Correctional Officers",
    "description": "Directly supervise and coordinate activities of correctional officers and jailers.",
    "hourlyIncome": 40,
    "annualIncome": 82260,
    "careerGrowth": -1.6,
    "jobZone": 3
  },
  {
    "code": "33-1012.00",
    "name": "First-Line Supervisors of Police and Detectives",
    "description": "Directly supervise and coordinate activities of members of police force.",
    "hourlyIncome": 53,
    "annualIncome": 110990,
    "careerGrowth": 3.8,
    "jobZone": 2
  },
  {
    "code": "33-1021.00",
    "name": "First-Line Supervisors of Firefighting and Prevention Workers",
    "description": "Directly supervise and coordinate activities of workers engaged in firefighting and fire prevention and control.",
    "hourlyIncome": 47,
    "annualIncome": 97030,
    "careerGrowth": 4.2,
    "jobZone": 3
  },
  {
    "code": "33-1091.00",
    "name": "First-Line Supervisors of Security Workers",
    "description": "Directly supervise and coordinate activities of security workers and security guards.",
    "hourlyIncome": 30,
    "annualIncome": 62990,
    "careerGrowth": 3.7,
    "jobZone": 2
  },
  {
    "code": "33-1099.00",
    "name": "First-Line Supervisors of Protective Service Workers, All Other",
    "description": "All protective service supervisors not listed separately above.",
    "hourlyIncome": 35,
    "annualIncome": 73320,
    "careerGrowth": 4,
    "jobZone": null
  },
  {
    "code": "33-2011.00",
    "name": "Firefighters",
    "description": "Control and extinguish fires or respond to emergency situations where life, property, or the environment is at risk. Duties may include fire prevention, emergency medical service, hazardous material response, search and rescue, and disaster assistance.",
    "hourlyIncome": 31,
    "annualIncome": 63890,
    "careerGrowth": 4.2,
    "jobZone": 3
  },
  {
    "code": "33-2021.00",
    "name": "Fire Inspectors and Investigators",
    "description": "Inspect buildings to detect fire hazards and enforce local ordinances and state laws, or investigate and gather facts to determine cause of fires and explosions.",
    "hourlyIncome": 42,
    "annualIncome": 87440,
    "careerGrowth": 4.5,
    "jobZone": 3
  },
  {
    "code": "33-2022.00",
    "name": "Forest Fire Inspectors and Prevention Specialists",
    "description": "Enforce fire regulations, inspect forest for fire hazards, and recommend forest fire prevention or control measures. May report forest fires and weather conditions.",
    "hourlyIncome": 30,
    "annualIncome": 61820,
    "careerGrowth": 16.3,
    "jobZone": 3
  },
  {
    "code": "33-3011.00",
    "name": "Bailiffs",
    "description": "Maintain order in courts of law.",
    "hourlyIncome": 30,
    "annualIncome": 62180,
    "careerGrowth": -1.4,
    "jobZone": 3
  },
  {
    "code": "33-3012.00",
    "name": "Correctional Officers and Jailers",
    "description": "Guard inmates in penal or rehabilitative institutions in accordance with established regulations and procedures. May guard prisoners in transit between jail, courtroom, prison, or other point. Includes deputy sheriffs and police who spend the majority of their time guarding prisoners in correctional institutions.",
    "hourlyIncome": 30,
    "annualIncome": 62760,
    "careerGrowth": -6.7,
    "jobZone": 2
  },
  {
    "code": "33-3021.00",
    "name": "Detectives and Criminal Investigators",
    "description": "Conduct investigations related to suspected violations of federal, state, or local laws to prevent or solve crimes.",
    "hourlyIncome": 47,
    "annualIncome": 98770,
    "careerGrowth": 2.3,
    "jobZone": 3
  },
  {
    "code": "33-3021.02",
    "name": "Police Identification and Records Officers",
    "description": "Collect evidence at crime scene, classify and identify fingerprints, and photograph evidence for use in criminal and civil cases.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "33-3021.06",
    "name": "Intelligence Analysts",
    "description": "Gather, analyze, or evaluate information from a variety of sources, such as law enforcement databases, surveillance, intelligence networks or geographic information systems. Use intelligence data to anticipate and prevent organized crime activities, such as terrorism.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 4
  },
  {
    "code": "33-3031.00",
    "name": "Fish and Game Wardens",
    "description": "Patrol assigned area to prevent fish and game law violations. Investigate reports of damage to crops or property by wildlife. Compile biological data.",
    "hourlyIncome": 33,
    "annualIncome": 67990,
    "careerGrowth": -5,
    "jobZone": 4
  },
  {
    "code": "33-3041.00",
    "name": "Parking Enforcement Workers",
    "description": "Patrol assigned area, such as public parking lot or city streets to issue tickets to overtime parking violators and illegally parked vehicles.",
    "hourlyIncome": 25,
    "annualIncome": 51840,
    "careerGrowth": -0.4,
    "jobZone": 2
  },
  {
    "code": "33-3051.00",
    "name": "Police and Sheriff's Patrol Officers",
    "description": "Maintain order and protect life and property by enforcing local, tribal, state, or federal laws and ordinances. Perform a combination of the following duties: patrol a specific area; direct traffic; issue traffic summonses; investigate accidents; apprehend and arrest suspects, or serve legal processes of courts. Includes police officers working at educational institutions.",
    "hourlyIncome": 38,
    "annualIncome": 79320,
    "careerGrowth": 3.9,
    "jobZone": 3
  },
  {
    "code": "33-3051.04",
    "name": "Customs and Border Protection Officers",
    "description": "Investigate and inspect persons, common carriers, goods, and merchandise, arriving in or departing from the United States or between states to detect violations of immigration and customs laws and regulations.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "33-3052.00",
    "name": "Transit and Railroad Police",
    "description": "Protect and police railroad and transit property, employees, or passengers.",
    "hourlyIncome": 44,
    "annualIncome": 91820,
    "careerGrowth": 3.5,
    "jobZone": 3
  },
  {
    "code": "33-9011.00",
    "name": "Animal Control Workers",
    "description": "Handle animals for the purpose of investigations of mistreatment, or control of abandoned, dangerous, or unattended animals.",
    "hourlyIncome": 24,
    "annualIncome": 49240,
    "careerGrowth": 4.9,
    "jobZone": 2
  },
  {
    "code": "33-9021.00",
    "name": "Private Detectives and Investigators",
    "description": "Gather, analyze, compile, and report information regarding individuals or organizations to clients, or detect occurrences of unlawful acts or infractions of rules in private establishment.",
    "hourlyIncome": 30,
    "annualIncome": 61680,
    "careerGrowth": 5,
    "jobZone": 3
  },
  {
    "code": "33-9031.00",
    "name": "Gambling Surveillance Officers and Gambling Investigators",
    "description": "Observe gambling operation for irregular activities such as cheating or theft by either employees or patrons. Investigate potential threats to gambling assets such as money, chips, and gambling equipment. Act as oversight and security agent for management and customers.",
    "hourlyIncome": 22,
    "annualIncome": 46710,
    "careerGrowth": 2.6,
    "jobZone": 2
  },
  {
    "code": "33-9032.00",
    "name": "Security Guards",
    "description": "Guard, patrol, or monitor premises to prevent theft, violence, or infractions of rules. May operate x-ray and metal detector equipment.",
    "hourlyIncome": 21,
    "annualIncome": 42890,
    "careerGrowth": 2.2,
    "jobZone": 2
  },
  {
    "code": "33-9091.00",
    "name": "Crossing Guards and Flaggers",
    "description": "Guide or control vehicular or pedestrian traffic at such places as streets, schools, railroad crossings, or construction sites.",
    "hourlyIncome": 21,
    "annualIncome": 42910,
    "careerGrowth": 4.5,
    "jobZone": 2
  },
  {
    "code": "33-9092.00",
    "name": "Lifeguards, Ski Patrol, and Other Recreational Protective Service Workers",
    "description": "Monitor recreational areas, such as pools, beaches, or ski slopes, to provide assistance and protection to participants.",
    "hourlyIncome": 17,
    "annualIncome": 34700,
    "careerGrowth": 6.8,
    "jobZone": 2
  },
  {
    "code": "33-9093.00",
    "name": "Transportation Security Screeners",
    "description": "Conduct screening of passengers, baggage, or cargo to ensure compliance with Transportation Security Administration (TSA) regulations. May operate basic security equipment such as x-ray machines and hand wands at screening checkpoints.",
    "hourlyIncome": 30,
    "annualIncome": 61840,
    "careerGrowth": 0.9,
    "jobZone": 2
  },
  {
    "code": "33-9094.00",
    "name": "School Bus Monitors",
    "description": "Maintain order among students on a school bus. Duties include helping students safely board and exit and communicating behavioral problems. May perform pretrip and posttrip inspections and prepare for and assist in emergency evacuations.",
    "hourlyIncome": 17,
    "annualIncome": 35270,
    "careerGrowth": -2.4,
    "jobZone": 2
  },
  {
    "code": "33-9099.00",
    "name": "Protective Service Workers, All Other",
    "description": "All protective service workers not listed separately.",
    "hourlyIncome": 23,
    "annualIncome": 48210,
    "careerGrowth": 3.3,
    "jobZone": null
  },
  {
    "code": "33-9099.02",
    "name": "Retail Loss Prevention Specialists",
    "description": "Implement procedures and systems to prevent merchandise loss. Conduct audits and investigations of employee activity. May assist in developing policies, procedures, and systems for safeguarding assets.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "35-1011.00",
    "name": "Chefs and Head Cooks",
    "description": "Direct and may participate in the preparation, seasoning, and cooking of salads, soups, fish, meats, vegetables, desserts, or other foods. May plan and price menu items, order supplies, and keep records and accounts.",
    "hourlyIncome": 31,
    "annualIncome": 64720,
    "careerGrowth": 8.3,
    "jobZone": 3
  },
  {
    "code": "35-1012.00",
    "name": "First-Line Supervisors of Food Preparation and Serving Workers",
    "description": "Directly supervise and coordinate activities of workers engaged in preparing and serving food.",
    "hourlyIncome": 22,
    "annualIncome": 44900,
    "careerGrowth": 6.3,
    "jobZone": 2
  },
  {
    "code": "35-2011.00",
    "name": "Cooks, Fast Food",
    "description": "Prepare and cook food in a fast food restaurant with a limited menu. Duties of these cooks are limited to preparation of a few basic items and normally involve operating large-volume single-purpose cooking equipment.",
    "hourlyIncome": 15,
    "annualIncome": 31140,
    "careerGrowth": -13.7,
    "jobZone": 1
  },
  {
    "code": "35-2012.00",
    "name": "Cooks, Institution and Cafeteria",
    "description": "Prepare and cook large quantities of food for institutions, such as schools, hospitals, or cafeterias.",
    "hourlyIncome": 18,
    "annualIncome": 37310,
    "careerGrowth": 3.3,
    "jobZone": 2
  },
  {
    "code": "35-2013.00",
    "name": "Cooks, Private Household",
    "description": "Prepare meals in private homes. Includes personal chefs.",
    "hourlyIncome": 25,
    "annualIncome": 51290,
    "careerGrowth": -6.3,
    "jobZone": 3
  },
  {
    "code": "35-2014.00",
    "name": "Cooks, Restaurant",
    "description": "Prepare, season, and cook dishes such as soups, meats, vegetables, or desserts in restaurants. May order supplies, keep records and accounts, price items on menu, or plan menu.",
    "hourlyIncome": 18,
    "annualIncome": 37730,
    "careerGrowth": 17,
    "jobZone": 2
  },
  {
    "code": "35-2015.00",
    "name": "Cooks, Short Order",
    "description": "Prepare and cook to order a variety of foods that require only a short preparation time. May take orders from customers and serve patrons at counters or tables.",
    "hourlyIncome": 17,
    "annualIncome": 35660,
    "careerGrowth": -4.1,
    "jobZone": 2
  },
  {
    "code": "35-2019.00",
    "name": "Cooks, All Other",
    "description": "All cooks not listed separately.",
    "hourlyIncome": 18,
    "annualIncome": 38000,
    "careerGrowth": 5.2,
    "jobZone": null
  },
  {
    "code": "35-2021.00",
    "name": "Food Preparation Workers",
    "description": "Perform a variety of food preparation duties other than cooking, such as preparing cold foods and shellfish, slicing meat, and brewing coffee or tea.",
    "hourlyIncome": 16,
    "annualIncome": 33940,
    "careerGrowth": -3.8,
    "jobZone": 2
  },
  {
    "code": "35-3011.00",
    "name": "Bartenders",
    "description": "Mix and serve drinks to patrons, directly or through waitstaff.",
    "hourlyIncome": 19,
    "annualIncome": 39880,
    "careerGrowth": 8.8,
    "jobZone": 2
  },
  {
    "code": "35-3023.00",
    "name": "Fast Food and Counter Workers",
    "description": "Perform duties such as taking orders and serving food and beverages. Serve customers at counter or from a steam table. May take payment. May prepare food and beverages.",
    "hourlyIncome": 15,
    "annualIncome": 31350,
    "careerGrowth": 5.7,
    "jobZone": 1
  },
  {
    "code": "35-3023.01",
    "name": "Baristas",
    "description": "Prepare or serve specialty coffee or other beverages. Serve food such as baked goods or sandwiches to patrons.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 1
  },
  {
    "code": "35-3031.00",
    "name": "Waiters and Waitresses",
    "description": "Take orders and serve food and beverages to patrons at tables in dining establishment.",
    "hourlyIncome": 18,
    "annualIncome": 38360,
    "careerGrowth": 1,
    "jobZone": 2
  },
  {
    "code": "35-3041.00",
    "name": "Food Servers, Nonrestaurant",
    "description": "Serve food to individuals outside of a restaurant environment, such as in hotel rooms, hospital rooms, residential care facilities, or cars.",
    "hourlyIncome": 17,
    "annualIncome": 35030,
    "careerGrowth": 4.9,
    "jobZone": 2
  },
  {
    "code": "35-9011.00",
    "name": "Dining Room and Cafeteria Attendants and Bartender Helpers",
    "description": "Facilitate food service. Clean tables; remove dirty dishes; replace soiled table linens; set tables; replenish supply of clean linens, silverware, glassware, and dishes; supply service bar with food; and serve items such as water, condiments, and coffee to patrons.",
    "hourlyIncome": 16,
    "annualIncome": 34190,
    "careerGrowth": 8.3,
    "jobZone": 1
  },
  {
    "code": "35-9021.00",
    "name": "Dishwashers",
    "description": "Clean dishes, kitchen, food preparation equipment, or utensils.",
    "hourlyIncome": 16,
    "annualIncome": 33220,
    "careerGrowth": 1.4,
    "jobZone": 1
  },
  {
    "code": "35-9031.00",
    "name": "Hosts and Hostesses, Restaurant, Lounge, and Coffee Shop",
    "description": "Welcome patrons, seat them at tables or in lounge, and help ensure quality of facilities and service.",
    "hourlyIncome": 15,
    "annualIncome": 32030,
    "careerGrowth": 0.3,
    "jobZone": 2
  },
  {
    "code": "35-9099.00",
    "name": "Food Preparation and Serving Related Workers, All Other",
    "description": "All food preparation and serving related workers not listed separately.",
    "hourlyIncome": 17,
    "annualIncome": 35990,
    "careerGrowth": 7.6,
    "jobZone": null
  },
  {
    "code": "37-1011.00",
    "name": "First-Line Supervisors of Housekeeping and Janitorial Workers",
    "description": "Directly supervise and coordinate work activities of cleaning personnel in hotels, hospitals, offices, and other establishments.",
    "hourlyIncome": 25,
    "annualIncome": 51170,
    "careerGrowth": 4,
    "jobZone": 2
  },
  {
    "code": "37-1012.00",
    "name": "First-Line Supervisors of Landscaping, Lawn Service, and Groundskeeping Workers",
    "description": "Directly supervise and coordinate activities of workers engaged in landscaping or groundskeeping activities. Work may involve reviewing contracts to ascertain service, machine, and workforce requirements; answering inquiries from potential customers regarding methods, material, and price ranges; and preparing estimates according to labor, material, and machine costs.",
    "hourlyIncome": 29,
    "annualIncome": 59380,
    "careerGrowth": 3.5,
    "jobZone": 3
  },
  {
    "code": "37-2011.00",
    "name": "Janitors and Cleaners, Except Maids and Housekeeping Cleaners",
    "description": "Keep buildings in clean and orderly condition. Perform heavy cleaning duties, such as cleaning floors, shampooing rugs, washing walls and glass, and removing rubbish. Duties may include tending furnace and boiler, performing routine maintenance activities, notifying management of need for repairs, and cleaning snow or debris from sidewalk.",
    "hourlyIncome": 18,
    "annualIncome": 37460,
    "careerGrowth": 3.1,
    "jobZone": 3
  },
  {
    "code": "37-2012.00",
    "name": "Maids and Housekeeping Cleaners",
    "description": "Perform any combination of light cleaning duties to maintain private households or commercial establishments, such as hotels and hospitals, in a clean and orderly manner. Duties may include making beds, replenishing linens, cleaning rooms and halls, and vacuuming.",
    "hourlyIncome": 17,
    "annualIncome": 36180,
    "careerGrowth": 0.8,
    "jobZone": 1
  },
  {
    "code": "37-2019.00",
    "name": "Building Cleaning Workers, All Other",
    "description": "All building cleaning workers not listed separately.",
    "hourlyIncome": 21,
    "annualIncome": 44150,
    "careerGrowth": 4.3,
    "jobZone": null
  },
  {
    "code": "37-2021.00",
    "name": "Pest Control Workers",
    "description": "Apply or release chemical solutions or toxic gases and set traps to kill or remove pests and vermin that infest buildings and surrounding areas.",
    "hourlyIncome": 22,
    "annualIncome": 45800,
    "careerGrowth": 7,
    "jobZone": 2
  },
  {
    "code": "37-3011.00",
    "name": "Landscaping and Groundskeeping Workers",
    "description": "Landscape or maintain grounds of property using hand or power tools or equipment. Workers typically perform a variety of tasks, which may include any combination of the following: sod laying, mowing, trimming, planting, watering, fertilizing, digging, raking, sprinkler installation, and installation of mortarless segmental concrete masonry wall units.",
    "hourlyIncome": 20,
    "annualIncome": 40880,
    "careerGrowth": 5.1,
    "jobZone": 1
  },
  {
    "code": "37-3012.00",
    "name": "Pesticide Handlers, Sprayers, and Applicators, Vegetation",
    "description": "Mix or apply pesticides, herbicides, fungicides, or insecticides through sprays, dusts, vapors, soil incorporation, or chemical application on trees, shrubs, lawns, or crops. Usually requires specific training and state or federal certification.",
    "hourlyIncome": 22,
    "annualIncome": 45960,
    "careerGrowth": 5.1,
    "jobZone": 2
  },
  {
    "code": "37-3013.00",
    "name": "Tree Trimmers and Pruners",
    "description": "Using sophisticated climbing and rigging techniques, cut away dead or excess branches from trees or shrubs to maintain right-of-way for roads, sidewalks, or utilities, or to improve appearance, health, and value of tree. Prune or treat trees or shrubs using handsaws, hand pruners, clippers, and power pruners. Works off the ground in the tree canopy and may use truck-mounted lifts.",
    "hourlyIncome": 26,
    "annualIncome": 54970,
    "careerGrowth": 4.8,
    "jobZone": 2
  },
  {
    "code": "37-3019.00",
    "name": "Grounds Maintenance Workers, All Other",
    "description": "All grounds maintenance workers not listed separately.",
    "hourlyIncome": 23,
    "annualIncome": 47180,
    "careerGrowth": 3.8,
    "jobZone": null
  },
  {
    "code": "39-1013.00",
    "name": "First-Line Supervisors of Gambling Services Workers",
    "description": "Directly supervise and coordinate activities of workers in assigned gambling areas. May circulate among tables, observe operations, and ensure that stations and games are covered for each shift. May verify and pay off jackpots. May reset slot machines after payoffs and make repairs or adjustments to slot machines or recommend removal of slot machines for repair. May plan and organize activities and services for guests in hotels/casinos.",
    "hourlyIncome": 30,
    "annualIncome": 62600,
    "careerGrowth": 5.2,
    "jobZone": 2
  },
  {
    "code": "39-1014.00",
    "name": "First-Line Supervisors of Entertainment and Recreation Workers, Except Gambling Services",
    "description": "Directly supervise and coordinate activities of entertainment and recreation related workers.",
    "hourlyIncome": 25,
    "annualIncome": 51400,
    "careerGrowth": 9.1,
    "jobZone": 2
  },
  {
    "code": "39-1022.00",
    "name": "First-Line Supervisors of Personal Service Workers",
    "description": "Supervise and coordinate activities of personal service workers.",
    "hourlyIncome": 24,
    "annualIncome": 50920,
    "careerGrowth": 10.1,
    "jobZone": 3
  },
  {
    "code": "39-2011.00",
    "name": "Animal Trainers",
    "description": "Train animals for riding, harness, security, performance, or obedience, or for assisting persons with disabilities. Accustom animals to human voice and contact, and condition animals to respond to commands. Train animals according to prescribed standards for show or competition. May train animals to carry pack loads or work as part of pack team.",
    "hourlyIncome": 22,
    "annualIncome": 45780,
    "careerGrowth": 6.4,
    "jobZone": 2
  },
  {
    "code": "39-2021.00",
    "name": "Animal Caretakers",
    "description": "Feed, water, groom, bathe, exercise, or otherwise provide care to promote and maintain the well-being of pets and other animals that are not raised for consumption, such as dogs, cats, race horses, ornamental fish or birds, zoo animals, and mice. Work in settings such as kennels, animal shelters, zoos, circuses, and aquariums. May keep records of feedings, treatments, and animals received or discharged. May clean, disinfect, and repair cages, pens, or fish tanks.",
    "hourlyIncome": 17,
    "annualIncome": 34750,
    "careerGrowth": 16.6,
    "jobZone": 2
  },
  {
    "code": "39-3011.00",
    "name": "Gambling Dealers",
    "description": "Operate table games. Stand or sit behind table and operate games of chance by dispensing the appropriate number of cards or blocks to players, or operating other gambling equipment. Distribute winnings or collect players' money or chips. May compare the house's hand against players' hands.",
    "hourlyIncome": 19,
    "annualIncome": 40420,
    "careerGrowth": 3.2,
    "jobZone": 2
  },
  {
    "code": "39-3012.00",
    "name": "Gambling and Sports Book Writers and Runners",
    "description": "Post information enabling patrons to wager on various races and sporting events. Assist in the operation of games such as keno and bingo. May operate random number-generating equipment and announce the numbers for patrons. Receive, verify, and record patrons' wagers. Scan and process winning tickets presented by patrons and pay out winnings for those wagers.",
    "hourlyIncome": 16,
    "annualIncome": 32570,
    "careerGrowth": -2.4,
    "jobZone": 2
  },
  {
    "code": "39-3019.00",
    "name": "Gambling Service Workers, All Other",
    "description": "All gambling service workers not listed separately.",
    "hourlyIncome": 18,
    "annualIncome": 37590,
    "careerGrowth": 2.9,
    "jobZone": null
  },
  {
    "code": "39-3021.00",
    "name": "Motion Picture Projectionists",
    "description": "Set up and operate motion picture projection and related sound reproduction equipment.",
    "hourlyIncome": 24,
    "annualIncome": 50290,
    "careerGrowth": -5,
    "jobZone": 2
  },
  {
    "code": "39-3031.00",
    "name": "Ushers, Lobby Attendants, and Ticket Takers",
    "description": "Assist patrons at entertainment events by performing duties, such as collecting admission tickets and passes from patrons, assisting in finding seats, searching for lost articles, and helping patrons locate such facilities as restrooms and telephones.",
    "hourlyIncome": 15,
    "annualIncome": 31770,
    "careerGrowth": 2.6,
    "jobZone": 2
  },
  {
    "code": "39-3091.00",
    "name": "Amusement and Recreation Attendants",
    "description": "Perform a variety of attending duties at amusement or recreation facility. May schedule use of recreation facilities, maintain and provide equipment to participants of sporting events or recreational pursuits, or operate amusement concessions and rides.",
    "hourlyIncome": 15,
    "annualIncome": 31350,
    "careerGrowth": 4.5,
    "jobZone": 1
  },
  {
    "code": "39-3092.00",
    "name": "Costume Attendants",
    "description": "Select, fit, and take care of costumes for cast members, and aid entertainers. May assist with multiple costume changes during performances.",
    "hourlyIncome": 32,
    "annualIncome": 65890,
    "careerGrowth": 7.1,
    "jobZone": 2
  },
  {
    "code": "39-3093.00",
    "name": "Locker Room, Coatroom, and Dressing Room Attendants",
    "description": "Provide personal items to patrons or customers in locker rooms, dressing rooms, or coatrooms.",
    "hourlyIncome": 18,
    "annualIncome": 36490,
    "careerGrowth": 8,
    "jobZone": 2
  },
  {
    "code": "39-3099.00",
    "name": "Entertainment Attendants and Related Workers, All Other",
    "description": "All entertainment attendants and related workers not listed separately.",
    "hourlyIncome": 17,
    "annualIncome": 36180,
    "careerGrowth": 5.2,
    "jobZone": null
  },
  {
    "code": "39-4011.00",
    "name": "Embalmers",
    "description": "Prepare bodies for interment in conformity with legal requirements.",
    "hourlyIncome": 28,
    "annualIncome": 57520,
    "careerGrowth": 1.2,
    "jobZone": 3
  },
  {
    "code": "39-4012.00",
    "name": "Crematory Operators",
    "description": "Operate crematory equipment to reduce human or animal remains to bone fragments in accordance with state and local regulations. Duties may include preparing the body for cremation and performing general maintenance on crematory equipment. May use traditional flame-based cremation, calcination, or alkaline hydrolysis.",
    "hourlyIncome": 22,
    "annualIncome": 44790,
    "careerGrowth": 4.7,
    "jobZone": 2
  },
  {
    "code": "39-4021.00",
    "name": "Funeral Attendants",
    "description": "Perform a variety of tasks during funeral, such as placing casket in parlor or chapel prior to service, arranging floral offerings or lights around casket, directing or escorting mourners, closing casket, and issuing and storing funeral equipment.",
    "hourlyIncome": 17,
    "annualIncome": 35900,
    "careerGrowth": 3.2,
    "jobZone": 2
  },
  {
    "code": "39-4031.00",
    "name": "Morticians, Undertakers, and Funeral Arrangers",
    "description": "Perform various tasks to arrange and direct individual funeral services, such as coordinating transportation of body to mortuary, interviewing family or other authorized person to arrange details, selecting pallbearers, aiding with the selection of officials for religious rites, and providing transportation for mourners.",
    "hourlyIncome": 27,
    "annualIncome": 56340,
    "careerGrowth": 3.5,
    "jobZone": 3
  },
  {
    "code": "39-5011.00",
    "name": "Barbers",
    "description": "Provide barbering services, such as cutting, trimming, shampooing, and styling hair; trimming beards; or giving shaves.",
    "hourlyIncome": 23,
    "annualIncome": 47800,
    "careerGrowth": 6.4,
    "jobZone": 3
  },
  {
    "code": "39-5012.00",
    "name": "Hairdressers, Hairstylists, and Cosmetologists",
    "description": "Provide beauty services, such as cutting, coloring, and styling hair, and massaging and treating scalp. May shampoo hair, apply makeup, dress wigs, remove hair, and provide nail and skincare services.",
    "hourlyIncome": 21,
    "annualIncome": 43460,
    "careerGrowth": 7.1,
    "jobZone": 3
  },
  {
    "code": "39-5091.00",
    "name": "Makeup Artists, Theatrical and Performance",
    "description": "Apply makeup to performers to reflect period, setting, and situation of their role.",
    "hourlyIncome": 36,
    "annualIncome": 75410,
    "careerGrowth": 9.4,
    "jobZone": 3
  },
  {
    "code": "39-5092.00",
    "name": "Manicurists and Pedicurists",
    "description": "Clean and shape customers' fingernails and toenails. May polish or decorate nails.",
    "hourlyIncome": 18,
    "annualIncome": 36910,
    "careerGrowth": 11.8,
    "jobZone": 2
  },
  {
    "code": "39-5093.00",
    "name": "Shampooers",
    "description": "Shampoo and rinse customers' hair.",
    "hourlyIncome": 15,
    "annualIncome": 30830,
    "careerGrowth": 9.5,
    "jobZone": 2
  },
  {
    "code": "39-5094.00",
    "name": "Skincare Specialists",
    "description": "Provide skincare treatments to face and body to enhance an individual's appearance. Includes electrologists and laser hair removal specialists.",
    "hourlyIncome": 23,
    "annualIncome": 48670,
    "careerGrowth": 10.3,
    "jobZone": 3
  },
  {
    "code": "39-6011.00",
    "name": "Baggage Porters and Bellhops",
    "description": "Handle baggage for travelers at transportation terminals or for guests at hotels or similar establishments.",
    "hourlyIncome": 18,
    "annualIncome": 36960,
    "careerGrowth": 0.5,
    "jobZone": 2
  },
  {
    "code": "39-6012.00",
    "name": "Concierges",
    "description": "Assist patrons at hotel, apartment, or office building with personal services. May take messages; arrange or give advice on transportation, business services, or entertainment; or monitor guest requests for housekeeping and maintenance.",
    "hourlyIncome": 20,
    "annualIncome": 40770,
    "careerGrowth": 5.4,
    "jobZone": 3
  },
  {
    "code": "39-7011.00",
    "name": "Tour Guides and Escorts",
    "description": "Escort individuals or groups on sightseeing tours or through places of interest, such as industrial establishments, public buildings, and art galleries.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "39-7012.00",
    "name": "Travel Guides",
    "description": "Plan, organize, and conduct long-distance travel, tours, and expeditions for individuals and groups.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "39-9011.00",
    "name": "Childcare Workers",
    "description": "Attend to children at schools, businesses, private households, and childcare institutions. Perform a variety of tasks, such as dressing, feeding, bathing, and overseeing play.",
    "hourlyIncome": 16,
    "annualIncome": 33140,
    "careerGrowth": -1.3,
    "jobZone": 2
  },
  {
    "code": "39-9011.01",
    "name": "Nannies",
    "description": "Care for children in private households and provide support and expertise to parents in satisfying children's physical, emotional, intellectual, and social needs. Duties may include meal planning and preparation, laundry and clothing care, organization of play activities and outings, discipline, intellectual stimulation, language activities, and transportation.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "39-9031.00",
    "name": "Exercise Trainers and Group Fitness Instructors",
    "description": "Instruct or coach groups or individuals in exercise activities for the primary purpose of personal fitness. Demonstrate techniques and form, observe participants, and explain to them corrective measures necessary to improve their skills. Develop and implement individualized approaches to exercise.",
    "hourlyIncome": 25,
    "annualIncome": 51360,
    "careerGrowth": 13.6,
    "jobZone": 3
  },
  {
    "code": "39-9032.00",
    "name": "Recreation Workers",
    "description": "Conduct recreation activities with groups in public, private, or volunteer agencies or recreation facilities. Organize and promote activities, such as arts and crafts, sports, games, music, dramatics, social recreation, camping, and hobbies, taking into account the needs and interests of individual members.",
    "hourlyIncome": 18,
    "annualIncome": 37170,
    "careerGrowth": 5.5,
    "jobZone": 4
  },
  {
    "code": "39-9041.00",
    "name": "Residential Advisors",
    "description": "Coordinate activities in resident facilities in secondary school and college dormitories, group homes, or similar establishments. Order supplies and determine need for maintenance, repairs, and furnishings. May maintain household records and assign rooms. May assist residents with problem solving or refer them to counseling resources.",
    "hourlyIncome": 20,
    "annualIncome": 41590,
    "careerGrowth": 5.2,
    "jobZone": 3
  },
  {
    "code": "39-9099.00",
    "name": "Personal Care and Service Workers, All Other",
    "description": "All personal care and service workers not listed separately.",
    "hourlyIncome": 18,
    "annualIncome": 37990,
    "careerGrowth": 12.1,
    "jobZone": null
  },
  {
    "code": "41-1011.00",
    "name": "First-Line Supervisors of Retail Sales Workers",
    "description": "Directly supervise and coordinate activities of retail sales workers in an establishment or department. Duties may include management functions, such as purchasing, budgeting, accounting, and personnel work, in addition to supervisory duties.",
    "hourlyIncome": 25,
    "annualIncome": 52350,
    "careerGrowth": -6.4,
    "jobZone": 2
  },
  {
    "code": "41-1012.00",
    "name": "First-Line Supervisors of Non-Retail Sales Workers",
    "description": "Directly supervise and coordinate activities of sales workers other than retail sales workers. May perform duties such as budgeting, accounting, and personnel work, in addition to supervisory duties.",
    "hourlyIncome": 47,
    "annualIncome": 97870,
    "careerGrowth": 1.2,
    "jobZone": 4
  },
  {
    "code": "41-2011.00",
    "name": "Cashiers",
    "description": "Receive and disburse money in establishments other than financial institutions. May use electronic scanners, cash registers, or related equipment. May process credit or debit card transactions and validate checks.",
    "hourlyIncome": 15,
    "annualIncome": 31810,
    "careerGrowth": -10.6,
    "jobZone": 2
  },
  {
    "code": "41-2012.00",
    "name": "Gambling Change Persons and Booth Cashiers",
    "description": "Exchange coins, tokens, and chips for patrons' money. May issue payoffs and obtain customer's signature on receipt. May operate a booth in the slot machine area and furnish change persons with money bank at the start of the shift, or count and audit money in drawers.",
    "hourlyIncome": 18,
    "annualIncome": 36820,
    "careerGrowth": -4.3,
    "jobZone": 2
  },
  {
    "code": "41-2021.00",
    "name": "Counter and Rental Clerks",
    "description": "Receive orders, generally in person, for repairs, rentals, and services. May describe available options, compute cost, and accept payment.",
    "hourlyIncome": 21,
    "annualIncome": 43700,
    "careerGrowth": 4.2,
    "jobZone": 2
  },
  {
    "code": "41-2022.00",
    "name": "Parts Salespersons",
    "description": "Sell spare and replacement parts and equipment in repair shop or parts store.",
    "hourlyIncome": 20,
    "annualIncome": 42390,
    "careerGrowth": 1.2,
    "jobZone": 2
  },
  {
    "code": "41-2031.00",
    "name": "Retail Salespersons",
    "description": "Sell merchandise, such as furniture, motor vehicles, appliances, or apparel to consumers.",
    "hourlyIncome": 18,
    "annualIncome": 37150,
    "careerGrowth": 0.1,
    "jobZone": 2
  },
  {
    "code": "41-3011.00",
    "name": "Advertising Sales Agents",
    "description": "Sell or solicit advertising space, time, or media in publications, signage, TV, radio, or Internet establishments or public spaces.",
    "hourlyIncome": 37,
    "annualIncome": 76350,
    "careerGrowth": -6.6,
    "jobZone": 4
  },
  {
    "code": "41-3021.00",
    "name": "Insurance Sales Agents",
    "description": "Sell life, property, casualty, health, automotive, or other types of insurance. May refer clients to independent brokers, work as an independent broker, or be employed by an insurance company.",
    "hourlyIncome": 39,
    "annualIncome": 81510,
    "careerGrowth": 6.1,
    "jobZone": 4
  },
  {
    "code": "41-3031.00",
    "name": "Securities, Commodities, and Financial Services Sales Agents",
    "description": "Buy and sell securities or commodities in investment and trading firms, or provide financial services to businesses and individuals. May advise customers about stocks, bonds, mutual funds, commodities, and market conditions.",
    "hourlyIncome": 53,
    "annualIncome": 110400,
    "careerGrowth": 6.6,
    "jobZone": 4
  },
  {
    "code": "41-3041.00",
    "name": "Travel Agents",
    "description": "Plan and sell transportation and accommodations for customers. Determine destination, modes of transportation, travel dates, costs, and accommodations required. May also describe, plan, and arrange itineraries and sell tour packages. May assist in resolving clients' travel problems.",
    "hourlyIncome": 25,
    "annualIncome": 52690,
    "careerGrowth": 3.4,
    "jobZone": 3
  },
  {
    "code": "41-3091.00",
    "name": "Sales Representatives of Services, Except Advertising, Insurance, Financial Services, and Travel",
    "description": "Sell services to individuals or businesses. May describe options or resolve client problems.",
    "hourlyIncome": 39,
    "annualIncome": 81260,
    "careerGrowth": 3.8,
    "jobZone": 2
  },
  {
    "code": "41-4011.00",
    "name": "Sales Representatives, Wholesale and Manufacturing, Technical and Scientific Products",
    "description": "Sell goods for wholesalers or manufacturers where technical or scientific knowledge is required in such areas as biology, engineering, chemistry, and electronics, normally obtained from at least 2 years of postsecondary education.",
    "hourlyIncome": 55,
    "annualIncome": 114520,
    "careerGrowth": 3.1,
    "jobZone": 4
  },
  {
    "code": "41-4011.07",
    "name": "Solar Sales Representatives and Assessors",
    "description": "Contact new or existing customers to determine their solar equipment needs, suggest systems or equipment, or estimate costs.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "41-4012.00",
    "name": "Sales Representatives, Wholesale and Manufacturing, Except Technical and Scientific Products",
    "description": "Sell goods for wholesalers or manufacturers to businesses or groups of individuals. Work requires substantial knowledge of items sold.",
    "hourlyIncome": 39,
    "annualIncome": 81470,
    "careerGrowth": 0.7,
    "jobZone": 4
  },
  {
    "code": "41-9011.00",
    "name": "Demonstrators and Product Promoters",
    "description": "Demonstrate merchandise and answer questions for the purpose of creating public interest in buying the product. May sell demonstrated merchandise.",
    "hourlyIncome": 21,
    "annualIncome": 43730,
    "careerGrowth": 4.9,
    "jobZone": 2
  },
  {
    "code": "41-9012.00",
    "name": "Models",
    "description": "Model garments or other apparel and accessories for prospective buyers at fashion shows, private showings, or retail establishments. May pose for photos to be used in magazines or advertisements. May pose as subject for paintings, sculptures, and other types of artistic expression.",
    "hourlyIncome": 39,
    "annualIncome": 81540,
    "careerGrowth": -0.4,
    "jobZone": 2
  },
  {
    "code": "41-9021.00",
    "name": "Real Estate Brokers",
    "description": "Operate real estate office, or work for commercial real estate firm, overseeing real estate transactions. Other duties usually include selling real estate or renting properties and arranging loans.",
    "hourlyIncome": 44,
    "annualIncome": 91660,
    "careerGrowth": 2,
    "jobZone": 4
  },
  {
    "code": "41-9022.00",
    "name": "Real Estate Sales Agents",
    "description": "Rent, buy, or sell property for clients. Perform duties such as study property listings, interview prospective clients, accompany clients to property site, discuss conditions of sale, and draw up real estate contracts. Includes agents who represent buyer.",
    "hourlyIncome": 34,
    "annualIncome": 70970,
    "careerGrowth": 1.8,
    "jobZone": 3
  },
  {
    "code": "41-9031.00",
    "name": "Sales Engineers",
    "description": "Sell business goods or services, the selling of which requires a technical background equivalent to a baccalaureate degree in engineering.",
    "hourlyIncome": 63,
    "annualIncome": 130410,
    "careerGrowth": 6.3,
    "jobZone": 4
  },
  {
    "code": "41-9041.00",
    "name": "Telemarketers",
    "description": "Solicit donations or orders for goods or services over the telephone.",
    "hourlyIncome": 17,
    "annualIncome": 36340,
    "careerGrowth": -21.5,
    "jobZone": 2
  },
  {
    "code": "41-9091.00",
    "name": "Door-to-Door Sales Workers, News and Street Vendors, and Related Workers",
    "description": "Sell goods or services door-to-door or on the street.",
    "hourlyIncome": 19,
    "annualIncome": 39890,
    "careerGrowth": -14.6,
    "jobZone": 1
  },
  {
    "code": "41-9099.00",
    "name": "Sales and Related Workers, All Other",
    "description": "All sales and related workers not listed separately.",
    "hourlyIncome": 27,
    "annualIncome": 57030,
    "careerGrowth": 3.9,
    "jobZone": null
  },
  {
    "code": "43-1011.00",
    "name": "First-Line Supervisors of Office and Administrative Support Workers",
    "description": "Directly supervise and coordinate the activities of clerical and administrative support workers.",
    "hourlyIncome": 34,
    "annualIncome": 71560,
    "careerGrowth": -4.4,
    "jobZone": 3
  },
  {
    "code": "43-2011.00",
    "name": "Switchboard Operators, Including Answering Service",
    "description": "Operate telephone business systems equipment or switchboards to relay incoming, outgoing, and interoffice calls. May supply information to callers and record messages.",
    "hourlyIncome": 20,
    "annualIncome": 42130,
    "careerGrowth": -25.2,
    "jobZone": 2
  },
  {
    "code": "43-2021.00",
    "name": "Telephone Operators",
    "description": "Provide information by accessing alphabetical, geographical, or other directories. Assist customers with special billing requests, such as charges to a third party and credits or refunds for incorrectly dialed numbers or bad connections. May handle emergency calls and assist children or people with physical disabilities to make telephone calls.",
    "hourlyIncome": 21,
    "annualIncome": 42880,
    "careerGrowth": -26.4,
    "jobZone": 2
  },
  {
    "code": "43-2099.00",
    "name": "Communications Equipment Operators, All Other",
    "description": "All communications equipment operators not listed separately.",
    "hourlyIncome": 27,
    "annualIncome": 55890,
    "careerGrowth": 5.1,
    "jobZone": null
  },
  {
    "code": "43-3011.00",
    "name": "Bill and Account Collectors",
    "description": "Locate and notify customers of delinquent accounts by mail, telephone, or personal visit to solicit payment. Duties include receiving payment and posting amount to customer's account, preparing statements to credit department if customer fails to respond, initiating repossession proceedings or service disconnection, and keeping records of collection and status of accounts.",
    "hourlyIncome": 23,
    "annualIncome": 48370,
    "careerGrowth": -9.5,
    "jobZone": 2
  },
  {
    "code": "43-3021.00",
    "name": "Billing and Posting Clerks",
    "description": "Compile, compute, and record billing, accounting, statistical, and other numerical data for billing purposes. Prepare billing invoices for services rendered or for delivery or shipment of goods.",
    "hourlyIncome": 24,
    "annualIncome": 49490,
    "careerGrowth": 0.5,
    "jobZone": 3
  },
  {
    "code": "43-3031.00",
    "name": "Bookkeeping, Accounting, and Auditing Clerks",
    "description": "Compute, classify, and record numerical data to keep financial records complete. Perform any combination of routine calculating, posting, and verifying duties to obtain primary financial data for use in maintaining accounting records. May also check the accuracy of figures, calculations, and postings pertaining to business transactions recorded by other workers.",
    "hourlyIncome": 25,
    "annualIncome": 52020,
    "careerGrowth": -5,
    "jobZone": 3
  },
  {
    "code": "43-3041.00",
    "name": "Gambling Cage Workers",
    "description": "In a gambling establishment, conduct financial transactions for patrons. Accept patron's credit application and verify credit references to provide check-cashing authorization or to establish house credit accounts. May reconcile daily summaries of transactions to balance books. May sell gambling chips, tokens, or tickets to patrons, or to other workers for resale to patrons. May convert gambling chips, tokens, or tickets to currency upon patron's request. May use a cash register or computer to record transaction.",
    "hourlyIncome": 19,
    "annualIncome": 38600,
    "careerGrowth": -3.7,
    "jobZone": 2
  },
  {
    "code": "43-3051.00",
    "name": "Payroll and Timekeeping Clerks",
    "description": "Compile and record employee time and payroll data. May compute employees' time worked, production, and commission. May compute and post wages and deductions, or prepare paychecks.",
    "hourlyIncome": 27,
    "annualIncome": 56870,
    "careerGrowth": -15.1,
    "jobZone": 3
  },
  {
    "code": "43-3061.00",
    "name": "Procurement Clerks",
    "description": "Compile information and records to draw up purchase orders for procurement of materials and services.",
    "hourlyIncome": 24,
    "annualIncome": 50430,
    "careerGrowth": -6.7,
    "jobZone": 2
  },
  {
    "code": "43-3071.00",
    "name": "Tellers",
    "description": "Receive and pay out money. Keep records of money and negotiable instruments involved in a financial institution's various transactions.",
    "hourlyIncome": 20,
    "annualIncome": 40940,
    "careerGrowth": -14.7,
    "jobZone": 2
  },
  {
    "code": "43-3099.00",
    "name": "Financial Clerks, All Other",
    "description": "All financial clerks not listed separately.",
    "hourlyIncome": 27,
    "annualIncome": 55330,
    "careerGrowth": 2.3,
    "jobZone": null
  },
  {
    "code": "43-4011.00",
    "name": "Brokerage Clerks",
    "description": "Perform duties related to the purchase, sale, or holding of securities. Duties include writing orders for stock purchases or sales, computing transfer taxes, verifying stock transactions, accepting and delivering securities, tracking stock price fluctuations, computing equity, distributing dividends, and keeping records of daily transactions and holdings.",
    "hourlyIncome": 33,
    "annualIncome": 67680,
    "careerGrowth": -2.8,
    "jobZone": 3
  },
  {
    "code": "43-4021.00",
    "name": "Correspondence Clerks",
    "description": "Compose letters or electronic correspondence in reply to requests for merchandise, damage claims, credit and other information, delinquent accounts, incorrect billings, or unsatisfactory services. Duties may include gathering data to formulate reply and preparing correspondence.",
    "hourlyIncome": 22,
    "annualIncome": 46610,
    "careerGrowth": -6.7,
    "jobZone": 2
  },
  {
    "code": "43-4031.00",
    "name": "Court, Municipal, and License Clerks",
    "description": "Perform clerical duties for courts of law, municipalities, or governmental licensing agencies and bureaus. May prepare docket of cases to be called; secure information for judges and court; prepare draft agendas or bylaws for town or city council; answer official correspondence; keep fiscal records and accounts; issue licenses or permits; and record data, administer tests, or collect fees.",
    "hourlyIncome": 25,
    "annualIncome": 51200,
    "careerGrowth": 3.8,
    "jobZone": 2
  },
  {
    "code": "43-4041.00",
    "name": "Credit Authorizers, Checkers, and Clerks",
    "description": "Authorize credit charges against customers' accounts. Investigate history and credit standing of individuals or business establishments applying for credit. May interview applicants to obtain personal and financial data, determine credit worthiness, process applications, and notify customers of acceptance or rejection of credit.",
    "hourlyIncome": 25,
    "annualIncome": 51270,
    "careerGrowth": -5.2,
    "jobZone": 2
  },
  {
    "code": "43-4051.00",
    "name": "Customer Service Representatives",
    "description": "Interact with customers to provide basic or scripted information in response to routine inquiries about products and services. May handle and resolve general complaints. Excludes individuals whose duties are primarily installation, sales, repair, and technical support.",
    "hourlyIncome": 22,
    "annualIncome": 45380,
    "careerGrowth": -5,
    "jobZone": 2
  },
  {
    "code": "43-4061.00",
    "name": "Eligibility Interviewers, Government Programs",
    "description": "Determine eligibility of persons applying to receive assistance from government programs and agency resources, such as welfare, unemployment benefits, social security, and public housing.",
    "hourlyIncome": 26,
    "annualIncome": 53970,
    "careerGrowth": 3.1,
    "jobZone": 3
  },
  {
    "code": "43-4071.00",
    "name": "File Clerks",
    "description": "File correspondence, cards, invoices, receipts, and other records in alphabetical or numerical order or according to the filing system used. Locate and remove material from file when requested.",
    "hourlyIncome": 21,
    "annualIncome": 43700,
    "careerGrowth": -15.3,
    "jobZone": 2
  },
  {
    "code": "43-4081.00",
    "name": "Hotel, Motel, and Resort Desk Clerks",
    "description": "Accommodate hotel, motel, and resort patrons by registering and assigning rooms to guests, issuing room keys or cards, transmitting and receiving messages, keeping records of occupied rooms and guests' accounts, making and confirming reservations, and presenting statements to and collecting payments from departing guests.",
    "hourlyIncome": 17,
    "annualIncome": 34740,
    "careerGrowth": 7,
    "jobZone": 2
  },
  {
    "code": "43-4111.00",
    "name": "Interviewers, Except Eligibility and Loan",
    "description": "Interview persons by telephone, mail, in person, or by other means for the purpose of completing forms, applications, or questionnaires. Ask specific questions, record answers, and assist persons with completing form. May sort, classify, and file forms.",
    "hourlyIncome": 22,
    "annualIncome": 45400,
    "careerGrowth": -9.9,
    "jobZone": 3
  },
  {
    "code": "43-4121.00",
    "name": "Library Assistants, Clerical",
    "description": "Compile records, and sort, shelve, issue, and receive library materials such as books, electronic media, pictures, cards, slides and microfilm. Locate library materials for loan and replace material in shelving area, stacks, or files according to identification number and title. Register patrons to permit them to borrow books, periodicals, and other library materials.",
    "hourlyIncome": 18,
    "annualIncome": 37910,
    "careerGrowth": -5.7,
    "jobZone": 2
  },
  {
    "code": "43-4131.00",
    "name": "Loan Interviewers and Clerks",
    "description": "Interview loan applicants to elicit information; investigate applicants' backgrounds and verify references; prepare loan request papers; and forward findings, reports, and documents to appraisal department. Review loan papers to ensure completeness, and complete transactions between loan establishment, borrowers, and sellers upon approval of loan.",
    "hourlyIncome": 25,
    "annualIncome": 51050,
    "careerGrowth": -2.4,
    "jobZone": 3
  },
  {
    "code": "43-4141.00",
    "name": "New Accounts Clerks",
    "description": "Interview persons desiring to open accounts in financial institutions. Explain account services available to prospective customers and assist them in preparing applications.",
    "hourlyIncome": 23,
    "annualIncome": 47610,
    "careerGrowth": -14.6,
    "jobZone": 3
  },
  {
    "code": "43-4151.00",
    "name": "Order Clerks",
    "description": "Receive and process incoming orders for materials, merchandise, classified ads, or services such as repairs, installations, or rental of facilities. Generally receives orders via mail, phone, fax, or other electronic means. Duties include informing customers of receipt, prices, shipping dates, and delays; preparing contracts; and handling complaints.",
    "hourlyIncome": 22,
    "annualIncome": 46270,
    "careerGrowth": -17.9,
    "jobZone": 2
  },
  {
    "code": "43-4161.00",
    "name": "Human Resources Assistants, Except Payroll and Timekeeping",
    "description": "Compile and keep personnel records. Record data for each employee, such as address, weekly earnings, absences, amount of sales or production, supervisory reports, and date of and reason for termination. May prepare reports for employment records, file employment records, or search employee files and furnish information to authorized persons.",
    "hourlyIncome": 25,
    "annualIncome": 50950,
    "careerGrowth": -4.8,
    "jobZone": 3
  },
  {
    "code": "43-4171.00",
    "name": "Receptionists and Information Clerks",
    "description": "Answer inquiries and provide information to the general public, customers, visitors, and other interested parties regarding activities conducted at establishment and location of departments, offices, and employees within the organization.",
    "hourlyIncome": 19,
    "annualIncome": 38480,
    "careerGrowth": -0.5,
    "jobZone": 2
  },
  {
    "code": "43-4181.00",
    "name": "Reservation and Transportation Ticket Agents and Travel Clerks",
    "description": "Make and confirm reservations for transportation or lodging, or sell transportation tickets. May check baggage and direct passengers to designated concourse, pier, or track; deliver tickets and contact individuals and groups to inform them of package tours; or provide tourists with travel or transportation information.",
    "hourlyIncome": 23,
    "annualIncome": 47720,
    "careerGrowth": 3.8,
    "jobZone": 2
  },
  {
    "code": "43-4199.00",
    "name": "Information and Record Clerks, All Other",
    "description": "All information and record clerks not listed separately.",
    "hourlyIncome": 24,
    "annualIncome": 50200,
    "careerGrowth": 2.9,
    "jobZone": null
  },
  {
    "code": "43-5011.00",
    "name": "Cargo and Freight Agents",
    "description": "Expedite and route movement of incoming and outgoing cargo and freight shipments in airline, train, and trucking terminals and shipping docks. Take orders from customers and arrange pickup of freight and cargo for delivery to loading platform. Prepare and examine bills of lading to determine shipping charges and tariffs.",
    "hourlyIncome": 27,
    "annualIncome": 55420,
    "careerGrowth": 9.7,
    "jobZone": 2
  },
  {
    "code": "43-5011.01",
    "name": "Freight Forwarders",
    "description": "Research rates, routings, or modes of transport for shipment of products. Maintain awareness of regulations affecting the international movement of cargo. Make arrangements for additional services, such as storage or inland transportation.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "43-5021.00",
    "name": "Couriers and Messengers",
    "description": "Pick up and deliver messages, documents, packages, and other items between offices or departments within an establishment or directly to other business concerns, traveling by foot, bicycle, motorcycle, automobile, or public conveyance.",
    "hourlyIncome": 19,
    "annualIncome": 40060,
    "careerGrowth": 8.3,
    "jobZone": 2
  },
  {
    "code": "43-5031.00",
    "name": "Public Safety Telecommunicators",
    "description": "Operate telephone, radio, or other communication systems to receive and communicate requests for emergency assistance at 9-1-1 public safety answering points and emergency operations centers. Take information from the public and other sources regarding crimes, threats, disturbances, acts of terrorism, fires, medical emergencies, and other public safety matters. May coordinate and provide information to law enforcement and emergency response personnel. May access sensitive databases and other information sources as needed. May provide additional instructions to callers based on knowledge of and certification in law enforcement, fire, or emergency medical procedures.",
    "hourlyIncome": 26,
    "annualIncome": 54800,
    "careerGrowth": 4,
    "jobZone": 2
  },
  {
    "code": "43-5032.00",
    "name": "Dispatchers, Except Police, Fire, and Ambulance",
    "description": "Schedule and dispatch workers, work crews, equipment, or service vehicles for conveyance of materials, freight, or passengers, or for normal installation, service, or emergency repairs rendered outside the place of business. Duties may include using radio, telephone, or computer to transmit assignments and compiling statistics and reports on work progress.",
    "hourlyIncome": 26,
    "annualIncome": 53150,
    "careerGrowth": 0.2,
    "jobZone": 2
  },
  {
    "code": "43-5041.00",
    "name": "Meter Readers, Utilities",
    "description": "Read meter and record consumption of electricity, gas, water, or steam.",
    "hourlyIncome": 27,
    "annualIncome": 55810,
    "careerGrowth": -11.4,
    "jobZone": 2
  },
  {
    "code": "43-5051.00",
    "name": "Postal Service Clerks",
    "description": "Perform any combination of tasks in a United States Postal Service (USPS) post office, such as receive letters and parcels; sell postage and revenue stamps, postal cards, and stamped envelopes; fill out and sell money orders; place mail in pigeon holes of mail rack or in bags; and examine mail for correct postage. Includes postal service clerks employed by USPS contractors.",
    "hourlyIncome": 29,
    "annualIncome": 61070,
    "careerGrowth": -3,
    "jobZone": 2
  },
  {
    "code": "43-5052.00",
    "name": "Postal Service Mail Carriers",
    "description": "Sort and deliver mail for the United States Postal Service (USPS). Deliver mail on established route by vehicle or on foot. Includes postal service mail carriers employed by USPS contractors.",
    "hourlyIncome": 29,
    "annualIncome": 59880,
    "careerGrowth": -3,
    "jobZone": 2
  },
  {
    "code": "43-5053.00",
    "name": "Postal Service Mail Sorters, Processors, and Processing Machine Operators",
    "description": "Prepare incoming and outgoing mail for distribution for the United States Postal Service (USPS). Examine, sort, and route mail. Load, operate, and occasionally adjust and repair mail processing, sorting, and canceling machinery. Keep records of shipments, pouches, and sacks, and perform other duties related to mail handling within the postal service. Includes postal service mail sorters and processors employed by USPS contractors.",
    "hourlyIncome": 28,
    "annualIncome": 58310,
    "careerGrowth": -7.9,
    "jobZone": 2
  },
  {
    "code": "43-5061.00",
    "name": "Production, Planning, and Expediting Clerks",
    "description": "Coordinate and expedite the flow of work and materials within or between departments of an establishment according to production schedule. Duties include reviewing and distributing production, work, and shipment schedules; conferring with department supervisors to determine progress of work and completion dates; and compiling reports on progress of work, inventory levels, costs, and production problems.",
    "hourlyIncome": 29,
    "annualIncome": 60420,
    "careerGrowth": 4.9,
    "jobZone": 2
  },
  {
    "code": "43-5071.00",
    "name": "Shipping, Receiving, and Inventory Clerks",
    "description": "Verify and maintain records on incoming and outgoing shipments involving inventory. Duties include verifying and recording incoming merchandise or material and arranging for the transportation of products. May prepare items for shipment.",
    "hourlyIncome": 22,
    "annualIncome": 44890,
    "careerGrowth": -7.6,
    "jobZone": 2
  },
  {
    "code": "43-5111.00",
    "name": "Weighers, Measurers, Checkers, and Samplers, Recordkeeping",
    "description": "Weigh, measure, and check materials, supplies, and equipment for the purpose of keeping relevant records. Duties are primarily clerical by nature. Includes workers who collect and keep record of samples of products or materials.",
    "hourlyIncome": 22,
    "annualIncome": 46660,
    "careerGrowth": -3.3,
    "jobZone": 2
  },
  {
    "code": "43-6011.00",
    "name": "Executive Secretaries and Executive Administrative Assistants",
    "description": "Provide high-level administrative support by conducting research, preparing statistical reports, and handling information requests, as well as performing routine administrative functions such as preparing correspondence, receiving visitors, arranging conference calls, and scheduling meetings. May also train and supervise lower-level clerical staff.",
    "hourlyIncome": 37,
    "annualIncome": 77060,
    "careerGrowth": 0.2,
    "jobZone": 3
  },
  {
    "code": "43-6012.00",
    "name": "Legal Secretaries and Administrative Assistants",
    "description": "Perform secretarial duties using legal terminology, procedures, and documents. Prepare legal papers and correspondence, such as summonses, complaints, motions, and subpoenas. May also assist with legal research.",
    "hourlyIncome": 29,
    "annualIncome": 60320,
    "careerGrowth": -5.1,
    "jobZone": 3
  },
  {
    "code": "43-6013.00",
    "name": "Medical Secretaries and Administrative Assistants",
    "description": "Perform secretarial duties using specific knowledge of medical terminology and hospital, clinic, or laboratory procedures. Duties may include scheduling appointments, billing patients, and compiling and recording medical charts, reports, and correspondence.",
    "hourlyIncome": 22,
    "annualIncome": 45580,
    "careerGrowth": 5.4,
    "jobZone": 2
  },
  {
    "code": "43-6014.00",
    "name": "Secretaries and Administrative Assistants, Except Legal, Medical, and Executive",
    "description": "Perform routine administrative functions such as drafting correspondence, scheduling appointments, organizing and maintaining paper and electronic files, or providing information to callers.",
    "hourlyIncome": 23,
    "annualIncome": 47640,
    "careerGrowth": -0.3,
    "jobZone": 2
  },
  {
    "code": "43-9021.00",
    "name": "Data Entry Keyers",
    "description": "Operate data entry device, such as keyboard or photo composing perforator. Duties may include verifying data and preparing materials for printing.",
    "hourlyIncome": 20,
    "annualIncome": 42070,
    "careerGrowth": -25,
    "jobZone": 2
  },
  {
    "code": "43-9022.00",
    "name": "Word Processors and Typists",
    "description": "Use word processor, computer, or typewriter to type letters, reports, forms, or other material from rough draft, corrected copy, or voice recording. May perform other clerical duties as assigned.",
    "hourlyIncome": 24,
    "annualIncome": 49730,
    "careerGrowth": -38,
    "jobZone": 2
  },
  {
    "code": "43-9031.00",
    "name": "Desktop Publishers",
    "description": "Format typescript and graphic elements using computer software to produce publication-ready material.",
    "hourlyIncome": 29,
    "annualIncome": 60250,
    "careerGrowth": -13.4,
    "jobZone": 3
  },
  {
    "code": "43-9041.00",
    "name": "Insurance Claims and Policy Processing Clerks",
    "description": "Process new insurance policies, modifications to existing policies, and claims forms. Obtain information from policyholders to verify the accuracy and completeness of information on claims forms, applications and related documents, and company records. Update existing policies and company records to reflect changes requested by policyholders and insurance company representatives.",
    "hourlyIncome": 25,
    "annualIncome": 51980,
    "careerGrowth": -3.9,
    "jobZone": 2
  },
  {
    "code": "43-9051.00",
    "name": "Mail Clerks and Mail Machine Operators, Except Postal Service",
    "description": "Prepare incoming and outgoing mail for distribution. Time-stamp, open, read, sort, and route incoming mail; and address, seal, stamp, fold, stuff, and affix postage to outgoing mail or packages. Duties may also include keeping necessary records and completed forms.",
    "hourlyIncome": 19,
    "annualIncome": 40200,
    "careerGrowth": -6.2,
    "jobZone": 2
  },
  {
    "code": "43-9061.00",
    "name": "Office Clerks, General",
    "description": "Perform duties too varied and diverse to be classified in any specific office clerical occupation, requiring knowledge of office systems and procedures. Clerical duties may be assigned in accordance with the office procedures of individual establishments and may include a combination of answering telephones, bookkeeping, typing or word processing, office machine operation, and filing.",
    "hourlyIncome": 22,
    "annualIncome": 45470,
    "careerGrowth": -5.6,
    "jobZone": 2
  },
  {
    "code": "43-9071.00",
    "name": "Office Machine Operators, Except Computer",
    "description": "Operate one or more of a variety of office machines, such as photocopying, photographic, and duplicating machines, or other office machines.",
    "hourlyIncome": 20,
    "annualIncome": 41620,
    "careerGrowth": -15.1,
    "jobZone": 2
  },
  {
    "code": "43-9081.00",
    "name": "Proofreaders and Copy Markers",
    "description": "Read transcript or proof type setup to detect and mark for correction any grammatical, typographical, or compositional errors. Excludes workers whose primary duty is editing copy. Includes proofreaders of braille.",
    "hourlyIncome": 25,
    "annualIncome": 52730,
    "careerGrowth": -3.4,
    "jobZone": 4
  },
  {
    "code": "43-9111.00",
    "name": "Statistical Assistants",
    "description": "Compile and compute data according to statistical formulas for use in statistical studies. May perform actuarial computations and compile charts and graphs for use by actuaries. Includes actuarial clerks.",
    "hourlyIncome": 27,
    "annualIncome": 55470,
    "careerGrowth": 0.2,
    "jobZone": 4
  },
  {
    "code": "43-9199.00",
    "name": "Office and Administrative Support Workers, All Other",
    "description": "All office and administrative support workers not listed separately.",
    "hourlyIncome": 23,
    "annualIncome": 48700,
    "careerGrowth": -7.7,
    "jobZone": null
  },
  {
    "code": "45-1011.00",
    "name": "First-Line Supervisors of Farming, Fishing, and Forestry Workers",
    "description": "Directly supervise and coordinate the activities of agricultural, forestry, aquacultural, and related workers.",
    "hourlyIncome": 30,
    "annualIncome": 63360,
    "careerGrowth": 3.1,
    "jobZone": 3
  },
  {
    "code": "45-2011.00",
    "name": "Agricultural Inspectors",
    "description": "Inspect agricultural commodities, processing equipment, and facilities, and fish and logging operations, to ensure compliance with regulations and laws governing health, quality, and safety.",
    "hourlyIncome": 27,
    "annualIncome": 55650,
    "careerGrowth": 3.9,
    "jobZone": 2
  },
  {
    "code": "45-2021.00",
    "name": "Animal Breeders",
    "description": "Select and breed animals according to their genealogy, characteristics, and offspring. May require knowledge of artificial insemination techniques and equipment use. May involve keeping records on heats, birth intervals, or pedigree.",
    "hourlyIncome": 27,
    "annualIncome": 56150,
    "careerGrowth": 2.4,
    "jobZone": 2
  },
  {
    "code": "45-2041.00",
    "name": "Graders and Sorters, Agricultural Products",
    "description": "Grade, sort, or classify unprocessed food and other agricultural products by size, weight, color, or condition.",
    "hourlyIncome": 17,
    "annualIncome": 36080,
    "careerGrowth": -4.7,
    "jobZone": 1
  },
  {
    "code": "45-2091.00",
    "name": "Agricultural Equipment Operators",
    "description": "Drive and control equipment to support agricultural activities such as tilling soil; planting, cultivating, and harvesting crops; feeding and herding livestock; or removing animal waste. May perform tasks such as crop baling or hay bucking. May operate stationary equipment to perform post-harvest tasks such as husking, shelling, threshing, and ginning.",
    "hourlyIncome": 21,
    "annualIncome": 43920,
    "careerGrowth": 8.4,
    "jobZone": 1
  },
  {
    "code": "45-2092.00",
    "name": "Farmworkers and Laborers, Crop, Nursery, and Greenhouse",
    "description": "Manually plant, cultivate, and harvest vegetables, fruits, nuts, horticultural specialties, and field crops. Use hand tools, such as shovels, trowels, hoes, tampers, pruning hooks, shears, and knives. Duties may include tilling soil and applying fertilizers; transplanting, weeding, thinning, or pruning crops; applying pesticides; or cleaning, grading, sorting, packing, and loading harvested products. May construct trellises, repair fences and farm buildings, or participate in irrigation activities.",
    "hourlyIncome": 18,
    "annualIncome": 37850,
    "careerGrowth": -2.4,
    "jobZone": 1
  },
  {
    "code": "45-2093.00",
    "name": "Farmworkers, Farm, Ranch, and Aquacultural Animals",
    "description": "Attend to live farm, ranch, open range or aquacultural animals that may include cattle, sheep, swine, goats, horses and other equines, poultry, rabbits, finfish, shellfish, and bees. Attend to animals produced for animal products, such as meat, fur, skins, feathers, eggs, milk, and honey. Duties may include feeding, watering, herding, grazing, milking, castrating, branding, de-beaking, weighing, catching, and loading animals. May maintain records on animals; examine animals to detect diseases and injuries; assist in birth deliveries; and administer medications, vaccinations, or insecticides as appropriate. May clean and maintain animal housing areas. Includes workers who shear wool from sheep and collect eggs in hatcheries.",
    "hourlyIncome": 19,
    "annualIncome": 38580,
    "careerGrowth": -5.2,
    "jobZone": 2
  },
  {
    "code": "45-2099.00",
    "name": "Agricultural Workers, All Other",
    "description": "All agricultural workers not listed separately.",
    "hourlyIncome": 22,
    "annualIncome": 45780,
    "careerGrowth": 2.5,
    "jobZone": null
  },
  {
    "code": "45-3031.00",
    "name": "Fishing and Hunting Workers",
    "description": "Hunt, trap, catch, or gather wild animals or aquatic animals and plants. May use nets, traps, or other equipment. May haul catch onto ship or other vessel.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": -0.7,
    "jobZone": 1
  },
  {
    "code": "45-4011.00",
    "name": "Forest and Conservation Workers",
    "description": "Under supervision, perform manual labor necessary to develop, maintain, or protect areas such as forests, forested areas, woodlands, wetlands, and rangelands through such activities as raising and transporting seedlings; combating insects, pests, and diseases harmful to plant life; and building structures to control water, erosion, and leaching of soil. Includes forester aides, seedling pullers, tree planters, and gatherers of nontimber forestry products such as pine straw.",
    "hourlyIncome": 21,
    "annualIncome": 42830,
    "careerGrowth": -3.8,
    "jobZone": 2
  },
  {
    "code": "45-4021.00",
    "name": "Fallers",
    "description": "Use axes or chainsaws to fell trees using knowledge of tree characteristics and cutting techniques to control direction of fall and minimize tree damage.",
    "hourlyIncome": 28,
    "annualIncome": 59120,
    "careerGrowth": -8.4,
    "jobZone": 1
  },
  {
    "code": "45-4022.00",
    "name": "Logging Equipment Operators",
    "description": "Drive logging tractor or wheeled vehicle equipped with one or more accessories, such as bulldozer blade, frontal shear, grapple, logging arch, cable winches, hoisting rack, or crane boom, to fell tree; to skid, load, unload, or stack logs; or to pull stumps or clear brush. Includes operating stand-alone logging machines, such as log chippers.",
    "hourlyIncome": 25,
    "annualIncome": 52020,
    "careerGrowth": -3.8,
    "jobZone": 1
  },
  {
    "code": "45-4023.00",
    "name": "Log Graders and Scalers",
    "description": "Grade logs or estimate the marketable content or value of logs or pulpwood in sorting yards, millpond, log deck, or similar locations. Inspect logs for defects or measure logs to determine volume.",
    "hourlyIncome": 23,
    "annualIncome": 48130,
    "careerGrowth": -1.5,
    "jobZone": 2
  },
  {
    "code": "45-4029.00",
    "name": "Logging Workers, All Other",
    "description": "All logging workers not listed separately.",
    "hourlyIncome": 26,
    "annualIncome": 53820,
    "careerGrowth": -7.4,
    "jobZone": null
  },
  {
    "code": "47-1011.00",
    "name": "First-Line Supervisors of Construction Trades and Extraction Workers",
    "description": "Directly supervise and coordinate activities of construction or extraction workers.",
    "hourlyIncome": 41,
    "annualIncome": 84500,
    "careerGrowth": 5.9,
    "jobZone": 3
  },
  {
    "code": "47-1011.03",
    "name": "Solar Energy Installation Managers",
    "description": "Direct work crews installing residential or commercial solar photovoltaic or thermal systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "47-2011.00",
    "name": "Boilermakers",
    "description": "Construct, assemble, maintain, and repair stationary steam boilers and boiler house auxiliaries. Align structures or plate sections to assemble boiler frame tanks or vats, following blueprints. Work involves use of hand and power tools, plumb bobs, levels, wedges, dogs, or turnbuckles. Assist in testing assembled vessels. Direct cleaning of boilers and boiler furnaces. Inspect and repair boiler fittings, such as safety valves, regulators, automatic-control mechanisms, water columns, and auxiliary machines.",
    "hourlyIncome": 37,
    "annualIncome": 76900,
    "careerGrowth": -1.2,
    "jobZone": 3
  },
  {
    "code": "47-2021.00",
    "name": "Brickmasons and Blockmasons",
    "description": "Lay and bind building materials, such as brick, structural tile, concrete block, cinder block, glass block, and terra-cotta block, with mortar and other substances, to construct or repair walls, partitions, arches, sewers, and other structures.",
    "hourlyIncome": 31,
    "annualIncome": 65390,
    "careerGrowth": 3.3,
    "jobZone": 2
  },
  {
    "code": "47-2022.00",
    "name": "Stonemasons",
    "description": "Build stone structures, such as piers, walls, and abutments. Lay walks, curbstones, or special types of masonry for vats, tanks, and floors.",
    "hourlyIncome": 28,
    "annualIncome": 57220,
    "careerGrowth": -3.6,
    "jobZone": 3
  },
  {
    "code": "47-2031.00",
    "name": "Carpenters",
    "description": "Construct, erect, install, or repair structures and fixtures made of wood and comparable materials, such as concrete forms; building frameworks, including partitions, joists, studding, and rafters; and wood stairways, window and door frames, and hardwood floors. May also install cabinets, siding, drywall, and batt or roll insulation. Includes brattice builders who build doors or brattices (ventilation walls or partitions) in underground passageways.",
    "hourlyIncome": 31,
    "annualIncome": 64040,
    "careerGrowth": 4.2,
    "jobZone": 2
  },
  {
    "code": "47-2041.00",
    "name": "Carpet Installers",
    "description": "Lay and install carpet from rolls or blocks on floors. Install padding and trim flooring materials.",
    "hourlyIncome": 27,
    "annualIncome": 55860,
    "careerGrowth": -8.9,
    "jobZone": 2
  },
  {
    "code": "47-2042.00",
    "name": "Floor Layers, Except Carpet, Wood, and Hard Tiles",
    "description": "Apply blocks, strips, or sheets of shock-absorbing, sound-deadening, or decorative coverings to floors.",
    "hourlyIncome": 29,
    "annualIncome": 60550,
    "careerGrowth": 10.1,
    "jobZone": 2
  },
  {
    "code": "47-2043.00",
    "name": "Floor Sanders and Finishers",
    "description": "Scrape and sand wooden floors to smooth surfaces using floor scraper and floor sanding machine, and apply coats of finish.",
    "hourlyIncome": 24,
    "annualIncome": 50880,
    "careerGrowth": 2.5,
    "jobZone": 1
  },
  {
    "code": "47-2044.00",
    "name": "Tile and Stone Setters",
    "description": "Apply hard tile, stone, and comparable materials to walls, floors, ceilings, countertops, and roof decks.",
    "hourlyIncome": 28,
    "annualIncome": 57590,
    "careerGrowth": 10.4,
    "jobZone": 2
  },
  {
    "code": "47-2051.00",
    "name": "Cement Masons and Concrete Finishers",
    "description": "Smooth and finish surfaces of poured concrete, such as floors, walks, sidewalks, roads, or curbs using a variety of hand and power tools. Align forms for sidewalks, curbs, or gutters; patch voids; and use saws to cut expansion joints.",
    "hourlyIncome": 29,
    "annualIncome": 59360,
    "careerGrowth": -0.7,
    "jobZone": 1
  },
  {
    "code": "47-2053.00",
    "name": "Terrazzo Workers and Finishers",
    "description": "Apply a mixture of cement, sand, pigment, or marble chips to floors, stairways, and cabinet fixtures to fashion durable and decorative surfaces.",
    "hourlyIncome": 30,
    "annualIncome": 62330,
    "careerGrowth": -8.4,
    "jobZone": 2
  },
  {
    "code": "47-2061.00",
    "name": "Construction Laborers",
    "description": "Perform tasks involving physical labor at construction sites. May operate hand and power tools of all types: air hammers, earth tampers, cement mixers, small mechanical hoists, surveying and measuring equipment, and a variety of other equipment and instruments. May clean and prepare sites, dig trenches, set braces to support the sides of excavations, erect scaffolding, and clean up rubble, debris, and other waste materials. May assist other craft workers.",
    "hourlyIncome": 25,
    "annualIncome": 51260,
    "careerGrowth": 8.2,
    "jobZone": 2
  },
  {
    "code": "47-2071.00",
    "name": "Paving, Surfacing, and Tamping Equipment Operators",
    "description": "Operate equipment used for applying concrete, asphalt, or other materials to road beds, parking lots, or airport runways and taxiways or for tamping gravel, dirt, or other materials. Includes concrete and asphalt paving machine operators, form tampers, tamping machine operators, and stone spreader operators.",
    "hourlyIncome": 28,
    "annualIncome": 58660,
    "careerGrowth": 3.9,
    "jobZone": 2
  },
  {
    "code": "47-2072.00",
    "name": "Pile Driver Operators",
    "description": "Operate pile drivers mounted on skids, barges, crawler treads, or locomotive cranes to drive pilings for retaining walls, bulkheads, and foundations of structures such as buildings, bridges, and piers.",
    "hourlyIncome": 38,
    "annualIncome": 79000,
    "careerGrowth": 4.6,
    "jobZone": 2
  },
  {
    "code": "47-2073.00",
    "name": "Operating Engineers and Other Construction Equipment Operators",
    "description": "Operate one or several types of power construction equipment, such as motor graders, bulldozers, scrapers, compressors, pumps, derricks, shovels, tractors, or front-end loaders to excavate, move, and grade earth, erect structures, or pour concrete or other hard surface pavement. May repair and maintain equipment in addition to other duties.",
    "hourlyIncome": 31,
    "annualIncome": 65180,
    "careerGrowth": 4.2,
    "jobZone": 2
  },
  {
    "code": "47-2081.00",
    "name": "Drywall and Ceiling Tile Installers",
    "description": "Apply plasterboard or other wallboard to ceilings or interior walls of buildings. Apply or mount acoustical tiles or blocks, strips, or sheets of shock-absorbing materials to ceilings and walls of buildings to reduce or reflect sound. Materials may be of decorative quality. Includes lathers who fasten wooden, metal, or rockboard lath to walls, ceilings, or partitions of buildings to provide support base for plaster, fireproofing, or acoustical material.",
    "hourlyIncome": 30,
    "annualIncome": 62810,
    "careerGrowth": 3.3,
    "jobZone": 2
  },
  {
    "code": "47-2082.00",
    "name": "Tapers",
    "description": "Seal joints between plasterboard or other wallboard to prepare wall surface for painting or papering.",
    "hourlyIncome": 34,
    "annualIncome": 70390,
    "careerGrowth": -0.7,
    "jobZone": 2
  },
  {
    "code": "47-2111.00",
    "name": "Electricians",
    "description": "Install, maintain, and repair electrical wiring, equipment, and fixtures. Ensure that work is in accordance with relevant codes. May install or service street lights, intercom systems, or electrical control systems.",
    "hourlyIncome": 33,
    "annualIncome": 69630,
    "careerGrowth": 10.8,
    "jobZone": 3
  },
  {
    "code": "47-2121.00",
    "name": "Glaziers",
    "description": "Install glass in windows, skylights, store fronts, and display cases, or on surfaces, such as building fronts, interior walls, ceilings, and tabletops.",
    "hourlyIncome": 29,
    "annualIncome": 60260,
    "careerGrowth": 3.8,
    "jobZone": 2
  },
  {
    "code": "47-2131.00",
    "name": "Insulation Workers, Floor, Ceiling, and Wall",
    "description": "Line and cover structures with insulating materials. May work with batt, roll, or blown insulation materials.",
    "hourlyIncome": 26,
    "annualIncome": 53440,
    "careerGrowth": 2.7,
    "jobZone": 2
  },
  {
    "code": "47-2132.00",
    "name": "Insulation Workers, Mechanical",
    "description": "Apply insulating materials to pipes or ductwork, or other mechanical systems in order to help control and maintain temperature.",
    "hourlyIncome": 31,
    "annualIncome": 63540,
    "careerGrowth": 5.1,
    "jobZone": 2
  },
  {
    "code": "47-2141.00",
    "name": "Painters, Construction and Maintenance",
    "description": "Paint walls, equipment, buildings, bridges, and other structural surfaces, using brushes, rollers, and spray guns. May remove old paint to prepare surface prior to painting. May mix colors or oils to obtain desired color or consistency.",
    "hourlyIncome": 26,
    "annualIncome": 53710,
    "careerGrowth": 4,
    "jobZone": 2
  },
  {
    "code": "47-2142.00",
    "name": "Paperhangers",
    "description": "Cover interior walls or ceilings of rooms with decorative wallpaper or fabric, or attach advertising posters on surfaces such as walls and billboards. May remove old materials or prepare surfaces to be papered.",
    "hourlyIncome": 25,
    "annualIncome": 51900,
    "careerGrowth": 5.7,
    "jobZone": 2
  },
  {
    "code": "47-2151.00",
    "name": "Pipelayers",
    "description": "Lay pipe for storm or sanitation sewers, drains, and water mains. Perform any combination of the following tasks: grade trenches or culverts, position pipe, or seal joints.",
    "hourlyIncome": 26,
    "annualIncome": 54270,
    "careerGrowth": -2.3,
    "jobZone": 2
  },
  {
    "code": "47-2152.00",
    "name": "Plumbers, Pipefitters, and Steamfitters",
    "description": "Assemble, install, alter, and repair pipelines or pipe systems that carry water, steam, air, or other liquids or gases. May install heating and cooling equipment and mechanical control systems. Includes sprinkler fitters.",
    "hourlyIncome": 34,
    "annualIncome": 69940,
    "careerGrowth": 5.6,
    "jobZone": 3
  },
  {
    "code": "47-2152.04",
    "name": "Solar Thermal Installers and Technicians",
    "description": "Install or repair solar energy systems designed to collect, store, and circulate solar-heated water for residential, commercial or industrial use.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "47-2161.00",
    "name": "Plasterers and Stucco Masons",
    "description": "Apply interior or exterior plaster, cement, stucco, or similar materials. May also set ornamental plaster.",
    "hourlyIncome": 29,
    "annualIncome": 61000,
    "careerGrowth": 3.3,
    "jobZone": 1
  },
  {
    "code": "47-2171.00",
    "name": "Reinforcing Iron and Rebar Workers",
    "description": "Position and secure steel bars or mesh in concrete forms in order to reinforce concrete. Use a variety of fasteners, rod-bending machines, blowtorches, and hand tools. Includes rod busters.",
    "hourlyIncome": 30,
    "annualIncome": 62640,
    "careerGrowth": 4.2,
    "jobZone": 2
  },
  {
    "code": "47-2181.00",
    "name": "Roofers",
    "description": "Cover roofs of structures with shingles, slate, asphalt, aluminum, wood, or related materials. May spray roofs, sidings, and walls with material to bind, seal, insulate, or soundproof sections of structures.",
    "hourlyIncome": 27,
    "annualIncome": 57090,
    "careerGrowth": 5.8,
    "jobZone": 2
  },
  {
    "code": "47-2211.00",
    "name": "Sheet Metal Workers",
    "description": "Fabricate, assemble, install, and repair sheet metal products and equipment, such as ducts, control boxes, drainpipes, and furnace casings. Work may involve any of the following: setting up and operating fabricating machines to cut, bend, and straighten sheet metal; shaping metal over anvils, blocks, or forms using hammer; operating soldering and welding equipment to join sheet metal parts; or inspecting, assembling, and smoothing seams and joints of burred surfaces. Includes sheet metal duct installers who install prefabricated sheet metal ducts used for heating, air conditioning, or other purposes.",
    "hourlyIncome": 32,
    "annualIncome": 66110,
    "careerGrowth": 2.3,
    "jobZone": 2
  },
  {
    "code": "47-2221.00",
    "name": "Structural Iron and Steel Workers",
    "description": "Raise, place, and unite iron or steel girders, columns, and other structural members to form completed structures or structural frameworks. May erect metal storage tanks and assemble prefabricated metal buildings.",
    "hourlyIncome": 33,
    "annualIncome": 69270,
    "careerGrowth": 4.1,
    "jobZone": 2
  },
  {
    "code": "47-2231.00",
    "name": "Solar Photovoltaic Installers",
    "description": "Assemble, install, or maintain solar photovoltaic (PV) systems on roofs or other structures in compliance with site assessment and schematics. May include measuring, cutting, assembling, and bolting structural framing and solar modules. May perform minor electrical work such as current checks.",
    "hourlyIncome": 28,
    "annualIncome": 57380,
    "careerGrowth": 48,
    "jobZone": 2
  },
  {
    "code": "47-3011.00",
    "name": "Helpers--Brickmasons, Blockmasons, Stonemasons, and Tile and Marble Setters",
    "description": "Help brickmasons, blockmasons, stonemasons, or tile and marble setters by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "hourlyIncome": 24,
    "annualIncome": 49730,
    "careerGrowth": -9.1,
    "jobZone": 2
  },
  {
    "code": "47-3012.00",
    "name": "Helpers--Carpenters",
    "description": "Help carpenters by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "hourlyIncome": 20,
    "annualIncome": 42080,
    "careerGrowth": -3,
    "jobZone": 2
  },
  {
    "code": "47-3013.00",
    "name": "Helpers--Electricians",
    "description": "Help electricians by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "hourlyIncome": 21,
    "annualIncome": 42900,
    "careerGrowth": 1,
    "jobZone": 2
  },
  {
    "code": "47-3014.00",
    "name": "Helpers--Painters, Paperhangers, Plasterers, and Stucco Masons",
    "description": "Help painters, paperhangers, plasterers, or stucco masons by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "hourlyIncome": 20,
    "annualIncome": 40880,
    "careerGrowth": 1.9,
    "jobZone": 1
  },
  {
    "code": "47-3015.00",
    "name": "Helpers--Pipelayers, Plumbers, Pipefitters, and Steamfitters",
    "description": "Help plumbers, pipefitters, steamfitters, or pipelayers by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "hourlyIncome": 20,
    "annualIncome": 41720,
    "careerGrowth": 5.9,
    "jobZone": 2
  },
  {
    "code": "47-3016.00",
    "name": "Helpers--Roofers",
    "description": "Help roofers by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "hourlyIncome": 20,
    "annualIncome": 42070,
    "careerGrowth": 5.6,
    "jobZone": 2
  },
  {
    "code": "47-3019.00",
    "name": "Helpers, Construction Trades, All Other",
    "description": "All construction trades helpers not listed separately.",
    "hourlyIncome": 21,
    "annualIncome": 44040,
    "careerGrowth": 8.3,
    "jobZone": null
  },
  {
    "code": "47-4011.00",
    "name": "Construction and Building Inspectors",
    "description": "Inspect structures using engineering skills to determine structural soundness and compliance with specifications, building codes, and other regulations. Inspections may be general in nature or may be limited to a specific area, such as electrical systems or plumbing.",
    "hourlyIncome": 37,
    "annualIncome": 76430,
    "careerGrowth": 0,
    "jobZone": 3
  },
  {
    "code": "47-4011.01",
    "name": "Energy Auditors",
    "description": "Conduct energy audits of buildings, building systems, or process systems. May also conduct investment grade audits of buildings or systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "47-4021.00",
    "name": "Elevator and Escalator Installers and Repairers",
    "description": "Assemble, install, repair, or maintain electric or hydraulic freight or passenger elevators, escalators, or dumbwaiters.",
    "hourlyIncome": 50,
    "annualIncome": 104860,
    "careerGrowth": 5.7,
    "jobZone": 3
  },
  {
    "code": "47-4031.00",
    "name": "Fence Erectors",
    "description": "Erect and repair fences and fence gates, using hand and power tools.",
    "hourlyIncome": 24,
    "annualIncome": 50550,
    "careerGrowth": 4.8,
    "jobZone": 2
  },
  {
    "code": "47-4041.00",
    "name": "Hazardous Materials Removal Workers",
    "description": "Identify, remove, pack, transport, or dispose of hazardous materials, including asbestos, lead-based paint, waste oil, fuel, transmission fluid, radioactive materials, or contaminated soil. Specialized training and certification in hazardous materials handling or a confined entry permit are generally required. May operate earth-moving equipment or trucks.",
    "hourlyIncome": 27,
    "annualIncome": 55740,
    "careerGrowth": 1,
    "jobZone": 3
  },
  {
    "code": "47-4051.00",
    "name": "Highway Maintenance Workers",
    "description": "Maintain highways, municipal and rural roads, airport runways, and rights-of-way. Duties include patching broken or eroded pavement and repairing guard rails, highway markers, and snow fences. May also mow or clear brush from along road, or plow snow from roadway.",
    "hourlyIncome": 25,
    "annualIncome": 51410,
    "careerGrowth": 3.8,
    "jobZone": 2
  },
  {
    "code": "47-4061.00",
    "name": "Rail-Track Laying and Maintenance Equipment Operators",
    "description": "Lay, repair, and maintain track for standard or narrow-gauge railroad equipment used in regular railroad service or in plant yards, quarries, sand and gravel pits, and mines. Includes ballast cleaning machine operators and railroad bed tamping machine operators.",
    "hourlyIncome": 33,
    "annualIncome": 68270,
    "careerGrowth": 2.5,
    "jobZone": 2
  },
  {
    "code": "47-4071.00",
    "name": "Septic Tank Servicers and Sewer Pipe Cleaners",
    "description": "Clean and repair septic tanks, sewer lines, or drains. May patch walls and partitions of tank, replace damaged drain tile, or repair breaks in underground piping.",
    "hourlyIncome": 25,
    "annualIncome": 52730,
    "careerGrowth": 8.1,
    "jobZone": 1
  },
  {
    "code": "47-4091.00",
    "name": "Segmental Pavers",
    "description": "Lay out, cut, and place segmental paving units. Includes installers of bedding and restraining materials for the paving units.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "47-4099.00",
    "name": "Construction and Related Workers, All Other",
    "description": "All construction and related workers not listed separately.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "47-4099.03",
    "name": "Weatherization Installers and Technicians",
    "description": "Perform a variety of activities to weatherize homes and make them more energy efficient. Duties include repairing windows, insulating ducts, and performing heating, ventilating, and air-conditioning (HVAC) work. May perform energy audits and advise clients on energy conservation measures.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "47-5011.00",
    "name": "Derrick Operators, Oil and Gas",
    "description": "Rig derrick equipment and operate pumps to circulate mud or fluid through drill hole.",
    "hourlyIncome": 30,
    "annualIncome": 62490,
    "careerGrowth": 3.1,
    "jobZone": 1
  },
  {
    "code": "47-5012.00",
    "name": "Rotary Drill Operators, Oil and Gas",
    "description": "Set up or operate a variety of drills to remove underground oil and gas, or remove core samples for testing during oil and gas exploration.",
    "hourlyIncome": 34,
    "annualIncome": 70080,
    "careerGrowth": 2.2,
    "jobZone": 2
  },
  {
    "code": "47-5013.00",
    "name": "Service Unit Operators, Oil and Gas",
    "description": "Operate equipment to increase oil flow from producing wells or to remove stuck pipe, casing, tools, or other obstructions from drilling wells. Includes fishing-tool technicians.",
    "hourlyIncome": 30,
    "annualIncome": 61530,
    "careerGrowth": 2.1,
    "jobZone": 2
  },
  {
    "code": "47-5022.00",
    "name": "Excavating and Loading Machine and Dragline Operators, Surface Mining",
    "description": "Operate or tend machinery at surface mining site, equipped with scoops, shovels, or buckets to excavate and load loose materials.",
    "hourlyIncome": 28,
    "annualIncome": 57860,
    "careerGrowth": -0.8,
    "jobZone": 2
  },
  {
    "code": "47-5023.00",
    "name": "Earth Drillers, Except Oil and Gas",
    "description": "Operate a variety of drills such as rotary, churn, and pneumatic to tap subsurface water and salt deposits, to remove core samples during mineral exploration or soil testing, and to facilitate the use of explosives in mining or construction. Includes horizontal and earth boring machine operators.",
    "hourlyIncome": 30,
    "annualIncome": 63260,
    "careerGrowth": 4,
    "jobZone": 2
  },
  {
    "code": "47-5032.00",
    "name": "Explosives Workers, Ordnance Handling Experts, and Blasters",
    "description": "Place and detonate explosives to demolish structures or to loosen, remove, or displace earth, rock, or other materials. May perform specialized handling, storage, and accounting procedures.",
    "hourlyIncome": 32,
    "annualIncome": 66840,
    "careerGrowth": 1.2,
    "jobZone": 2
  },
  {
    "code": "47-5041.00",
    "name": "Continuous Mining Machine Operators",
    "description": "Operate self-propelled mining machines that rip coal, metal and nonmetal ores, rock, stone, or sand from the mine face and load it onto conveyors, shuttle cars, or trucks in a continuous operation.",
    "hourlyIncome": 31,
    "annualIncome": 63920,
    "careerGrowth": -1.8,
    "jobZone": 2
  },
  {
    "code": "47-5043.00",
    "name": "Roof Bolters, Mining",
    "description": "Operate machinery to install roof support bolts in underground mine.",
    "hourlyIncome": 36,
    "annualIncome": 74760,
    "careerGrowth": -32,
    "jobZone": 2
  },
  {
    "code": "47-5044.00",
    "name": "Loading and Moving Machine Operators, Underground Mining",
    "description": "Operate underground loading or moving machine to load or move coal, ore, or rock using shuttle or mine car or conveyors. Equipment may include power shovels, hoisting engines equipped with cable-drawn scraper or scoop, or machines equipped with gathering arms and conveyor.",
    "hourlyIncome": 33,
    "annualIncome": 68470,
    "careerGrowth": -22.9,
    "jobZone": 2
  },
  {
    "code": "47-5049.00",
    "name": "Underground Mining Machine Operators, All Other",
    "description": "All underground mining machine operators not listed separately.",
    "hourlyIncome": 33,
    "annualIncome": 67830,
    "careerGrowth": -4.5,
    "jobZone": null
  },
  {
    "code": "47-5051.00",
    "name": "Rock Splitters, Quarry",
    "description": "Separate blocks of rough dimension stone from quarry mass using jackhammers, wedges, or chop saws.",
    "hourlyIncome": 24,
    "annualIncome": 50540,
    "careerGrowth": 2.8,
    "jobZone": 1
  },
  {
    "code": "47-5071.00",
    "name": "Roustabouts, Oil and Gas",
    "description": "Assemble or repair oil field equipment using hand and power tools. Perform other tasks as needed.",
    "hourlyIncome": 24,
    "annualIncome": 49060,
    "careerGrowth": 5.5,
    "jobZone": 1
  },
  {
    "code": "47-5081.00",
    "name": "Helpers--Extraction Workers",
    "description": "Help extraction craft workers, such as earth drillers, blasters and explosives workers, derrick operators, and mining machine operators, by performing duties requiring less skill. Duties include supplying equipment or cleaning work area.",
    "hourlyIncome": 24,
    "annualIncome": 50330,
    "careerGrowth": 1.8,
    "jobZone": 2
  },
  {
    "code": "47-5099.00",
    "name": "Extraction Workers, All Other",
    "description": "All extraction workers not listed separately.",
    "hourlyIncome": 26,
    "annualIncome": 54780,
    "careerGrowth": -0.5,
    "jobZone": null
  },
  {
    "code": "49-1011.00",
    "name": "First-Line Supervisors of Mechanics, Installers, and Repairers",
    "description": "Directly supervise and coordinate the activities of mechanics, installers, and repairers. May also advise customers on recommended services. Excludes team or work leaders.",
    "hourlyIncome": 40,
    "annualIncome": 82930,
    "careerGrowth": 3.6,
    "jobZone": 3
  },
  {
    "code": "49-2011.00",
    "name": "Computer, Automated Teller, and Office Machine Repairers",
    "description": "Repair, maintain, or install computers, word processing systems, automated teller machines, and electronic office machines, such as duplicating and fax machines.",
    "hourlyIncome": 24,
    "annualIncome": 49820,
    "careerGrowth": -2,
    "jobZone": 3
  },
  {
    "code": "49-2021.00",
    "name": "Radio, Cellular, and Tower Equipment Installers and Repairers",
    "description": "Repair, install, or maintain mobile or stationary radio transmitting, broadcasting, and receiving equipment, and two-way radio communications systems used in cellular telecommunications, mobile broadband, ship-to-shore, aircraft-to-ground communications, and radio equipment in service and emergency vehicles. May test and analyze network coverage.",
    "hourlyIncome": 33,
    "annualIncome": 69180,
    "careerGrowth": 6.8,
    "jobZone": 3
  },
  {
    "code": "49-2022.00",
    "name": "Telecommunications Equipment Installers and Repairers, Except Line Installers",
    "description": "Install, set up, rearrange, or remove switching, distribution, routing, and dialing equipment used in central offices or headends. Service or repair telephone, cable television, Internet, and other communications equipment on customers' property. May install communications equipment or communications wiring in buildings.",
    "hourlyIncome": 32,
    "annualIncome": 66650,
    "careerGrowth": -3.4,
    "jobZone": 3
  },
  {
    "code": "49-2091.00",
    "name": "Avionics Technicians",
    "description": "Install, inspect, test, adjust, or repair avionics equipment, such as radar, radio, navigation, and missile control systems in aircraft or space vehicles.",
    "hourlyIncome": 40,
    "annualIncome": 82350,
    "careerGrowth": 7.6,
    "jobZone": 3
  },
  {
    "code": "49-2092.00",
    "name": "Electric Motor, Power Tool, and Related Repairers",
    "description": "Repair, maintain, or install electric motors, wiring, or switches.",
    "hourlyIncome": 27,
    "annualIncome": 56820,
    "careerGrowth": 5,
    "jobZone": 3
  },
  {
    "code": "49-2093.00",
    "name": "Electrical and Electronics Installers and Repairers, Transportation Equipment",
    "description": "Install, adjust, or maintain mobile electronics communication equipment, including sound, sonar, security, navigation, and surveillance systems on trains, watercraft, or other mobile equipment.",
    "hourlyIncome": 39,
    "annualIncome": 80980,
    "careerGrowth": 6.9,
    "jobZone": 3
  },
  {
    "code": "49-2094.00",
    "name": "Electrical and Electronics Repairers, Commercial and Industrial Equipment",
    "description": "Repair, test, adjust, or install electronic equipment, such as industrial controls, transmitters, and antennas.",
    "hourlyIncome": 35,
    "annualIncome": 72950,
    "careerGrowth": 1.2,
    "jobZone": 3
  },
  {
    "code": "49-2095.00",
    "name": "Electrical and Electronics Repairers, Powerhouse, Substation, and Relay",
    "description": "Inspect, test, repair, or maintain electrical equipment in generating stations, substations, and in-service relays.",
    "hourlyIncome": 47,
    "annualIncome": 97460,
    "careerGrowth": 0.8,
    "jobZone": 3
  },
  {
    "code": "49-2096.00",
    "name": "Electronic Equipment Installers and Repairers, Motor Vehicles",
    "description": "Install, diagnose, or repair communications, sound, security, or navigation equipment in motor vehicles.",
    "hourlyIncome": 24,
    "annualIncome": 50240,
    "careerGrowth": -13.2,
    "jobZone": 3
  },
  {
    "code": "49-2097.00",
    "name": "Audiovisual Equipment Installers and Repairers",
    "description": "Install, repair, or adjust audio or television receivers, stereo systems, camcorders, video systems, or other electronic entertainment equipment in homes or other venues. May perform routine maintenance.",
    "hourlyIncome": 27,
    "annualIncome": 55740,
    "careerGrowth": 1.9,
    "jobZone": 3
  },
  {
    "code": "49-2098.00",
    "name": "Security and Fire Alarm Systems Installers",
    "description": "Install, program, maintain, and repair security and fire alarm wiring and equipment. Ensure that work is in accordance with relevant codes.",
    "hourlyIncome": 29,
    "annualIncome": 60040,
    "careerGrowth": 8.6,
    "jobZone": 3
  },
  {
    "code": "49-3011.00",
    "name": "Aircraft Mechanics and Service Technicians",
    "description": "Diagnose, adjust, repair, or overhaul aircraft engines and assemblies, such as hydraulic and pneumatic systems.",
    "hourlyIncome": 39,
    "annualIncome": 80780,
    "careerGrowth": 5.2,
    "jobZone": 3
  },
  {
    "code": "49-3021.00",
    "name": "Automotive Body and Related Repairers",
    "description": "Repair and refinish automotive vehicle bodies and straighten vehicle frames.",
    "hourlyIncome": 28,
    "annualIncome": 58830,
    "careerGrowth": 1.3,
    "jobZone": 2
  },
  {
    "code": "49-3022.00",
    "name": "Automotive Glass Installers and Repairers",
    "description": "Replace or repair broken windshields and window glass in motor vehicles.",
    "hourlyIncome": 24,
    "annualIncome": 49580,
    "careerGrowth": 2,
    "jobZone": 2
  },
  {
    "code": "49-3023.00",
    "name": "Automotive Service Technicians and Mechanics",
    "description": "Diagnose, adjust, repair, or overhaul automotive vehicles.",
    "hourlyIncome": 27,
    "annualIncome": 55260,
    "careerGrowth": 2.7,
    "jobZone": 3
  },
  {
    "code": "49-3031.00",
    "name": "Bus and Truck Mechanics and Diesel Engine Specialists",
    "description": "Diagnose, adjust, repair, or overhaul buses and trucks, or maintain and repair any type of diesel engines. Includes mechanics working primarily with automobile or marine diesel engines.",
    "hourlyIncome": 30,
    "annualIncome": 62480,
    "careerGrowth": 2.8,
    "jobZone": 3
  },
  {
    "code": "49-3041.00",
    "name": "Farm Equipment Mechanics and Service Technicians",
    "description": "Diagnose, adjust, repair, or overhaul farm machinery and vehicles, such as tractors, harvesters, dairy equipment, and irrigation systems.",
    "hourlyIncome": 27,
    "annualIncome": 55290,
    "careerGrowth": 11.4,
    "jobZone": 3
  },
  {
    "code": "49-3042.00",
    "name": "Mobile Heavy Equipment Mechanics, Except Engines",
    "description": "Diagnose, adjust, repair, or overhaul mobile mechanical, hydraulic, and pneumatic equipment, such as cranes, bulldozers, graders, and conveyors, used in construction, logging, and mining.",
    "hourlyIncome": 32,
    "annualIncome": 67580,
    "careerGrowth": 8.5,
    "jobZone": 3
  },
  {
    "code": "49-3043.00",
    "name": "Rail Car Repairers",
    "description": "Diagnose, adjust, repair, or overhaul railroad rolling stock, mine cars, or mass transit rail cars.",
    "hourlyIncome": 33,
    "annualIncome": 67610,
    "careerGrowth": 4.4,
    "jobZone": 2
  },
  {
    "code": "49-3051.00",
    "name": "Motorboat Mechanics and Service Technicians",
    "description": "Repair and adjust electrical and mechanical equipment of inboard or inboard-outboard boat engines.",
    "hourlyIncome": 27,
    "annualIncome": 56450,
    "careerGrowth": 6.7,
    "jobZone": 3
  },
  {
    "code": "49-3052.00",
    "name": "Motorcycle Mechanics",
    "description": "Diagnose, adjust, repair, or overhaul motorcycles, scooters, mopeds, dirt bikes, or similar motorized vehicles.",
    "hourlyIncome": 24,
    "annualIncome": 49650,
    "careerGrowth": 2.5,
    "jobZone": 3
  },
  {
    "code": "49-3053.00",
    "name": "Outdoor Power Equipment and Other Small Engine Mechanics",
    "description": "Diagnose, adjust, repair, or overhaul small engines used to power lawn mowers, chain saws, recreational sporting equipment, and related equipment.",
    "hourlyIncome": 23,
    "annualIncome": 48200,
    "careerGrowth": 2.9,
    "jobZone": 2
  },
  {
    "code": "49-3091.00",
    "name": "Bicycle Repairers",
    "description": "Repair and service bicycles.",
    "hourlyIncome": 20,
    "annualIncome": 41550,
    "careerGrowth": 5.6,
    "jobZone": 2
  },
  {
    "code": "49-3092.00",
    "name": "Recreational Vehicle Service Technicians",
    "description": "Diagnose, inspect, adjust, repair, or overhaul recreational vehicles including travel trailers. May specialize in maintaining gas, electrical, hydraulic, plumbing, or chassis/towing systems as well as repairing generators, appliances, and interior components. Includes workers who perform customized van conversions.",
    "hourlyIncome": 27,
    "annualIncome": 55380,
    "careerGrowth": 9.9,
    "jobZone": 2
  },
  {
    "code": "49-3093.00",
    "name": "Tire Repairers and Changers",
    "description": "Repair and replace tires.",
    "hourlyIncome": 19,
    "annualIncome": 39140,
    "careerGrowth": 5.3,
    "jobZone": 2
  },
  {
    "code": "49-9011.00",
    "name": "Mechanical Door Repairers",
    "description": "Install, service, or repair automatic door mechanisms and hydraulic doors. Includes garage door mechanics.",
    "hourlyIncome": 26,
    "annualIncome": 54110,
    "careerGrowth": 11.4,
    "jobZone": 2
  },
  {
    "code": "49-9012.00",
    "name": "Control and Valve Installers and Repairers, Except Mechanical Door",
    "description": "Install, repair, and maintain mechanical regulating and controlling devices, such as electric meters, gas regulators, thermostats, safety and flow valves, and other mechanical governors.",
    "hourlyIncome": 37,
    "annualIncome": 75970,
    "careerGrowth": 1.6,
    "jobZone": 3
  },
  {
    "code": "49-9021.00",
    "name": "Heating, Air Conditioning, and Refrigeration Mechanics and Installers",
    "description": "Install or repair heating, central air conditioning, HVAC, or refrigeration systems, including oil burners, hot-air furnaces, and heating stoves.",
    "hourlyIncome": 30,
    "annualIncome": 62690,
    "careerGrowth": 9.1,
    "jobZone": 3
  },
  {
    "code": "49-9031.00",
    "name": "Home Appliance Repairers",
    "description": "Repair, adjust, or install all types of electric or gas household appliances, such as refrigerators, washers, dryers, and ovens.",
    "hourlyIncome": 26,
    "annualIncome": 53580,
    "careerGrowth": 0.8,
    "jobZone": 2
  },
  {
    "code": "49-9041.00",
    "name": "Industrial Machinery Mechanics",
    "description": "Repair, install, adjust, or maintain industrial production and processing machinery or refinery and pipeline distribution systems. May also install, dismantle, or move machinery and heavy equipment according to plans.",
    "hourlyIncome": 32,
    "annualIncome": 67160,
    "careerGrowth": 17.2,
    "jobZone": 3
  },
  {
    "code": "49-9043.00",
    "name": "Maintenance Workers, Machinery",
    "description": "Lubricate machinery, change parts, or perform other routine machinery maintenance.",
    "hourlyIncome": 30,
    "annualIncome": 61820,
    "careerGrowth": 7.8,
    "jobZone": 3
  },
  {
    "code": "49-9044.00",
    "name": "Millwrights",
    "description": "Install, dismantle, or move machinery and heavy equipment according to layout plans, blueprints, or other drawings.",
    "hourlyIncome": 33,
    "annualIncome": 68640,
    "careerGrowth": 4.8,
    "jobZone": 2
  },
  {
    "code": "49-9045.00",
    "name": "Refractory Materials Repairers, Except Brickmasons",
    "description": "Build or repair equipment such as furnaces, kilns, cupolas, boilers, converters, ladles, soaking pits, and ovens, using refractory materials.",
    "hourlyIncome": 30,
    "annualIncome": 61480,
    "careerGrowth": -17.8,
    "jobZone": 2
  },
  {
    "code": "49-9051.00",
    "name": "Electrical Power-Line Installers and Repairers",
    "description": "Install or repair cables or wires used in electrical power or distribution systems. May erect poles and light or heavy duty transmission towers.",
    "hourlyIncome": 43,
    "annualIncome": 90110,
    "careerGrowth": 7.6,
    "jobZone": 2
  },
  {
    "code": "49-9052.00",
    "name": "Telecommunications Line Installers and Repairers",
    "description": "Install and repair telecommunications cable, including fiber optics.",
    "hourlyIncome": 35,
    "annualIncome": 72440,
    "careerGrowth": -2.7,
    "jobZone": 2
  },
  {
    "code": "49-9061.00",
    "name": "Camera and Photographic Equipment Repairers",
    "description": "Repair and adjust cameras and photographic equipment, including commercial video and motion picture camera equipment.",
    "hourlyIncome": 26,
    "annualIncome": 53420,
    "careerGrowth": -16.9,
    "jobZone": 3
  },
  {
    "code": "49-9062.00",
    "name": "Medical Equipment Repairers",
    "description": "Test, adjust, or repair biomedical or electromedical equipment.",
    "hourlyIncome": 32,
    "annualIncome": 66810,
    "careerGrowth": 18.4,
    "jobZone": 3
  },
  {
    "code": "49-9063.00",
    "name": "Musical Instrument Repairers and Tuners",
    "description": "Repair percussion, stringed, reed, or wind instruments. May specialize in one area, such as piano tuning.",
    "hourlyIncome": 24,
    "annualIncome": 49020,
    "careerGrowth": 1.5,
    "jobZone": 3
  },
  {
    "code": "49-9064.00",
    "name": "Watch and Clock Repairers",
    "description": "Repair, clean, and adjust mechanisms of timing instruments, such as watches and clocks. Includes watchmakers, watch technicians, and mechanical timepiece repairers.",
    "hourlyIncome": 30,
    "annualIncome": 62450,
    "careerGrowth": 0,
    "jobZone": 3
  },
  {
    "code": "49-9069.00",
    "name": "Precision Instrument and Equipment Repairers, All Other",
    "description": "All precision instrument and equipment repairers not listed separately.",
    "hourlyIncome": 34,
    "annualIncome": 70420,
    "careerGrowth": 3.5,
    "jobZone": null
  },
  {
    "code": "49-9071.00",
    "name": "Maintenance and Repair Workers, General",
    "description": "Perform work involving the skills of two or more maintenance or craft occupations to keep machines, mechanical equipment, or the structure of a building in repair. Duties may involve pipe fitting; HVAC maintenance; insulating; welding; machining; carpentry; repairing electrical or mechanical equipment; installing, aligning, and balancing new equipment; and repairing buildings, floors, or stairs.",
    "hourlyIncome": 25,
    "annualIncome": 52430,
    "careerGrowth": 5.1,
    "jobZone": 3
  },
  {
    "code": "49-9081.00",
    "name": "Wind Turbine Service Technicians",
    "description": "Inspect, diagnose, adjust, or repair wind turbines. Perform maintenance on wind turbine equipment including resolving electrical, mechanical, and hydraulic malfunctions.",
    "hourlyIncome": 32,
    "annualIncome": 67580,
    "careerGrowth": 60.1,
    "jobZone": 3
  },
  {
    "code": "49-9091.00",
    "name": "Coin, Vending, and Amusement Machine Servicers and Repairers",
    "description": "Install, service, adjust, or repair coin, vending, or amusement machines including video games, juke boxes, pinball machines, or slot machines.",
    "hourlyIncome": 23,
    "annualIncome": 48530,
    "careerGrowth": -0.4,
    "jobZone": 2
  },
  {
    "code": "49-9092.00",
    "name": "Commercial Divers",
    "description": "Work below surface of water, using surface-supplied air or scuba equipment to inspect, repair, remove, or install equipment and structures. May use a variety of power and hand tools, such as drills, sledgehammers, torches, and welding equipment. May conduct tests or experiments, rig explosives, or photograph structures or marine life.",
    "hourlyIncome": 38,
    "annualIncome": 78110,
    "careerGrowth": 8.3,
    "jobZone": 3
  },
  {
    "code": "49-9094.00",
    "name": "Locksmiths and Safe Repairers",
    "description": "Repair and open locks, make keys, change locks and safe combinations, and install and repair safes.",
    "hourlyIncome": 27,
    "annualIncome": 55200,
    "careerGrowth": -9.9,
    "jobZone": 2
  },
  {
    "code": "49-9095.00",
    "name": "Manufactured Building and Mobile Home Installers",
    "description": "Move or install mobile homes or prefabricated buildings.",
    "hourlyIncome": 20,
    "annualIncome": 42620,
    "careerGrowth": -19.6,
    "jobZone": 2
  },
  {
    "code": "49-9096.00",
    "name": "Riggers",
    "description": "Set up or repair rigging for construction projects, manufacturing plants, logging yards, ships and shipyards, or for the entertainment industry.",
    "hourlyIncome": 32,
    "annualIncome": 66600,
    "careerGrowth": 4.9,
    "jobZone": 2
  },
  {
    "code": "49-9097.00",
    "name": "Signal and Track Switch Repairers",
    "description": "Install, inspect, test, maintain, or repair electric gate crossings, signals, signal equipment, track switches, section lines, or intercommunications systems within a railroad system.",
    "hourlyIncome": 41,
    "annualIncome": 84940,
    "careerGrowth": 2.3,
    "jobZone": 3
  },
  {
    "code": "49-9098.00",
    "name": "Helpers--Installation, Maintenance, and Repair Workers",
    "description": "Help installation, maintenance, and repair workers in maintenance, parts replacement, and repair of vehicles, industrial machinery, and electrical and electronic equipment. Perform duties such as furnishing tools, materials, and supplies to other workers; cleaning work area, machines, and tools; and holding materials or tools for other workers.",
    "hourlyIncome": 20,
    "annualIncome": 40750,
    "careerGrowth": 4.4,
    "jobZone": 2
  },
  {
    "code": "49-9099.00",
    "name": "Installation, Maintenance, and Repair Workers, All Other",
    "description": "All installation, maintenance, and repair workers not listed separately.",
    "hourlyIncome": 26,
    "annualIncome": 53270,
    "careerGrowth": 3.6,
    "jobZone": null
  },
  {
    "code": "49-9099.01",
    "name": "Geothermal Technicians",
    "description": "Perform technical activities at power plants or individual installations necessary for the generation of power from geothermal energy sources. Monitor and control operating activities at geothermal power generation facilities and perform maintenance and repairs as necessary. Install, test, and maintain residential and commercial geothermal heat pumps.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "51-1011.00",
    "name": "First-Line Supervisors of Production and Operating Workers",
    "description": "Directly supervise and coordinate the activities of production and operating workers, such as inspectors, precision workers, machine setters and operators, assemblers, fabricators, and plant and system operators. Excludes team or work leaders.",
    "hourlyIncome": 36,
    "annualIncome": 74540,
    "careerGrowth": 0.6,
    "jobZone": 3
  },
  {
    "code": "51-2011.00",
    "name": "Aircraft Structure, Surfaces, Rigging, and Systems Assemblers",
    "description": "Assemble, fit, fasten, and install parts of airplanes, space vehicles, or missiles, such as tails, wings, fuselage, bulkheads, stabilizers, landing gear, rigging and control equipment, or heating and ventilating systems.",
    "hourlyIncome": 32,
    "annualIncome": 66510,
    "careerGrowth": -16.4,
    "jobZone": 2
  },
  {
    "code": "51-2021.00",
    "name": "Coil Winders, Tapers, and Finishers",
    "description": "Wind wire coils used in electrical components, such as resistors and transformers, and in electrical equipment and instruments, such as field cores, bobbins, armature cores, electrical motors, generators, and control equipment.",
    "hourlyIncome": 24,
    "annualIncome": 48940,
    "careerGrowth": -9.3,
    "jobZone": 2
  },
  {
    "code": "51-2022.00",
    "name": "Electrical and Electronic Equipment Assemblers",
    "description": "Assemble or modify electrical or electronic equipment, such as computers, test equipment telemetering systems, electric motors, and batteries.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "51-2023.00",
    "name": "Electromechanical Equipment Assemblers",
    "description": "Assemble or modify electromechanical equipment or devices, such as servomechanisms, gyros, dynamometers, magnetic drums, tape drives, brakes, control linkage, actuators, and appliances.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "51-2031.00",
    "name": "Engine and Other Machine Assemblers",
    "description": "Construct, assemble, or rebuild machines, such as engines, turbines, and similar equipment used in such industries as construction, extraction, textiles, and paper manufacturing.",
    "hourlyIncome": 27,
    "annualIncome": 56040,
    "careerGrowth": -21.3,
    "jobZone": 2
  },
  {
    "code": "51-2041.00",
    "name": "Structural Metal Fabricators and Fitters",
    "description": "Fabricate, position, align, and fit parts of structural metal products.",
    "hourlyIncome": 25,
    "annualIncome": 52740,
    "careerGrowth": -15.3,
    "jobZone": 2
  },
  {
    "code": "51-2051.00",
    "name": "Fiberglass Laminators and Fabricators",
    "description": "Laminate layers of fiberglass on molds to form boat decks and hulls, bodies for golf carts, automobiles, or other products.",
    "hourlyIncome": 23,
    "annualIncome": 47320,
    "careerGrowth": 4.6,
    "jobZone": 2
  },
  {
    "code": "51-2061.00",
    "name": "Timing Device Assemblers and Adjusters",
    "description": "Perform precision assembling or adjusting, within narrow tolerances, of timing devices such as digital clocks or timing devices with electrical or electronic components.",
    "hourlyIncome": 20,
    "annualIncome": 42410,
    "careerGrowth": -16.3,
    "jobZone": 2
  },
  {
    "code": "51-2092.00",
    "name": "Team Assemblers",
    "description": "Work as part of a team having responsibility for assembling an entire product or component of a product. Team assemblers can perform all tasks conducted by the team in the assembly process and rotate through all or most of them, rather than being assigned to a specific task on a permanent basis. May participate in making management decisions affecting the work. Includes team leaders who work as part of the team.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "51-2099.00",
    "name": "Assemblers and Fabricators, All Other",
    "description": "All assemblers and fabricators not listed separately.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "51-3011.00",
    "name": "Bakers",
    "description": "Mix and bake ingredients to produce breads, rolls, cookies, cakes, pies, pastries, or other baked goods.",
    "hourlyIncome": 18,
    "annualIncome": 37670,
    "careerGrowth": 5.2,
    "jobZone": 2
  },
  {
    "code": "51-3021.00",
    "name": "Butchers and Meat Cutters",
    "description": "Cut, trim, or prepare consumer-sized portions of meat for use or sale in retail establishments.",
    "hourlyIncome": 20,
    "annualIncome": 41300,
    "careerGrowth": -2.1,
    "jobZone": 2
  },
  {
    "code": "51-3022.00",
    "name": "Meat, Poultry, and Fish Cutters and Trimmers",
    "description": "Use hands or hand tools to perform routine cutting and trimming of meat, poultry, and seafood.",
    "hourlyIncome": 19,
    "annualIncome": 38640,
    "careerGrowth": 4.7,
    "jobZone": 1
  },
  {
    "code": "51-3023.00",
    "name": "Slaughterers and Meat Packers",
    "description": "Perform nonroutine or precision functions involving the preparation of large portions of meat. Work may include specialized slaughtering tasks, cutting standard or premium cuts of meat for marketing, making sausage, or wrapping meats. Work typically occurs in slaughtering, meat packing, or wholesale establishments.",
    "hourlyIncome": 20,
    "annualIncome": 40710,
    "careerGrowth": 1.4,
    "jobZone": 2
  },
  {
    "code": "51-3091.00",
    "name": "Food and Tobacco Roasting, Baking, and Drying Machine Operators and Tenders",
    "description": "Operate or tend food or tobacco roasting, baking, or drying equipment, including hearth ovens, kiln driers, roasters, char kilns, and vacuum drying equipment.",
    "hourlyIncome": 21,
    "annualIncome": 44140,
    "careerGrowth": 2.2,
    "jobZone": 2
  },
  {
    "code": "51-3092.00",
    "name": "Food Batchmakers",
    "description": "Set up and operate equipment that mixes or blends ingredients used in the manufacturing of food products. Includes candy makers and cheese makers.",
    "hourlyIncome": 21,
    "annualIncome": 42830,
    "careerGrowth": 9.1,
    "jobZone": 2
  },
  {
    "code": "51-3093.00",
    "name": "Food Cooking Machine Operators and Tenders",
    "description": "Operate or tend cooking equipment, such as steam cooking vats, deep fry cookers, pressure cookers, kettles, and boilers, to prepare food products.",
    "hourlyIncome": 20,
    "annualIncome": 41930,
    "careerGrowth": 1,
    "jobZone": 2
  },
  {
    "code": "51-3099.00",
    "name": "Food Processing Workers, All Other",
    "description": "All food processing workers not listed separately.",
    "hourlyIncome": 19,
    "annualIncome": 39260,
    "careerGrowth": 4.4,
    "jobZone": null
  },
  {
    "code": "51-4021.00",
    "name": "Extruding and Drawing Machine Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend machines to extrude or draw thermoplastic or metal materials into tubes, rods, hoses, wire, bars, or structural shapes.",
    "hourlyIncome": 23,
    "annualIncome": 48170,
    "careerGrowth": 2,
    "jobZone": 2
  },
  {
    "code": "51-4022.00",
    "name": "Forging Machine Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend forging machines to taper, shape, or form metal or plastic parts.",
    "hourlyIncome": 24,
    "annualIncome": 50900,
    "careerGrowth": -15.7,
    "jobZone": 2
  },
  {
    "code": "51-4023.00",
    "name": "Rolling Machine Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend machines to roll steel or plastic forming bends, beads, knurls, rolls, or plate, or to flatten, temper, or reduce gauge of material.",
    "hourlyIncome": 24,
    "annualIncome": 50940,
    "careerGrowth": -7.7,
    "jobZone": 2
  },
  {
    "code": "51-4031.00",
    "name": "Cutting, Punching, and Press Machine Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend machines to saw, cut, shear, slit, punch, crimp, notch, bend, or straighten metal or plastic material.",
    "hourlyIncome": 23,
    "annualIncome": 47060,
    "careerGrowth": -11.2,
    "jobZone": 2
  },
  {
    "code": "51-4032.00",
    "name": "Drilling and Boring Machine Tool Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend drilling machines to drill, bore, ream, mill, or countersink metal or plastic work pieces.",
    "hourlyIncome": 24,
    "annualIncome": 50330,
    "careerGrowth": -19.2,
    "jobZone": 2
  },
  {
    "code": "51-4033.00",
    "name": "Grinding, Lapping, Polishing, and Buffing Machine Tool Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend grinding and related tools that remove excess material or burrs from surfaces, sharpen edges or corners, or buff, hone, or polish metal or plastic work pieces.",
    "hourlyIncome": 22,
    "annualIncome": 46600,
    "careerGrowth": -10.7,
    "jobZone": 2
  },
  {
    "code": "51-4034.00",
    "name": "Lathe and Turning Machine Tool Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend lathe and turning machines to turn, bore, thread, form, or face metal or plastic materials, such as wire, rod, or bar stock.",
    "hourlyIncome": 24,
    "annualIncome": 50190,
    "careerGrowth": -11.4,
    "jobZone": 2
  },
  {
    "code": "51-4035.00",
    "name": "Milling and Planing Machine Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend milling or planing machines to mill, plane, shape, groove, or profile metal or plastic work pieces.",
    "hourlyIncome": 25,
    "annualIncome": 52940,
    "careerGrowth": -12.9,
    "jobZone": 2
  },
  {
    "code": "51-4041.00",
    "name": "Machinists",
    "description": "Set up and operate a variety of machine tools to produce precision parts and instruments out of metal. Includes precision instrument makers who fabricate, modify, or repair mechanical instruments. May also fabricate and modify parts to make or repair machine tools or maintain industrial machines, applying knowledge of mechanics, mathematics, metal properties, layout, and machining procedures.",
    "hourlyIncome": 28,
    "annualIncome": 57390,
    "careerGrowth": 1.7,
    "jobZone": 3
  },
  {
    "code": "51-4051.00",
    "name": "Metal-Refining Furnace Operators and Tenders",
    "description": "Operate or tend furnaces, such as gas, oil, coal, electric-arc or electric induction, open-hearth, or oxygen furnaces, to melt and refine metal before casting or to produce specified types of steel.",
    "hourlyIncome": 28,
    "annualIncome": 57290,
    "careerGrowth": -4.8,
    "jobZone": 2
  },
  {
    "code": "51-4052.00",
    "name": "Pourers and Casters, Metal",
    "description": "Operate hand-controlled mechanisms to pour and regulate the flow of molten metal into molds to produce castings or ingots.",
    "hourlyIncome": 25,
    "annualIncome": 51320,
    "careerGrowth": -6.7,
    "jobZone": 2
  },
  {
    "code": "51-4061.00",
    "name": "Model Makers, Metal and Plastic",
    "description": "Set up and operate machines, such as lathes, milling and engraving machines, and jig borers to make working models of metal or plastic objects. Includes template makers.",
    "hourlyIncome": 32,
    "annualIncome": 65840,
    "careerGrowth": -17.6,
    "jobZone": 3
  },
  {
    "code": "51-4062.00",
    "name": "Patternmakers, Metal and Plastic",
    "description": "Lay out, machine, fit, and assemble castings and parts to metal or plastic foundry patterns, core boxes, or match plates.",
    "hourlyIncome": 28,
    "annualIncome": 57930,
    "careerGrowth": -22.2,
    "jobZone": 3
  },
  {
    "code": "51-4071.00",
    "name": "Foundry Mold and Coremakers",
    "description": "Make or form wax or sand cores or molds used in the production of metal castings in foundries.",
    "hourlyIncome": 23,
    "annualIncome": 46910,
    "careerGrowth": -24.6,
    "jobZone": 2
  },
  {
    "code": "51-4072.00",
    "name": "Molding, Coremaking, and Casting Machine Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend metal or plastic molding, casting, or coremaking machines to mold or cast metal or thermoplastic parts or products.",
    "hourlyIncome": 21,
    "annualIncome": 44130,
    "careerGrowth": -2.5,
    "jobZone": 2
  },
  {
    "code": "51-4081.00",
    "name": "Multiple Machine Tool Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend more than one type of cutting or forming machine tool or robot.",
    "hourlyIncome": 23,
    "annualIncome": 48590,
    "careerGrowth": 1.8,
    "jobZone": 2
  },
  {
    "code": "51-4111.00",
    "name": "Tool and Die Makers",
    "description": "Analyze specifications, lay out metal stock, set up and operate machine tools, and fit and assemble parts to make and repair dies, cutting tools, jigs, fixtures, gauges, and machinists' hand tools.",
    "hourlyIncome": 31,
    "annualIncome": 65100,
    "careerGrowth": -9.7,
    "jobZone": 3
  },
  {
    "code": "51-4121.00",
    "name": "Welders, Cutters, Solderers, and Brazers",
    "description": "Use hand-welding, flame-cutting, hand-soldering, or brazing equipment to weld or join metal components or to fill holes, indentations, or seams of fabricated metal products.",
    "hourlyIncome": 26,
    "annualIncome": 55100,
    "careerGrowth": 2,
    "jobZone": 2
  },
  {
    "code": "51-4122.00",
    "name": "Welding, Soldering, and Brazing Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend welding, soldering, or brazing machines or robots that weld, braze, solder, or heat treat metal products, components, or assemblies. Includes workers who operate laser cutters or laser-beam machines.",
    "hourlyIncome": 24,
    "annualIncome": 49270,
    "careerGrowth": -8.9,
    "jobZone": 2
  },
  {
    "code": "51-4191.00",
    "name": "Heat Treating Equipment Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend heating equipment, such as heat-treating furnaces, flame-hardening machines, induction machines, soaking pits, or vacuum equipment to temper, harden, anneal, or heat treat metal or plastic objects.",
    "hourlyIncome": 24,
    "annualIncome": 49030,
    "careerGrowth": -9.5,
    "jobZone": 2
  },
  {
    "code": "51-4192.00",
    "name": "Layout Workers, Metal and Plastic",
    "description": "Lay out reference points and dimensions on metal or plastic stock or workpieces, such as sheets, plates, tubes, structural shapes, castings, or machine parts, for further processing. Includes shipfitters.",
    "hourlyIncome": 32,
    "annualIncome": 65770,
    "careerGrowth": -3.5,
    "jobZone": 2
  },
  {
    "code": "51-4193.00",
    "name": "Plating Machine Setters, Operators, and Tenders, Metal and Plastic",
    "description": "Set up, operate, or tend plating machines to coat metal or plastic products with chromium, zinc, copper, cadmium, nickel, or other metal to protect or decorate surfaces. Typically, the product being coated is immersed in molten metal or an electrolytic solution.",
    "hourlyIncome": 21,
    "annualIncome": 43820,
    "careerGrowth": -11.1,
    "jobZone": 2
  },
  {
    "code": "51-4194.00",
    "name": "Tool Grinders, Filers, and Sharpeners",
    "description": "Perform precision smoothing, sharpening, polishing, or grinding of metal objects.",
    "hourlyIncome": 25,
    "annualIncome": 51790,
    "careerGrowth": -7.8,
    "jobZone": 2
  },
  {
    "code": "51-4199.00",
    "name": "Metal Workers and Plastic Workers, All Other",
    "description": "All metal workers and plastic workers not listed separately.",
    "hourlyIncome": 22,
    "annualIncome": 45850,
    "careerGrowth": -6.9,
    "jobZone": null
  },
  {
    "code": "51-5111.00",
    "name": "Prepress Technicians and Workers",
    "description": "Format and proof text and images submitted by designers and clients into finished pages that can be printed. Includes digital and photo typesetting. May produce printing plates.",
    "hourlyIncome": 24,
    "annualIncome": 49130,
    "careerGrowth": -18.5,
    "jobZone": 3
  },
  {
    "code": "51-5112.00",
    "name": "Printing Press Operators",
    "description": "Set up and operate digital, letterpress, lithographic, flexographic, gravure, or other printing machines. Includes short-run offset printing presses.",
    "hourlyIncome": 22,
    "annualIncome": 46620,
    "careerGrowth": -9.5,
    "jobZone": 2
  },
  {
    "code": "51-5113.00",
    "name": "Print Binding and Finishing Workers",
    "description": "Bind books and other publications or finish printed products by hand or machine. May set up binding and finishing machines.",
    "hourlyIncome": 21,
    "annualIncome": 43040,
    "careerGrowth": -17.5,
    "jobZone": 2
  },
  {
    "code": "51-6011.00",
    "name": "Laundry and Dry-Cleaning Workers",
    "description": "Operate or tend washing or dry-cleaning machines to wash or dry-clean industrial or household articles, such as cloth garments, suede, leather, furs, blankets, draperies, linens, rugs, and carpets. Includes spotters and dyers of these articles.",
    "hourlyIncome": 16,
    "annualIncome": 33990,
    "careerGrowth": 5.5,
    "jobZone": 1
  },
  {
    "code": "51-6021.00",
    "name": "Pressers, Textile, Garment, and Related Materials",
    "description": "Press or shape articles by hand or machine.",
    "hourlyIncome": 16,
    "annualIncome": 33370,
    "careerGrowth": -12,
    "jobZone": 1
  },
  {
    "code": "51-6031.00",
    "name": "Sewing Machine Operators",
    "description": "Operate or tend sewing machines to join, reinforce, decorate, or perform related sewing operations in the manufacture of garment or nongarment products.",
    "hourlyIncome": 18,
    "annualIncome": 36680,
    "careerGrowth": -13.2,
    "jobZone": 1
  },
  {
    "code": "51-6041.00",
    "name": "Shoe and Leather Workers and Repairers",
    "description": "Construct, decorate, or repair leather and leather-like products, such as luggage, shoes, and saddles. May use hand tools.",
    "hourlyIncome": 17,
    "annualIncome": 36280,
    "careerGrowth": -11.9,
    "jobZone": 2
  },
  {
    "code": "51-6042.00",
    "name": "Shoe Machine Operators and Tenders",
    "description": "Operate or tend a variety of machines to join, decorate, reinforce, or finish shoes and shoe parts.",
    "hourlyIncome": 18,
    "annualIncome": 37230,
    "careerGrowth": -13.6,
    "jobZone": 2
  },
  {
    "code": "51-6051.00",
    "name": "Sewers, Hand",
    "description": "Sew, join, reinforce, or finish, usually with needle and thread, a variety of manufactured items. Includes weavers and stitchers.",
    "hourlyIncome": 17,
    "annualIncome": 34810,
    "careerGrowth": -12.2,
    "jobZone": 1
  },
  {
    "code": "51-6052.00",
    "name": "Tailors, Dressmakers, and Custom Sewers",
    "description": "Design, make, alter, repair, or fit garments.",
    "hourlyIncome": 21,
    "annualIncome": 44050,
    "careerGrowth": -6.5,
    "jobZone": 2
  },
  {
    "code": "51-6061.00",
    "name": "Textile Bleaching and Dyeing Machine Operators and Tenders",
    "description": "Operate or tend machines to bleach, shrink, wash, dye, or finish textiles or synthetic or glass fibers.",
    "hourlyIncome": 19,
    "annualIncome": 39000,
    "careerGrowth": -10.3,
    "jobZone": 2
  },
  {
    "code": "51-6062.00",
    "name": "Textile Cutting Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend machines that cut textiles.",
    "hourlyIncome": 19,
    "annualIncome": 38500,
    "careerGrowth": -11.7,
    "jobZone": 2
  },
  {
    "code": "51-6063.00",
    "name": "Textile Knitting and Weaving Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend machines that knit, loop, weave, or draw in textiles.",
    "hourlyIncome": 19,
    "annualIncome": 39470,
    "careerGrowth": -11.8,
    "jobZone": 2
  },
  {
    "code": "51-6064.00",
    "name": "Textile Winding, Twisting, and Drawing Out Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend machines that wind or twist textiles; or draw out and combine sliver, such as wool, hemp, or synthetic fibers. Includes slubber machine and drawing frame operators.",
    "hourlyIncome": 18,
    "annualIncome": 38440,
    "careerGrowth": -8.8,
    "jobZone": 2
  },
  {
    "code": "51-6091.00",
    "name": "Extruding and Forming Machine Setters, Operators, and Tenders, Synthetic and Glass Fibers",
    "description": "Set up, operate, or tend machines that extrude and form continuous filaments from synthetic materials, such as liquid polymer, rayon, and fiberglass.",
    "hourlyIncome": 23,
    "annualIncome": 47420,
    "careerGrowth": -3.1,
    "jobZone": 2
  },
  {
    "code": "51-6092.00",
    "name": "Fabric and Apparel Patternmakers",
    "description": "Draw and construct sets of precision master fabric patterns or layouts. May also mark and cut fabrics and apparel.",
    "hourlyIncome": 34,
    "annualIncome": 71630,
    "careerGrowth": -11.7,
    "jobZone": 3
  },
  {
    "code": "51-6093.00",
    "name": "Upholsterers",
    "description": "Make, repair, or replace upholstery for household furniture or transportation vehicles.",
    "hourlyIncome": 23,
    "annualIncome": 46960,
    "careerGrowth": -2,
    "jobZone": 2
  },
  {
    "code": "51-6099.00",
    "name": "Textile, Apparel, and Furnishings Workers, All Other",
    "description": "All textile, apparel, and furnishings workers not listed separately.",
    "hourlyIncome": 19,
    "annualIncome": 40410,
    "careerGrowth": -9.5,
    "jobZone": null
  },
  {
    "code": "51-7011.00",
    "name": "Cabinetmakers and Bench Carpenters",
    "description": "Cut, shape, and assemble wooden articles or set up and operate a variety of woodworking machines, such as power saws, jointers, and mortisers to surface, cut, or shape lumber or to fabricate parts for wood products.",
    "hourlyIncome": 23,
    "annualIncome": 47460,
    "careerGrowth": -2.7,
    "jobZone": 2
  },
  {
    "code": "51-7021.00",
    "name": "Furniture Finishers",
    "description": "Shape, finish, and refinish damaged, worn, or used furniture or new high-grade furniture to specified color or finish.",
    "hourlyIncome": 21,
    "annualIncome": 44310,
    "careerGrowth": -1.6,
    "jobZone": 2
  },
  {
    "code": "51-7031.00",
    "name": "Model Makers, Wood",
    "description": "Construct full-size and scale wooden precision models of products. Includes wood jig builders and loft workers.",
    "hourlyIncome": 29,
    "annualIncome": 59780,
    "careerGrowth": -12.8,
    "jobZone": 3
  },
  {
    "code": "51-7032.00",
    "name": "Patternmakers, Wood",
    "description": "Plan, lay out, and construct wooden unit or sectional patterns used in forming sand molds for castings.",
    "hourlyIncome": 28,
    "annualIncome": 57920,
    "careerGrowth": -13.5,
    "jobZone": 3
  },
  {
    "code": "51-7041.00",
    "name": "Sawing Machine Setters, Operators, and Tenders, Wood",
    "description": "Set up, operate, or tend wood sawing machines. May operate computer numerically controlled (CNC) equipment. Includes lead sawyers.",
    "hourlyIncome": 20,
    "annualIncome": 42390,
    "careerGrowth": -0.5,
    "jobZone": 2
  },
  {
    "code": "51-7042.00",
    "name": "Woodworking Machine Setters, Operators, and Tenders, Except Sawing",
    "description": "Set up, operate, or tend woodworking machines, such as drill presses, lathes, shapers, routers, sanders, planers, and wood nailing machines. May operate computer numerically controlled (CNC) equipment.",
    "hourlyIncome": 20,
    "annualIncome": 42290,
    "careerGrowth": -2.2,
    "jobZone": 2
  },
  {
    "code": "51-7099.00",
    "name": "Woodworkers, All Other",
    "description": "All woodworkers not listed separately.",
    "hourlyIncome": 21,
    "annualIncome": 43730,
    "careerGrowth": -13.5,
    "jobZone": null
  },
  {
    "code": "51-8011.00",
    "name": "Nuclear Power Reactor Operators",
    "description": "Operate or control nuclear reactors. Move control rods, start and stop equipment, monitor and adjust controls, and record data in logs. Implement emergency procedures when needed. May respond to abnormalities, determine cause, and recommend corrective action.",
    "hourlyIncome": 59,
    "annualIncome": 122830,
    "careerGrowth": -10.3,
    "jobZone": 3
  },
  {
    "code": "51-8012.00",
    "name": "Power Distributors and Dispatchers",
    "description": "Coordinate, regulate, or distribute electricity or steam.",
    "hourlyIncome": 53,
    "annualIncome": 109620,
    "careerGrowth": -1.4,
    "jobZone": 3
  },
  {
    "code": "51-8013.00",
    "name": "Power Plant Operators",
    "description": "Control, operate, or maintain machinery to generate electric power. Includes auxiliary equipment operators.",
    "hourlyIncome": 46,
    "annualIncome": 95990,
    "careerGrowth": -9.4,
    "jobZone": 2
  },
  {
    "code": "51-8013.03",
    "name": "Biomass Plant Technicians",
    "description": "Control and monitor biomass plant activities and perform maintenance as needed.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "51-8013.04",
    "name": "Hydroelectric Plant Technicians",
    "description": "Monitor and control activities associated with hydropower generation. Operate plant equipment, such as turbines, pumps, valves, gates, fans, electric control boards, and battery banks. Monitor equipment operation and performance and make necessary adjustments to ensure optimal performance. Perform equipment maintenance and repair as necessary.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "51-8021.00",
    "name": "Stationary Engineers and Boiler Operators",
    "description": "Operate or maintain stationary engines, boilers, or other mechanical equipment to provide utilities for buildings or industrial processes. Operate equipment such as steam engines, generators, motors, turbines, and steam boilers.",
    "hourlyIncome": 38,
    "annualIncome": 79710,
    "careerGrowth": 4.1,
    "jobZone": 3
  },
  {
    "code": "51-8031.00",
    "name": "Water and Wastewater Treatment Plant and System Operators",
    "description": "Operate or control an entire process or system of machines, often through the use of control boards, to transfer or treat water or wastewater.",
    "hourlyIncome": 29,
    "annualIncome": 60620,
    "careerGrowth": -6,
    "jobZone": 3
  },
  {
    "code": "51-8091.00",
    "name": "Chemical Plant and System Operators",
    "description": "Control or operate entire chemical processes or system of machines.",
    "hourlyIncome": 37,
    "annualIncome": 76290,
    "careerGrowth": -0.8,
    "jobZone": 2
  },
  {
    "code": "51-8092.00",
    "name": "Gas Plant Operators",
    "description": "Distribute or process gas for utility companies and others by controlling compressors to maintain specified pressures on main pipelines.",
    "hourlyIncome": 41,
    "annualIncome": 85470,
    "careerGrowth": -9.8,
    "jobZone": 2
  },
  {
    "code": "51-8093.00",
    "name": "Petroleum Pump System Operators, Refinery Operators, and Gaugers",
    "description": "Operate or control petroleum refining or processing units. May specialize in controlling manifold and pumping systems, gauging or testing oil in storage tanks, or regulating the flow of oil into pipelines.",
    "hourlyIncome": 44,
    "annualIncome": 90970,
    "careerGrowth": -2.3,
    "jobZone": 2
  },
  {
    "code": "51-8099.00",
    "name": "Plant and System Operators, All Other",
    "description": "All plant and system operators not listed separately.",
    "hourlyIncome": 31,
    "annualIncome": 64490,
    "careerGrowth": 3.2,
    "jobZone": null
  },
  {
    "code": "51-8099.01",
    "name": "Biofuels Processing Technicians",
    "description": "Calculate, measure, load, mix, and process refined feedstock with additives in fermentation or reaction process vessels and monitor production process. Perform, and keep records of, plant maintenance, repairs, and safety inspections.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "51-9011.00",
    "name": "Chemical Equipment Operators and Tenders",
    "description": "Operate or tend equipment to control chemical changes or reactions in the processing of industrial or consumer products. Equipment used includes devulcanizers, steam-jacketed kettles, and reactor vessels.",
    "hourlyIncome": 29,
    "annualIncome": 59800,
    "careerGrowth": -5.4,
    "jobZone": 2
  },
  {
    "code": "51-9012.00",
    "name": "Separating, Filtering, Clarifying, Precipitating, and Still Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend continuous flow or vat-type equipment; filter presses; shaker screens; centrifuges; condenser tubes; precipitating, fermenting, or evaporating tanks; scrubbing towers; or batch stills. These machines extract, sort, or separate liquids, gases, or solids from other materials to recover a refined product. Includes dairy processing equipment operators.",
    "hourlyIncome": 26,
    "annualIncome": 53830,
    "careerGrowth": 1.7,
    "jobZone": 2
  },
  {
    "code": "51-9021.00",
    "name": "Crushing, Grinding, and Polishing Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend machines to crush, grind, or polish materials, such as coal, glass, grain, stone, food, or rubber.",
    "hourlyIncome": 24,
    "annualIncome": 49400,
    "careerGrowth": -1,
    "jobZone": 2
  },
  {
    "code": "51-9022.00",
    "name": "Grinding and Polishing Workers, Hand",
    "description": "Grind, sand, or polish, using hand tools or hand-held power tools, a variety of metal, wood, stone, clay, plastic, or glass objects. Includes chippers, buffers, and finishers.",
    "hourlyIncome": 21,
    "annualIncome": 43550,
    "careerGrowth": -17.8,
    "jobZone": 2
  },
  {
    "code": "51-9023.00",
    "name": "Mixing and Blending Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend machines to mix or blend materials, such as chemicals, tobacco, liquids, color pigments, or explosive ingredients.",
    "hourlyIncome": 24,
    "annualIncome": 49990,
    "careerGrowth": 4.3,
    "jobZone": 2
  },
  {
    "code": "51-9031.00",
    "name": "Cutters and Trimmers, Hand",
    "description": "Use hand tools or hand-held power tools to cut and trim a variety of manufactured items, such as carpet, fabric, stone, glass, or rubber.",
    "hourlyIncome": 20,
    "annualIncome": 41960,
    "careerGrowth": -18.4,
    "jobZone": 1
  },
  {
    "code": "51-9032.00",
    "name": "Cutting and Slicing Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend machines that cut or slice materials, such as glass, stone, cork, rubber, tobacco, food, paper, or insulating material.",
    "hourlyIncome": 22,
    "annualIncome": 46420,
    "careerGrowth": -2.7,
    "jobZone": 2
  },
  {
    "code": "51-9041.00",
    "name": "Extruding, Forming, Pressing, and Compacting Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend machines, such as glass-forming machines, plodder machines, and tuber machines, to shape and form products such as glassware, food, rubber, soap, brick, tile, clay, wax, tobacco, or cosmetics.",
    "hourlyIncome": 23,
    "annualIncome": 47040,
    "careerGrowth": 2.7,
    "jobZone": 2
  },
  {
    "code": "51-9051.00",
    "name": "Furnace, Kiln, Oven, Drier, and Kettle Operators and Tenders",
    "description": "Operate or tend heating equipment other than basic metal, plastic, or food processing equipment. Includes activities such as annealing glass, drying lumber, curing rubber, removing moisture from materials, or boiling soap.",
    "hourlyIncome": 24,
    "annualIncome": 49250,
    "careerGrowth": 2,
    "jobZone": 2
  },
  {
    "code": "51-9061.00",
    "name": "Inspectors, Testers, Sorters, Samplers, and Weighers",
    "description": "Inspect, test, sort, sample, or weigh nonagricultural raw materials or processed, machined, fabricated, or assembled parts or products for defects, wear, and deviations from specifications. May use precision measuring instruments and complex test equipment.",
    "hourlyIncome": 25,
    "annualIncome": 51670,
    "careerGrowth": -3,
    "jobZone": 2
  },
  {
    "code": "51-9071.00",
    "name": "Jewelers and Precious Stone and Metal Workers",
    "description": "Design, fabricate, adjust, repair, or appraise jewelry, gold, silver, other precious metals, or gems.",
    "hourlyIncome": 26,
    "annualIncome": 55030,
    "careerGrowth": -3.7,
    "jobZone": 3
  },
  {
    "code": "51-9071.06",
    "name": "Gem and Diamond Workers",
    "description": "Fabricate, finish, or evaluate the quality of gems and diamonds used in jewelry or industrial tools.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "51-9081.00",
    "name": "Dental Laboratory Technicians",
    "description": "Construct and repair full or partial dentures or dental appliances.",
    "hourlyIncome": 26,
    "annualIncome": 54060,
    "careerGrowth": -4.2,
    "jobZone": 2
  },
  {
    "code": "51-9082.00",
    "name": "Medical Appliance Technicians",
    "description": "Construct, maintain, or repair medical supportive devices such as braces, orthotics and prosthetic devices, joints, arch supports, and other surgical and medical appliances.",
    "hourlyIncome": 25,
    "annualIncome": 51410,
    "careerGrowth": 3.9,
    "jobZone": 3
  },
  {
    "code": "51-9083.00",
    "name": "Ophthalmic Laboratory Technicians",
    "description": "Cut, grind, and polish eyeglasses, contact lenses, or other precision optical elements. Assemble and mount lenses into frames or process other optical elements. Includes precision lens polishers or grinders, centerer-edgers, and lens mounters.",
    "hourlyIncome": 20,
    "annualIncome": 41760,
    "careerGrowth": 1.6,
    "jobZone": 2
  },
  {
    "code": "51-9111.00",
    "name": "Packaging and Filling Machine Operators and Tenders",
    "description": "Operate or tend machines to prepare industrial or consumer products for storage or shipment. Includes cannery workers who pack food products.",
    "hourlyIncome": 21,
    "annualIncome": 43630,
    "careerGrowth": 6.7,
    "jobZone": 2
  },
  {
    "code": "51-9123.00",
    "name": "Painting, Coating, and Decorating Workers",
    "description": "Paint, coat, or decorate articles, such as furniture, glass, plateware, pottery, jewelry, toys, books, or leather.",
    "hourlyIncome": 21,
    "annualIncome": 44130,
    "careerGrowth": 1.5,
    "jobZone": 1
  },
  {
    "code": "51-9124.00",
    "name": "Coating, Painting, and Spraying Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend spraying or rolling machines to coat or paint any of a wide variety of products, including glassware, cloth, ceramics, metal, plastic, paper, or wood, with lacquer, silver, copper, rubber, varnish, glaze, enamel, oil, or rust-proofing materials. Includes painters of transportation vehicles such as painters in auto body repair facilities.",
    "hourlyIncome": 25,
    "annualIncome": 51610,
    "careerGrowth": 1.2,
    "jobZone": 2
  },
  {
    "code": "51-9141.00",
    "name": "Semiconductor Processing Technicians",
    "description": "Perform any or all of the following functions in the manufacture of electronic semiconductors: load semiconductor material into furnace; saw formed ingots into segments; load individual segment into crystal growing chamber and monitor controls; locate crystal axis in ingot using x-ray equipment and saw ingots into wafers; and clean, polish, and load wafers into series of special purpose furnaces, chemical baths, and equipment used to form circuitry and change conductive properties.",
    "hourlyIncome": 29,
    "annualIncome": 59640,
    "careerGrowth": 13,
    "jobZone": 2
  },
  {
    "code": "51-9151.00",
    "name": "Photographic Process Workers and Processing Machine Operators",
    "description": "Perform work involved in developing and processing photographic images from film or digital media. May perform precision tasks such as editing photographic negatives and prints.",
    "hourlyIncome": 22,
    "annualIncome": 46050,
    "careerGrowth": 1.5,
    "jobZone": 2
  },
  {
    "code": "51-9161.00",
    "name": "Computer Numerically Controlled Tool Operators",
    "description": "Operate computer-controlled tools, machines, or robots to machine or process parts, tools, or other work pieces made of metal, plastic, wood, stone, or other materials. May also set up and maintain equipment.",
    "hourlyIncome": 25,
    "annualIncome": 52900,
    "careerGrowth": -9.2,
    "jobZone": 2
  },
  {
    "code": "51-9162.00",
    "name": "Computer Numerically Controlled Tool Programmers",
    "description": "Develop programs to control machining or processing of materials by automatic machine tools, equipment, or systems. May also set up, operate, or maintain equipment.",
    "hourlyIncome": 34,
    "annualIncome": 69880,
    "careerGrowth": 14.9,
    "jobZone": 3
  },
  {
    "code": "51-9191.00",
    "name": "Adhesive Bonding Machine Operators and Tenders",
    "description": "Operate or tend bonding machines that use adhesives to join items for further processing or to form a completed product. Processes include joining veneer sheets into plywood; gluing paper; or joining rubber and rubberized fabric parts, plastic, simulated leather, or other materials.",
    "hourlyIncome": 22,
    "annualIncome": 45670,
    "careerGrowth": -0.5,
    "jobZone": 2
  },
  {
    "code": "51-9192.00",
    "name": "Cleaning, Washing, and Metal Pickling Equipment Operators and Tenders",
    "description": "Operate or tend machines to wash or clean products, such as barrels or kegs, glass items, tin plate, food, pulp, coal, plastic, or rubber, to remove impurities.",
    "hourlyIncome": 21,
    "annualIncome": 43380,
    "careerGrowth": 4.5,
    "jobZone": 2
  },
  {
    "code": "51-9193.00",
    "name": "Cooling and Freezing Equipment Operators and Tenders",
    "description": "Operate or tend equipment such as cooling and freezing units, refrigerators, batch freezers, and freezing tunnels, to cool or freeze products, food, blood plasma, and chemicals.",
    "hourlyIncome": 21,
    "annualIncome": 44290,
    "careerGrowth": 9.4,
    "jobZone": 2
  },
  {
    "code": "51-9194.00",
    "name": "Etchers and Engravers",
    "description": "Engrave or etch metal, wood, rubber, or other materials. Includes such workers as etcher-circuit processors, pantograph engravers, and silk screen etchers.",
    "hourlyIncome": 21,
    "annualIncome": 43280,
    "careerGrowth": 2.3,
    "jobZone": 2
  },
  {
    "code": "51-9195.00",
    "name": "Molders, Shapers, and Casters, Except Metal and Plastic",
    "description": "Mold, shape, form, cast, or carve products such as food products, figurines, tile, pipes, and candles consisting of clay, glass, plaster, concrete, stone, or combinations of materials.",
    "hourlyIncome": 22,
    "annualIncome": 46730,
    "careerGrowth": 5.3,
    "jobZone": 2
  },
  {
    "code": "51-9195.03",
    "name": "Stone Cutters and Carvers, Manufacturing",
    "description": "Cut or carve stone according to diagrams and patterns.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "51-9195.04",
    "name": "Glass Blowers, Molders, Benders, and Finishers",
    "description": "Shape molten glass according to patterns.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "51-9195.05",
    "name": "Potters, Manufacturing",
    "description": "Operate production machines such as pug mill, jigger machine, or potter's wheel to process clay in manufacture of ceramic, pottery and stoneware products.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "51-9196.00",
    "name": "Paper Goods Machine Setters, Operators, and Tenders",
    "description": "Set up, operate, or tend paper goods machines that perform a variety of functions, such as converting, sawing, corrugating, banding, wrapping, boxing, stitching, forming, or sealing paper or paperboard sheets into products.",
    "hourlyIncome": 25,
    "annualIncome": 51750,
    "careerGrowth": -12.5,
    "jobZone": 2
  },
  {
    "code": "51-9197.00",
    "name": "Tire Builders",
    "description": "Operate machines to build tires.",
    "hourlyIncome": 27,
    "annualIncome": 56230,
    "careerGrowth": 3.1,
    "jobZone": 2
  },
  {
    "code": "51-9198.00",
    "name": "Helpers--Production Workers",
    "description": "Help production workers by performing duties requiring less skill. Duties include supplying or holding materials or tools, and cleaning work area and equipment.",
    "hourlyIncome": 19,
    "annualIncome": 40080,
    "careerGrowth": -8.3,
    "jobZone": 2
  },
  {
    "code": "51-9199.00",
    "name": "Production Workers, All Other",
    "description": "All production workers not listed separately.",
    "hourlyIncome": 21,
    "annualIncome": 42940,
    "careerGrowth": 1.9,
    "jobZone": null
  },
  {
    "code": "53-1041.00",
    "name": "Aircraft Cargo Handling Supervisors",
    "description": "Supervise and coordinate the activities of ground crew in the loading, unloading, securing, and staging of aircraft cargo or baggage. May determine the quantity and orientation of cargo and compute aircraft center of gravity. May accompany aircraft as member of flight crew and monitor and handle cargo in flight, and assist and brief passengers on safety and emergency procedures. Includes loadmasters.",
    "hourlyIncome": 32,
    "annualIncome": 66190,
    "careerGrowth": 7.7,
    "jobZone": 2
  },
  {
    "code": "53-1042.00",
    "name": "First-Line Supervisors of Helpers, Laborers, and Material Movers, Hand",
    "description": "Directly supervise and coordinate the activities of helpers, laborers, or material movers, hand.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "53-1042.01",
    "name": "Recycling Coordinators",
    "description": "Supervise curbside and drop-off recycling programs for municipal governments or private firms.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "53-1043.00",
    "name": "First-Line Supervisors of Material-Moving Machine and Vehicle Operators",
    "description": "Directly supervise and coordinate activities of material-moving machine and vehicle operators and helpers.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "53-1044.00",
    "name": "First-Line Supervisors of Passenger Attendants",
    "description": "Supervise and coordinate activities of passenger attendants.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "53-1049.00",
    "name": "First-Line Supervisors of Transportation Workers, All Other",
    "description": "All first-line supervisors of transportation workers not listed separately.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "53-2011.00",
    "name": "Airline Pilots, Copilots, and Flight Engineers",
    "description": "Pilot and navigate the flight of fixed-wing aircraft, usually on scheduled air carrier routes, for the transport of passengers and cargo. Requires Federal Air Transport certificate and rating for specific aircraft type used. Includes regional, national, and international airline pilots and flight instructors of airline pilots.",
    "hourlyIncome": null,
    "annualIncome": 280570,
    "careerGrowth": 5,
    "jobZone": 4
  },
  {
    "code": "53-2012.00",
    "name": "Commercial Pilots",
    "description": "Pilot and navigate the flight of fixed-wing aircraft on nonscheduled air carrier routes, or helicopters. Requires Commercial Pilot certificate. Includes charter pilots with similar certification, and air ambulance and air tour pilots. Excludes regional, national, and international airline pilots.",
    "hourlyIncome": null,
    "annualIncome": 142960,
    "careerGrowth": 5.7,
    "jobZone": 3
  },
  {
    "code": "53-2021.00",
    "name": "Air Traffic Controllers",
    "description": "Control air traffic on and within vicinity of airport, and movement of air traffic between altitude sectors and control centers, according to established procedures and policies. Authorize, regulate, and control commercial airline flights according to government or company regulations to expedite and ensure flight safety.",
    "hourlyIncome": 69,
    "annualIncome": 142740,
    "careerGrowth": 2.9,
    "jobZone": 3
  },
  {
    "code": "53-2022.00",
    "name": "Airfield Operations Specialists",
    "description": "Ensure the safe takeoff and landing of commercial and military aircraft. Duties include coordination between air-traffic control and maintenance personnel, dispatching, using airfield landing and navigational aids, implementing airfield safety procedures, monitoring and maintaining flight records, and applying knowledge of weather information.",
    "hourlyIncome": 32,
    "annualIncome": 67120,
    "careerGrowth": 5.3,
    "jobZone": 3
  },
  {
    "code": "53-2031.00",
    "name": "Flight Attendants",
    "description": "Monitor safety of the aircraft cabin. Provide services to airline passengers, explain safety information, serve food and beverages, and respond to emergency incidents.",
    "hourlyIncome": null,
    "annualIncome": 78950,
    "careerGrowth": 9.9,
    "jobZone": 2
  },
  {
    "code": "53-3011.00",
    "name": "Ambulance Drivers and Attendants, Except Emergency Medical Technicians",
    "description": "Drive ambulance or assist ambulance driver in transporting sick, injured, or convalescent persons. Assist in lifting patients.",
    "hourlyIncome": 17,
    "annualIncome": 35550,
    "careerGrowth": -0.1,
    "jobZone": 2
  },
  {
    "code": "53-3031.00",
    "name": "Driver/Sales Workers",
    "description": "Drive truck or other vehicle over established routes or within an established territory and sell or deliver goods, such as food products, including restaurant take-out items, or pick up or deliver items such as commercial laundry. May also take orders, collect payment, or stock merchandise at point of delivery.",
    "hourlyIncome": 19,
    "annualIncome": 39670,
    "careerGrowth": 9.2,
    "jobZone": 2
  },
  {
    "code": "53-3032.00",
    "name": "Heavy and Tractor-Trailer Truck Drivers",
    "description": "Drive a tractor-trailer combination or a truck with a capacity of at least 26,001 pounds Gross Vehicle Weight (GVW). May be required to unload truck. Requires commercial drivers' license. Includes tow truck drivers.",
    "hourlyIncome": 28,
    "annualIncome": 58400,
    "careerGrowth": 4.6,
    "jobZone": 2
  },
  {
    "code": "53-3033.00",
    "name": "Light Truck Drivers",
    "description": "Drive a light vehicle, such as a truck or van, with a capacity of less than 26,001 pounds Gross Vehicle Weight (GVW), primarily to pick up merchandise or packages from a distribution center and deliver. May load and unload vehicle.",
    "hourlyIncome": 23,
    "annualIncome": 47950,
    "careerGrowth": 8.8,
    "jobZone": 2
  },
  {
    "code": "53-3051.00",
    "name": "Bus Drivers, School",
    "description": "Drive a school bus to transport students. Ensure adherence to safety rules. May assist students in boarding or exiting.",
    "hourlyIncome": 22,
    "annualIncome": 46660,
    "careerGrowth": 1,
    "jobZone": 2
  },
  {
    "code": "53-3052.00",
    "name": "Bus Drivers, Transit and Intercity",
    "description": "Drive bus or motor coach, including regular route operations, charters, and private carriage. May assist passengers with baggage. May collect fares or tickets.",
    "hourlyIncome": 28,
    "annualIncome": 58390,
    "careerGrowth": 5.2,
    "jobZone": 2
  },
  {
    "code": "53-3053.00",
    "name": "Shuttle Drivers and Chauffeurs",
    "description": "Drive a motor vehicle to transport passengers on a planned or scheduled basis. May collect a fare. Includes nonemergency medical transporters and hearse drivers.",
    "hourlyIncome": 19,
    "annualIncome": 39070,
    "careerGrowth": 8.5,
    "jobZone": 2
  },
  {
    "code": "53-3054.00",
    "name": "Taxi Drivers",
    "description": "Drive a motor vehicle to transport passengers on an unplanned basis and charge a fare, usually based on a meter.",
    "hourlyIncome": 19,
    "annualIncome": 39310,
    "careerGrowth": 13.3,
    "jobZone": 2
  },
  {
    "code": "53-3099.00",
    "name": "Motor Vehicle Operators, All Other",
    "description": "All motor vehicle operators not listed separately.",
    "hourlyIncome": 20,
    "annualIncome": 40980,
    "careerGrowth": 8.3,
    "jobZone": null
  },
  {
    "code": "53-4011.00",
    "name": "Locomotive Engineers",
    "description": "Drive electric, diesel-electric, steam, or gas-turbine-electric locomotives to transport passengers or freight. Interpret train orders, electronic or manual signals, and railroad rules and regulations.",
    "hourlyIncome": 39,
    "annualIncome": 81540,
    "careerGrowth": 1.3,
    "jobZone": 2
  },
  {
    "code": "53-4013.00",
    "name": "Rail Yard Engineers, Dinkey Operators, and Hostlers",
    "description": "Drive switching or other locomotive or dinkey engines within railroad yard, industrial plant, quarry, construction project, or similar location.",
    "hourlyIncome": 29,
    "annualIncome": 60810,
    "careerGrowth": 0.5,
    "jobZone": 2
  },
  {
    "code": "53-4022.00",
    "name": "Railroad Brake, Signal, and Switch Operators and Locomotive Firers",
    "description": "Operate or monitor railroad track switches or locomotive instruments. May couple or uncouple rolling stock to make up or break up trains. Watch for and relay traffic signals. May inspect couplings, air hoses, journal boxes, and hand brakes. May watch for dragging equipment or obstacles on rights-of-way.",
    "hourlyIncome": 30,
    "annualIncome": 63170,
    "careerGrowth": 1.5,
    "jobZone": 2
  },
  {
    "code": "53-4031.00",
    "name": "Railroad Conductors and Yardmasters",
    "description": "Coordinate activities of switch-engine crew within railroad yard, industrial plant, or similar location. Conductors coordinate activities of train crew on passenger or freight trains. Yardmasters review train schedules and switching orders and coordinate activities of workers engaged in railroad traffic operations, such as the makeup or breakup of trains and yard switching.",
    "hourlyIncome": 36,
    "annualIncome": 75490,
    "careerGrowth": 1.9,
    "jobZone": 2
  },
  {
    "code": "53-4041.00",
    "name": "Subway and Streetcar Operators",
    "description": "Operate subway or elevated suburban trains with no separate locomotive, or electric-powered streetcar, to transport passengers. May handle fares.",
    "hourlyIncome": 36,
    "annualIncome": 75620,
    "careerGrowth": 4.2,
    "jobZone": 2
  },
  {
    "code": "53-4099.00",
    "name": "Rail Transportation Workers, All Other",
    "description": "All rail transportation workers not listed separately.",
    "hourlyIncome": 26,
    "annualIncome": 53500,
    "careerGrowth": 3.5,
    "jobZone": null
  },
  {
    "code": "53-5011.00",
    "name": "Sailors and Marine Oilers",
    "description": "Stand watch to look for obstructions in path of vessel, measure water depth, turn wheel on bridge, or use emergency equipment as directed by captain, mate, or pilot. Break out, rig, overhaul, and store cargo-handling gear, stationary rigging, and running gear. Perform a variety of maintenance tasks to preserve the painted surface of the ship and to maintain line and ship equipment. Must hold government-issued certification and tankerman certification when working aboard liquid-carrying vessels. Includes able seamen and ordinary seamen.",
    "hourlyIncome": 27,
    "annualIncome": 55320,
    "careerGrowth": 3.5,
    "jobZone": 2
  },
  {
    "code": "53-5021.00",
    "name": "Captains, Mates, and Pilots of Water Vessels",
    "description": "Command or supervise operations of ships and water vessels, such as tugboats and ferryboats. Required to hold license issued by U.S. Coast Guard.",
    "hourlyIncome": 47,
    "annualIncome": 97660,
    "careerGrowth": 2.3,
    "jobZone": 3
  },
  {
    "code": "53-5022.00",
    "name": "Motorboat Operators",
    "description": "Operate small motor-driven boats. May assist in navigational activities.",
    "hourlyIncome": 27,
    "annualIncome": 55370,
    "careerGrowth": 3.4,
    "jobZone": 2
  },
  {
    "code": "53-5031.00",
    "name": "Ship Engineers",
    "description": "Supervise and coordinate activities of crew engaged in operating and maintaining engines, boilers, deck machinery, and electrical, sanitary, and refrigeration equipment aboard ship.",
    "hourlyIncome": 51,
    "annualIncome": 105600,
    "careerGrowth": 3.4,
    "jobZone": 3
  },
  {
    "code": "53-6011.00",
    "name": "Bridge and Lock Tenders",
    "description": "Operate and tend bridges, canal locks, and lighthouses to permit marine passage on inland waterways, near shores, and at danger points in waterway passages. May supervise such operations. Includes drawbridge operators, lock operators, and slip bridge operators.",
    "hourlyIncome": 27,
    "annualIncome": 56520,
    "careerGrowth": 0.5,
    "jobZone": 2
  },
  {
    "code": "53-6021.00",
    "name": "Parking Attendants",
    "description": "Park vehicles or issue tickets for customers in a parking lot or garage. May park or tend vehicles in environments such as a car dealership or rental car facility. May collect fee.",
    "hourlyIncome": 16,
    "annualIncome": 34190,
    "careerGrowth": 5.3,
    "jobZone": 2
  },
  {
    "code": "53-6031.00",
    "name": "Automotive and Watercraft Service Attendants",
    "description": "Service automobiles, buses, trucks, boats, and other automotive or marine vehicles with fuel, lubricants, and accessories. Collect payment for services and supplies. May lubricate vehicle, change motor oil, refill antifreeze, or replace lights or other accessories, such as windshield wiper blades or fan belts. May repair or replace tires.",
    "hourlyIncome": 17,
    "annualIncome": 35800,
    "careerGrowth": -0.1,
    "jobZone": 2
  },
  {
    "code": "53-6032.00",
    "name": "Aircraft Service Attendants",
    "description": "Service aircraft with fuel. May de-ice aircraft, refill water and cooling agents, empty sewage tanks, service air and oxygen systems, or clean and polish exterior.",
    "hourlyIncome": 21,
    "annualIncome": 43630,
    "careerGrowth": 6.2,
    "jobZone": 2
  },
  {
    "code": "53-6041.00",
    "name": "Traffic Technicians",
    "description": "Conduct field studies to determine traffic volume, speed, effectiveness of signals, adequacy of lighting, and other factors influencing traffic conditions, under direction of traffic engineer.",
    "hourlyIncome": 29,
    "annualIncome": 61310,
    "careerGrowth": 4.2,
    "jobZone": 3
  },
  {
    "code": "53-6051.00",
    "name": "Transportation Inspectors",
    "description": "Inspect equipment or goods in connection with the safe transport of cargo or people. Includes rail transportation inspectors, such as freight inspectors, rail inspectors, and other inspectors of transportation vehicles not elsewhere classified.",
    "hourlyIncome": 42,
    "annualIncome": 86490,
    "careerGrowth": 3.9,
    "jobZone": 4
  },
  {
    "code": "53-6051.01",
    "name": "Aviation Inspectors",
    "description": "Inspect aircraft, maintenance procedures, air navigational aids, air traffic controls, and communications equipment to ensure conformance with Federal safety regulations.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 3
  },
  {
    "code": "53-6051.07",
    "name": "Transportation Vehicle, Equipment and Systems Inspectors, Except Aviation",
    "description": "Inspect and monitor transportation equipment, vehicles, or systems to ensure compliance with regulations and safety standards.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "53-6061.00",
    "name": "Passenger Attendants",
    "description": "Provide services to ensure the safety of passengers aboard ships, buses, trains, or within the station or terminal. Perform duties such as explaining the use of safety equipment, serving meals or beverages, or answering questions related to travel.",
    "hourlyIncome": 19,
    "annualIncome": 38480,
    "careerGrowth": 5.8,
    "jobZone": 2
  },
  {
    "code": "53-6099.00",
    "name": "Transportation Workers, All Other",
    "description": "All transportation workers not listed separately.",
    "hourlyIncome": 22,
    "annualIncome": 45040,
    "careerGrowth": 5.3,
    "jobZone": null
  },
  {
    "code": "53-7011.00",
    "name": "Conveyor Operators and Tenders",
    "description": "Control or tend conveyors or conveyor systems that move materials or products to and from stockpiles, processing stations, departments, or vehicles. May control speed and routing of materials or products.",
    "hourlyIncome": 22,
    "annualIncome": 44800,
    "careerGrowth": -0.9,
    "jobZone": 1
  },
  {
    "code": "53-7021.00",
    "name": "Crane and Tower Operators",
    "description": "Operate mechanical boom and cable or tower and cable equipment to lift and move materials, machines, or products in many directions.",
    "hourlyIncome": 34,
    "annualIncome": 71560,
    "careerGrowth": 3.7,
    "jobZone": 3
  },
  {
    "code": "53-7031.00",
    "name": "Dredge Operators",
    "description": "Operate dredge to remove sand, gravel, or other materials in order to excavate and maintain navigable channels in waterways.",
    "hourlyIncome": 27,
    "annualIncome": 55820,
    "careerGrowth": 2.1,
    "jobZone": 2
  },
  {
    "code": "53-7041.00",
    "name": "Hoist and Winch Operators",
    "description": "Operate or tend hoists or winches to lift and pull loads using power-operated cable equipment.",
    "hourlyIncome": 31,
    "annualIncome": 64070,
    "careerGrowth": -0.5,
    "jobZone": 2
  },
  {
    "code": "53-7051.00",
    "name": "Industrial Truck and Tractor Operators",
    "description": "Operate industrial trucks or tractors equipped to move materials around a warehouse, storage yard, factory, construction site, or similar location.",
    "hourlyIncome": 23,
    "annualIncome": 47830,
    "careerGrowth": 2.7,
    "jobZone": 2
  },
  {
    "code": "53-7061.00",
    "name": "Cleaners of Vehicles and Equipment",
    "description": "Wash or otherwise clean vehicles, machinery, and other equipment. Use such materials as water, cleaning agents, brushes, cloths, and hoses.",
    "hourlyIncome": 17,
    "annualIncome": 36290,
    "careerGrowth": 4.4,
    "jobZone": 2
  },
  {
    "code": "53-7062.00",
    "name": "Laborers and Freight, Stock, and Material Movers, Hand",
    "description": "Manually move freight, stock, luggage, or other materials, or perform other general labor. Includes all manual laborers not elsewhere classified.",
    "hourlyIncome": 20,
    "annualIncome": 41420,
    "careerGrowth": 4.2,
    "jobZone": 2
  },
  {
    "code": "53-7062.04",
    "name": "Recycling and Reclamation Workers",
    "description": "Prepare and sort materials or products for recycling. Identify and remove hazardous substances. Dismantle components of products such as appliances.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": 2
  },
  {
    "code": "53-7063.00",
    "name": "Machine Feeders and Offbearers",
    "description": "Feed materials into or remove materials from machines or equipment that is automatic or tended by other workers.",
    "hourlyIncome": 21,
    "annualIncome": 42840,
    "careerGrowth": -12.7,
    "jobZone": 2
  },
  {
    "code": "53-7064.00",
    "name": "Packers and Packagers, Hand",
    "description": "Pack or package by hand a wide variety of products and materials.",
    "hourlyIncome": 18,
    "annualIncome": 36600,
    "careerGrowth": -4.2,
    "jobZone": 2
  },
  {
    "code": "53-7065.00",
    "name": "Stockers and Order Fillers",
    "description": "Receive, store, and issue merchandise, materials, equipment, and other items from stockroom, warehouse, or storage yard to fill shelves, racks, tables, or customers' orders. May operate power equipment to fill orders. May mark prices on merchandise and set up sales displays.",
    "hourlyIncome": 19,
    "annualIncome": 38910,
    "careerGrowth": 5.9,
    "jobZone": 2
  },
  {
    "code": "53-7071.00",
    "name": "Gas Compressor and Gas Pumping Station Operators",
    "description": "Operate steam-, gas-, electric motor-, or internal combustion-engine driven compressors. Transmit, compress, or recover gases, such as butane, nitrogen, hydrogen, and natural gas.",
    "hourlyIncome": 35,
    "annualIncome": 71750,
    "careerGrowth": 1.2,
    "jobZone": 2
  },
  {
    "code": "53-7072.00",
    "name": "Pump Operators, Except Wellhead Pumpers",
    "description": "Tend, control, or operate power-driven, stationary, or portable pumps and manifold systems to transfer gases, oil, other liquids, slurries, or powdered materials to and from various vessels and processes.",
    "hourlyIncome": 30,
    "annualIncome": 61950,
    "careerGrowth": 5,
    "jobZone": 2
  },
  {
    "code": "53-7073.00",
    "name": "Wellhead Pumpers",
    "description": "Operate power pumps and auxiliary equipment to produce flow of oil or gas from wells in oil field.",
    "hourlyIncome": 34,
    "annualIncome": 70070,
    "careerGrowth": -2,
    "jobZone": 2
  },
  {
    "code": "53-7081.00",
    "name": "Refuse and Recyclable Material Collectors",
    "description": "Collect and dump refuse or recyclable materials from containers into truck. May drive truck.",
    "hourlyIncome": 25,
    "annualIncome": 51210,
    "careerGrowth": 2.3,
    "jobZone": 2
  },
  {
    "code": "53-7121.00",
    "name": "Tank Car, Truck, and Ship Loaders",
    "description": "Load and unload chemicals and bulk solids, such as coal, sand, and grain, into or from tank cars, trucks, or ships, using material moving equipment. May perform a variety of other tasks relating to shipment of products. May gauge or sample shipping tanks and test them for leaks.",
    "hourlyIncome": 29,
    "annualIncome": 60010,
    "careerGrowth": 3.9,
    "jobZone": 2
  },
  {
    "code": "53-7199.00",
    "name": "Material Moving Workers, All Other",
    "description": "All material moving workers not listed separately.",
    "hourlyIncome": 22,
    "annualIncome": 46650,
    "careerGrowth": 4.4,
    "jobZone": null
  },
  {
    "code": "55-1011.00",
    "name": "Air Crew Officers",
    "description": "Perform and direct in-flight duties to ensure the successful completion of combat, reconnaissance, transport, and search and rescue missions. Duties include operating aircraft communications and radar equipment, such as establishing satellite linkages and jamming enemy communications capabilities; operating aircraft weapons and defensive systems; conducting preflight, in-flight, and postflight inspections of onboard equipment; and directing cargo and personnel drops.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-1012.00",
    "name": "Aircraft Launch and Recovery Officers",
    "description": "Plan and direct the operation and maintenance of catapults, arresting gear, and associated mechanical, hydraulic, and control systems involved primarily in aircraft carrier takeoff and landing operations. Duties include supervision of readiness and safety of arresting gear, launching equipment, barricades, and visual landing aid systems; planning and coordinating the design, development, and testing of launch and recovery systems; preparing specifications for catapult and arresting gear installations; evaluating design proposals; determining handling equipment needed for new aircraft; preparing technical data and instructions for operation of landing aids; and training personnel in carrier takeoff and landing procedures.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-1013.00",
    "name": "Armored Assault Vehicle Officers",
    "description": "Direct the operation of tanks, light armor, and amphibious assault vehicle units during combat situations on land or in aquatic environments. Duties include directing crew members in the operation of targeting and firing systems; coordinating the operation of advanced onboard communications and navigation equipment; directing the transport of personnel and equipment during combat; formulating and implementing battle plans, including the tactical employment of armored vehicle units; and coordinating with infantry, artillery, and air support units.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-1014.00",
    "name": "Artillery and Missile Officers",
    "description": "Manage personnel and weapons operations to destroy enemy positions, aircraft, and vessels. Duties include planning, targeting, and coordinating the tactical deployment of field artillery and air defense artillery missile systems units; directing the establishment and operation of fire control communications systems; targeting and launching intercontinental ballistic missiles; directing the storage and handling of nuclear munitions and components; overseeing security of weapons storage and launch facilities; and managing maintenance of weapons systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-1015.00",
    "name": "Command and Control Center Officers",
    "description": "Manage the operation of communications, detection, and weapons systems essential for controlling air, ground, and naval operations. Duties include managing critical communication links between air, naval, and ground forces; formulating and implementing emergency plans for natural and wartime disasters; coordinating emergency response teams and agencies; evaluating command center information and need for high-level military and government reporting; managing the operation of surveillance and detection systems; providing technical information and advice on capabilities and operational readiness; and directing operation of weapons targeting, firing, and launch computer systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-1016.00",
    "name": "Infantry Officers",
    "description": "Direct, train, and lead infantry units in ground combat operations. Duties include directing deployment of infantry weapons, vehicles, and equipment; directing location, construction, and camouflage of infantry positions and equipment; managing field communications operations; coordinating with armor, artillery, and air support units; performing strategic and tactical planning, including battle plan development; and leading basic reconnaissance operations.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-1017.00",
    "name": "Special Forces Officers",
    "description": "Lead elite teams that implement unconventional operations by air, land, or sea during combat or peacetime. These activities include offensive raids, demolitions, reconnaissance, search and rescue, and counterterrorism. In addition to their combat training, special forces officers often have specialized training in swimming, diving, parachuting, survival, emergency medicine, and foreign languages. Duties include directing advanced reconnaissance operations and evaluating intelligence information; recruiting, training, and equipping friendly forces; leading raids and invasions on enemy territories; training personnel to implement individual missions and contingency plans; performing strategic and tactical planning for politically sensitive missions; and operating sophisticated communications equipment.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-1019.00",
    "name": "Military Officer Special and Tactical Operations Leaders, All Other",
    "description": "All military officer special and tactical operations leaders not listed separately.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-2011.00",
    "name": "First-Line Supervisors of Air Crew Members",
    "description": "Supervise and coordinate the activities of air crew members. Supervisors may also perform the same activities as the workers they supervise.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-2012.00",
    "name": "First-Line Supervisors of Weapons Specialists/Crew Members",
    "description": "Supervise and coordinate the activities of weapons specialists/crew members. Supervisors may also perform the same activities as the workers they supervise.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-2013.00",
    "name": "First-Line Supervisors of All Other Tactical Operations Specialists",
    "description": "Supervise and coordinate the activities of all other tactical operations specialists not classified separately above. Supervisors may also perform the same activities as the workers they supervise.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-3011.00",
    "name": "Air Crew Members",
    "description": "Perform in-flight duties to ensure the successful completion of combat, reconnaissance, transport, and search and rescue missions. Duties include operating aircraft communications and detection equipment, including establishing satellite linkages and jamming enemy communications capabilities; conducting preflight, in-flight, and postflight inspections of onboard equipment; operating and maintaining aircraft weapons and defensive systems; operating and maintaining aircraft in-flight refueling systems; executing aircraft safety and emergency procedures; computing and verifying passenger, cargo, fuel, and emergency and special equipment weight and balance data; and conducting cargo and personnel drops.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-3012.00",
    "name": "Aircraft Launch and Recovery Specialists",
    "description": "Operate and maintain catapults, arresting gear, and associated mechanical, hydraulic, and control systems involved primarily in aircraft carrier takeoff and landing operations. Duties include installing and maintaining visual landing aids; testing and maintaining launch and recovery equipment using electric and mechanical test equipment and hand tools; activating airfield arresting systems, such as crash barriers and cables, during emergency landing situations; directing aircraft launch and recovery operations using hand or light signals; and maintaining logs of airplane launches, recoveries, and equipment maintenance.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-3013.00",
    "name": "Armored Assault Vehicle Crew Members",
    "description": "Operate tanks, light armor, and amphibious assault vehicles during combat situations on land or in aquatic environments. Duties include driving armored vehicles that require specialized training; operating and maintaining targeting and firing systems; operating and maintaining advanced onboard communications and navigation equipment; transporting personnel and equipment in a combat environment; and operating and maintaining auxiliary weapons, including machine guns and grenade launchers.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-3014.00",
    "name": "Artillery and Missile Crew Members",
    "description": "Target, fire, and maintain weapons used to destroy enemy positions, aircraft, and vessels. Field artillery crew members predominantly use guns, cannons, and howitzers in ground combat operations, while air defense artillery crew members predominantly use missiles and rockets. Naval artillery crew members predominantly use torpedoes and missiles launched from a ship or submarine. Duties include testing, inspecting, and storing ammunition, missiles, and torpedoes; conducting preventive and routine maintenance on weapons and related equipment; establishing and maintaining radio and wire communications; and operating weapons targeting, firing, and launch computer systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-3015.00",
    "name": "Command and Control Center Specialists",
    "description": "Operate and monitor communications, detection, and weapons systems essential for controlling air, ground, and naval operations. Duties include maintaining and relaying critical communications between air, naval, and ground forces; implementing emergency plans for natural and wartime disasters; relaying command center information to high-level military and government decisionmakers; monitoring surveillance and detection systems, such as air defense; interpreting and evaluating tactical situations and making recommendations to superiors; and operating weapons targeting, firing, and launch computer systems.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-3016.00",
    "name": "Infantry",
    "description": "Operate weapons and equipment in ground combat operations. Duties include operating and maintaining weapons, such as rifles, machine guns, mortars, and hand grenades; locating, constructing, and camouflaging infantry positions and equipment; evaluating terrain and recording topographical information; operating and maintaining field communications equipment; assessing need for and directing supporting fire; placing explosives and performing minesweeping activities on land; and participating in basic reconnaissance operations.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-3018.00",
    "name": "Special Forces",
    "description": "Implement unconventional operations by air, land, or sea during combat or peacetime as members of elite teams. These activities include offensive raids, demolitions, reconnaissance, search and rescue, and counterterrorism. In addition to their combat training, special forces members often have specialized training in swimming, diving, parachuting, survival, emergency medicine, and foreign languages. Duties include conducting advanced reconnaissance operations and collecting intelligence information; recruiting, training, and equipping friendly forces; conducting raids and invasions on enemy territories; laying and detonating explosives for demolition targets; locating, identifying, defusing, and disposing of ordnance; and operating and maintaining sophisticated communications equipment.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  },
  {
    "code": "55-3019.00",
    "name": "Military Enlisted Tactical Operations and Air/Weapons Specialists and Crew Members, All Other",
    "description": "All military enlisted tactical operations and air/weapons specialists and crewmembers not listed separately.",
    "hourlyIncome": null,
    "annualIncome": null,
    "careerGrowth": null,
    "jobZone": null
  }
]